import { useState, useEffect, useRef } from "react";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://lwwygijjslkezxpycpgn.supabase.co",
  "sb_publishable_Ep4nBdwjVDJRYEPx3XTv2Q_DEXrwFJb"
);
const SUPABASE_ANON = "sb_publishable_Ep4nBdwjVDJRYEPx3XTv2Q_DEXrwFJb";

// Upload base64 image to Supabase Storage in expert's own folder
const uploadImage = async (base64Data, fileName, expertPhone, expertName) => {
  try {
    if(!base64Data || !base64Data.startsWith("data:")) return base64Data;
    const res = await fetch(base64Data);
    const blob = await res.blob();
    const file = new File([blob], fileName, {type:"image/jpeg"});
    // Create folder: experts/[phone]_[name]/[filename]
    const folderName = `${expertPhone}_${(expertName||"expert").replace(/\s+/g,"_")}`;
    const path = `experts/${folderName}/${fileName}`;
    const { data, error } = await supabase.storage
      .from("documents")
      .upload(path, file, {upsert:true, contentType:"image/jpeg"});
    if(error) { console.error("Storage error:", error); return base64Data; }
    const { data: urlData } = supabase.storage.from("documents").getPublicUrl(path);
    return urlData.publicUrl;
  } catch(e) {
    console.error("Upload failed:", e);
    return base64Data;
  }
};

// Auto-assign nearest available expert (Rapido/Urban Company style)
const autoAssignExpert = async (booking) => {
  // Assignment now happens on the SERVER (assign-expert), because the browser
  // can no longer read the professionals table (RLS). The server uses the
  // service role to find and assign the best available expert.
  try {
    const res = await fetch("https://lwwygijjslkezxpycpgn.supabase.co/functions/v1/assign-expert", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (SUPABASE_ANON || "sb_publishable_Ep4nBdwjVDJRYEPx3XTv2Q_DEXrwFJb"),
      },
      body: JSON.stringify({ booking_id: booking.id }),
    });
    const r = await res.json();
    return r?.expert || null;
  } catch(e) { console.error("autoAssign error:", e); return null; }
};


const STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
  *{margin:0;padding:0;box-sizing:border-box;-webkit-tap-highlight-color:transparent}
  body{font-family:'Plus Jakarta Sans',sans-serif;background:#fff}
  ::-webkit-scrollbar{display:none}
  input,textarea,button{font-family:'Plus Jakarta Sans',sans-serif}
  @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes slideUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
  @keyframes popIn{0%{transform:scale(.8);opacity:0}100%{transform:scale(1);opacity:1}}
  .fu{animation:fadeUp .4s cubic-bezier(.16,1,.3,1) both}
  .su{animation:slideUp .35s cubic-bezier(.16,1,.3,1) both}
  .pop{animation:popIn .3s cubic-bezier(.34,1.56,.64,1) both}
  .tap:active{transform:scale(.97);transition:transform .1s}
`;

const D = {
  navy:"#0F2D5C", navyL:"#1A4080", navyXL:"#E8EEF8",
  orange:"#FF5722", green:"#00875A", red:"#DC2626",
  bg:"#F6F7F9", white:"#FFFFFF", ink:"#0D0D0D",
  sub:"#545454", muted:"#9A9A9A", border:"#E8E8E8",
};

const SERVICES = [
  {id:1,en:"Salon & Beauty",hi:"सैलून & ब्यूटी",icon:"💄",accent:"#F43F5E",bg:"#FFF0F3",sub:"Haircut · Facial · Waxing · Makeup",
   items:[{n:"Haircut",p:199,t:"30 min",r:4.8},{n:"Facial",p:599,t:"60 min",r:4.9},{n:"Waxing",p:399,t:"45 min",r:4.7},{n:"Manicure",p:299,t:"40 min",r:4.6},{n:"Pedicure",p:349,t:"45 min",r:4.7},{n:"Makeup",p:999,t:"90 min",r:4.9}]},
  {id:2,en:"Cleaning",hi:"सफाई",icon:"🧹",accent:"#0EA5E9",bg:"#F0F9FF",sub:"Home · Sofa · Kitchen · Bathroom",
   items:[{n:"Home Cleaning",p:799,t:"3 hrs",r:4.8},{n:"Sofa Cleaning",p:499,t:"2 hrs",r:4.7},{n:"Kitchen Deep Clean",p:899,t:"3 hrs",r:4.9},{n:"Bathroom Clean",p:399,t:"1 hr",r:4.6}]},
  {id:3,en:"Electrician",hi:"बिजली मिस्त्री",icon:"⚡",accent:"#F59E0B",bg:"#FFFBEB",sub:"Fan · AC · Switchboard · Wiring",
   items:[{n:"Fan Installation",p:349,t:"1 hr",r:4.7},{n:"AC Service",p:699,t:"2 hrs",r:4.8},{n:"Switch Board",p:249,t:"30 min",r:4.6},{n:"Wiring",p:499,t:"2 hrs",r:4.5}]},
  {id:4,en:"Plumbing",hi:"प्लंबिंग",icon:"🔧",accent:"#0891B2",bg:"#ECFEFF",sub:"Tap · Pipe · Toilet · Water Pump",
   items:[{n:"Tap Repair",p:299,t:"30 min",r:4.7},{n:"Pipe Leak Fix",p:399,t:"1 hr",r:4.8},{n:"Toilet Repair",p:349,t:"1 hr",r:4.6},{n:"Water Pump",p:599,t:"2 hrs",r:4.7}]},
  {id:5,en:"AC Service",hi:"AC सर्विस",icon:"❄️",accent:"#06B6D4",bg:"#ECFEFF",sub:"Deep Clean · Gas Refill · Installation",
   items:[{n:"AC Deep Clean",p:799,t:"2 hrs",r:4.9},{n:"Gas Refill",p:1299,t:"2 hrs",r:4.8},{n:"AC Installation",p:1499,t:"3 hrs",r:4.7},{n:"AC Repair",p:699,t:"2 hrs",r:4.6}]},
  {id:6,en:"Carpenter",hi:"बढ़ई",icon:"🪚",accent:"#92400E",bg:"#FEF3C7",sub:"Furniture · Door · Cabinet · Assembly",
   items:[{n:"Furniture Repair",p:399,t:"2 hrs",r:4.6},{n:"Door Fix",p:299,t:"1 hr",r:4.5},{n:"Cabinet Install",p:599,t:"3 hrs",r:4.7}]},
  {id:7,en:"Pest Control",hi:"कीट नियंत्रण",icon:"🐛",accent:"#065F46",bg:"#ECFDF5",sub:"Cockroach · Termite · Rodent · Mosquito",
   items:[{n:"Cockroach Control",p:599,t:"1 hr",r:4.8},{n:"Termite Control",p:1299,t:"2 hrs",r:4.9},{n:"Mosquito Control",p:499,t:"1 hr",r:4.7}]},
  {id:8,en:"Painting",hi:"पेंटिंग",icon:"🎨",accent:"#7C3AED",bg:"#F5F3FF",sub:"Room · Full Home · Texture · Waterproof",
   items:[{n:"Room Painting",p:1999,t:"1 day",r:4.8},{n:"Full Home Painting",p:4999,t:"3 days",r:4.9},{n:"Waterproofing",p:2999,t:"2 days",r:4.7}]},
];

const AREAS = ["Gomti Nagar","Hazratganj","Aliganj","Indira Nagar","Vikas Nagar","Alambagh","Chinhat","Mahanagar","Rajajipuram","Kalyanpur","Jankipuram","Faizabad Road","Kursi Road","Telibagh","Sultanpur Road","Sushant Golf City","Eldeco","Vrindavan Yojana","Sarojini Nagar","Charbagh","Aminabad","Chowk","Narhi","Nishatganj","Thakurganj"];

const Spinner = () => (
  <div style={{width:20,height:20,border:"3px solid rgba(255,255,255,.3)",borderTopColor:"#fff",borderRadius:"50%",animation:"spin .7s linear infinite"}}/>
);

const Av = ({l,s=40,bg=D.navy}) => (
  <div style={{width:s,height:s,borderRadius:"50%",background:bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:s*.38,fontWeight:800,color:"white",flexShrink:0}}>
    {l}
  </div>
);

const Stars = ({r,s=11}) => (
  <span style={{display:"inline-flex",alignItems:"center",gap:3}}>
    <span style={{color:"#FBBF24",fontSize:s+1}}>★</span>
    <span style={{fontSize:s,fontWeight:700,color:D.ink}}>{r}</span>
  </span>
);

const StatusPill = ({status}) => {
  const m={
    confirmed:{bg:"#DCFCE7",c:"#15803D",t:"Confirmed"},
    "in-progress":{bg:"#FEF9C3",c:"#A16207",t:"On the way"},
    pending:{bg:"#F1F5F9",c:"#475569",t:"Scheduled"},
    completed:{bg:"#EFF6FF",c:"#1D4ED8",t:"Completed"},
    "awaiting-confirmation":{bg:"#FEF3C7",c:"#B45309",t:"Awaiting your confirmation"},
    cancelled:{bg:"#FEE2E2",c:"#DC2626",t:"Cancelled"},
  };
  const s=m[status]||m.pending;
  return <span style={{background:s.bg,color:s.c,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{s.t}</span>;
};

const HR = () => <div style={{height:1,background:D.border}}/>;

const Nav = ({tabs,active,set}) => (
  <div style={{position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",width:"100%",maxWidth:430,background:"rgba(255,255,255,.97)",backdropFilter:"blur(20px)",borderTop:`1px solid ${D.border}`,display:"flex",zIndex:999,paddingBottom:6,boxShadow:"0 -4px 24px rgba(0,0,0,.06)"}}>
    {tabs.map(t=>{
      const on=active===t.id;
      return(
        <button key={t.id} onClick={()=>set(t.id)} className="tap"
          style={{flex:1,border:"none",background:"none",cursor:"pointer",padding:"10px 4px 4px",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
          <div style={{width:40,height:32,borderRadius:12,background:on?D.navyXL:"transparent",display:"flex",alignItems:"center",justifyContent:"center",transition:"background .2s"}}>
            <span style={{fontSize:19}}>{t.icon}</span>
          </div>
          <span style={{fontSize:10,fontWeight:on?800:500,color:on?D.navy:D.muted}}>{t.lbl}</span>
        </button>
      );
    })}
  </div>
);

const Logo = ({size=40,white=false}) => (
  <svg width={size} height={size} viewBox="0 0 56 56" fill="none">
    <rect width="56" height="56" rx="14" fill={white?"rgba(255,255,255,.15)":D.navy}/>
    <path d="M8 30L28 10l20 20H8z" fill="#FBBF24"/>
    <rect x="14" y="30" width="28" height="18" rx="3" fill="white" opacity=".95"/>
    <rect x="22" y="36" width="12" height="12" rx="2" fill={white?"rgba(255,255,255,.3)":D.navy}/>
    <rect x="14" y="32" width="6" height="6" rx="1" fill="#BFDBFE"/>
    <rect x="36" y="32" width="6" height="6" rx="1" fill="#BFDBFE"/>
    <rect x="36" y="16" width="5" height="9" rx="1.5" fill="#FBBF24"/>
    <circle cx="29" cy="42" r="1.2" fill="#FBBF24"/>
  </svg>
);

const Brand = ({white=false,sm=false}) => (
  <div style={{display:"flex",alignItems:"center",gap:10}}>
    <Logo size={sm?34:44} white={white}/>
    <div>
      <div style={{fontSize:sm?17:22,fontWeight:900,color:white?"#fff":D.navy,letterSpacing:-.5,lineHeight:1}}>GharPe</div>
      <div style={{fontSize:sm?9:11,color:white?"rgba(255,255,255,.55)":D.muted,letterSpacing:2,textTransform:"uppercase",marginTop:1}}>घर पे · Lucknow</div>
    </div>
  </div>
);

// ── LOGIN WITH FIXED OTP AUTO-JUMP ──────────────
// ══════════════════════════════════════════════════
//  MULTI-ROLE LOGIN — Customer | Expert | Admin
// ══════════════════════════════════════════════════
// ══════════════════════════════════════════════════
//  LIVE SELFIE CAMERA — WebRTC front camera
// ══════════════════════════════════════════════════
const LiveSelfieCamera = ({onCapture}) => {
  const videoRef   = useRef(null);
  const canvasRef  = useRef(null);
  const streamRef  = useRef(null);
  const [active,setActive]       = useState(false);
  const [error,setError]         = useState("");
  const [countdown,setCountdown] = useState(0);
  const [flash,setFlash]         = useState(false);
  const [ready,setReady]         = useState(false);

  const startCamera = async () => {
    setError("");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video:{ facingMode:"user", width:{ideal:640}, height:{ideal:480} },
        audio:false
      });
      streamRef.current = stream;
      setActive(true);
      // Wait for next render then attach stream
      setTimeout(()=>{
        if(videoRef.current){
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = ()=>{
            videoRef.current.play();
            setReady(true);
          };
        }
      },100);
    } catch(e){
      if(e.name==="NotAllowedError") setError("Camera permission denied. Please allow camera access in your browser settings.");
      else if(e.name==="NotFoundError") setError("No camera found on this device.");
      else setError("Camera error: "+e.message);
    }
  };

  const stopCamera = () => {
    if(streamRef.current){ streamRef.current.getTracks().forEach(t=>t.stop()); streamRef.current=null; }
    setActive(false); setReady(false); setCountdown(0);
  };

  const capture = () => {
    if(!ready){ alert("Camera not ready yet, please wait..."); return; }
    setCountdown(3);
    let count=3;
    const timer = setInterval(()=>{
      count--;
      setCountdown(count);
      if(count===0){
        clearInterval(timer);
        setFlash(true);
        setTimeout(()=>{
          setFlash(false);
          const video = videoRef.current;
          const canvas = canvasRef.current;
          if(video&&canvas){
            const w = video.videoWidth||640;
            const h = video.videoHeight||480;
            canvas.width=w; canvas.height=h;
            const ctx = canvas.getContext("2d");
            ctx.save();
            ctx.translate(w,0);
            ctx.scale(-1,1);
            ctx.drawImage(video,0,0,w,h);
            ctx.restore();
            const img = canvas.toDataURL("image/jpeg",0.75);
            stopCamera();
            onCapture(img);
          }
        },300);
      }
    },1000);
  };

  useEffect(()=>()=>stopCamera(),[]);

  // ── NOT STARTED YET ────────────────────────────
  if(!active) return (
    <div>
      {error&&(
        <div style={{background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:12,padding:"12px 14px",marginBottom:12}}>
          <div style={{color:"#DC2626",fontSize:13,fontWeight:600}}>⚠️ {error}</div>
          <div style={{color:"#DC2626",fontSize:11,marginTop:4}}>Try: Browser settings → Allow camera for this site → Refresh</div>
        </div>
      )}
      <button onClick={startCamera}
        style={{width:"100%",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:16,padding:0,cursor:"pointer",overflow:"hidden"}}>
        {/* Placeholder image area */}
        <div style={{height:200,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:10,background:"linear-gradient(135deg,#064e3b,#065F46)"}}>
          <div style={{width:80,height:80,borderRadius:"50%",border:"3px dashed rgba(255,255,255,.4)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36}}>🤳</div>
          <div style={{color:"white",fontWeight:800,fontSize:16}}>Open Live Camera</div>
          <div style={{color:"rgba(255,255,255,.65)",fontSize:12}}>Tap here to open your front camera</div>
          <div style={{background:"rgba(255,255,255,.15)",borderRadius:20,padding:"6px 16px",marginTop:4}}>
            <span style={{color:"white",fontSize:11,fontWeight:600}}>📷 No gallery — camera only</span>
          </div>
        </div>
      </button>
    </div>
  );

  // ── CAMERA ACTIVE ──────────────────────────────
  return (
    <div>
      <div style={{position:"relative",borderRadius:18,overflow:"hidden",background:"#000",marginBottom:12}}>
        {/* Live video */}
        <video ref={videoRef} autoPlay playsInline muted
          style={{width:"100%",height:260,objectFit:"cover",display:"block",transform:"scaleX(-1)"}}/>

        {/* Loading overlay before video is ready */}
        {!ready&&(
          <div style={{position:"absolute",inset:0,background:"#000",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:12}}>
            <div style={{width:40,height:40,border:"3px solid rgba(255,255,255,.2)",borderTop:"3px solid white",borderRadius:"50%",animation:"spin 1s linear infinite"}}/>
            <div style={{color:"white",fontSize:13}}>Starting camera...</div>
          </div>
        )}

        {/* Flash */}
        {flash&&<div style={{position:"absolute",inset:0,background:"white",zIndex:10}}/>}

        {/* Countdown */}
        {countdown>0&&(
          <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,.5)",zIndex:5}}>
            <div style={{color:"white",fontSize:90,fontWeight:900,textShadow:"0 0 30px rgba(255,255,255,.5)"}}>{countdown}</div>
          </div>
        )}

        {/* Face oval guide */}
        {ready&&countdown===0&&(
          <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none"}}>
            <div style={{width:150,height:190,border:"3px solid rgba(255,255,255,.8)",borderRadius:"50%",boxShadow:"0 0 0 9999px rgba(0,0,0,.25)"}}/>
          </div>
        )}

        {/* Top bar */}
        <div style={{position:"absolute",top:0,left:0,right:0,padding:"10px 14px",display:"flex",justifyContent:"space-between",background:"linear-gradient(to bottom,rgba(0,0,0,.6),transparent)"}}>
          <span style={{color:"white",fontSize:11,fontWeight:600}}>🔴 Live Camera</span>
          <button onClick={stopCamera} style={{background:"rgba(0,0,0,.4)",border:"none",borderRadius:8,padding:"4px 10px",color:"white",fontSize:12,cursor:"pointer",fontWeight:600}}>✕ Cancel</button>
        </div>

        {/* Instruction at bottom */}
        {ready&&countdown===0&&(
          <div style={{position:"absolute",bottom:0,left:0,right:0,padding:"10px",background:"linear-gradient(to top,rgba(0,0,0,.7),transparent)",textAlign:"center"}}>
            <span style={{color:"white",fontSize:11}}>Position face in oval · Good lighting · Look at camera</span>
          </div>
        )}
      </div>

      <canvas ref={canvasRef} style={{display:"none"}}/>

      {/* Capture button */}
      <div style={{display:"flex",gap:10}}>
        <button onClick={stopCamera}
          style={{flex:1,padding:"13px",background:"#F4F6FA",border:"1px solid #E8E8E8",borderRadius:14,color:"#545454",fontWeight:700,fontSize:13,cursor:"pointer"}}>
          ✕ Cancel
        </button>
        <button onClick={capture} disabled={!ready||countdown>0}
          style={{flex:2,padding:"13px",background:ready?"linear-gradient(135deg,#065F46,#047857)":"#D1D5DB",border:"none",borderRadius:14,color:"white",fontWeight:800,fontSize:15,cursor:ready?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:ready?"0 6px 20px rgba(6,95,70,.35)":"none"}}>
          {countdown>0?`📸 ${countdown}...`:ready?"📸 Take Selfie":"⏳ Loading..."}
        </button>
      </div>
    </div>
  );
};


const Login = ({onLogin,lang,setLang}) => {
  const [role,setRole]     = useState(null);       // null | customer | expert | admin
  const [step,setStep]     = useState("role");     // role | phone | otp | register
  const [phone,setPhone]   = useState("");
  const [otp,setOtp]       = useState(["","","","","",""]);
  const [err,setErr]        = useState("");
  const [loading,setLoad]  = useState(false);
  const [cd,setCd]          = useState(0);
  const [regStep,setRegStep]= useState(1);         // expert registration step
  const [regData,setRegData]= useState({
    name:"", dob:"", address:"", city:"Lucknow", state:"Uttar Pradesh",
    pin:"", languages:[], experience:"", skills:[], aadhaar:"", pan:"",
    bankAccount:"", ifsc:"", bankName:""
  });
  const otpRefs = useRef([]);
  const L = lang==="en";

  useEffect(()=>{
    if(cd>0){const t=setTimeout(()=>setCd(c=>c-1),1000);return()=>clearTimeout(t);}
  },[cd]);

  // Admin is removed from public login — accessed only via /manage route
  const ROLES = [
    { id:"customer", label:"Customer", labelHi:"कस्टमर", icon:"🏠",
      desc:"Book home services", descHi:"होम सर्विस बुक करें",
      color:"#0F2D5C", light:"#E8EEF8", grad:"linear-gradient(135deg,#0F2D5C,#1A4080)" },
    { id:"expert",   label:"GharPe Expert", labelHi:"एक्सपर्ट", icon:"🔧",
      desc:"Earn by providing services", descHi:"सेवा देकर कमाएं",
      color:"#065F46", light:"#ECFDF5", grad:"linear-gradient(135deg,#065F46,#047857)" },
  ];

  const sendOTP = async () => {
    setErr(""); setLoad(true);
    try {
      // Supabase will use Twilio Verify to send OTP
      const { error } = await supabase.auth.signInWithOtp({
        phone: "+91" + phone,
      });
      if(error) {
        console.error("OTP Error:", error.message);
        if(error.message?.includes("rate limit")||error.message?.includes("429")) {
          setErr("Too many requests. Please wait 60 seconds.");
          setLoad(false); return;
        }
        if(error.message?.includes("invalid")||error.message?.includes("not a valid")) {
          setErr("Invalid phone number format.");
          setLoad(false); return;
        }
        // Other errors still proceed — OTP may still arrive
      }
      setStep("otp"); setCd(60);
      setTimeout(()=>otpRefs.current[0]?.focus(), 300);
    } catch(e) {
      console.error("sendOTP catch:", e);
      setStep("otp"); setCd(60);
      setTimeout(()=>otpRefs.current[0]?.focus(), 300);
    }
    setLoad(false);
  };

  const verifyOTP = async () => {
    setErr(""); setLoad(true);
    const entered = otp.join("").trim();
    if(entered.length < 6) {
      setErr("Please enter all 6 digits.");
      setLoad(false); return;
    }

    const handleExpertLogin = async (expertPhone) => {
      try {
        const { data: pro } = await supabase.from("professionals")
          .select("*").eq("phone", expertPhone).single();
        if(pro && pro.name) {
          onLogin({
            phone: expertPhone, name: pro.name, role: "expert",
            area: pro.city||pro.area||"Lucknow",
            verification_status: pro.verification_status||"pending",
            registered_at: pro.registered_at,
            admin_note: pro.admin_note,
            rejected_reason: pro.rejected_reason,
            more_docs_reason: pro.more_docs_reason,
          });
          return;
        }
      } catch(e) {}
      try {
        const { data: user } = await supabase.from("users")
          .select("*").eq("phone", expertPhone).single();
        if(user && user.name && user.role==="expert") {
          onLogin({...user, phone:expertPhone}); return;
        }
      } catch(e) {}
      setStep("register");
    };

    // Try multiple verification strategies for Twilio Verify compatibility
    let verified = false;
    let lastError = null;

    // Strategy 1: Standard +91 prefix with sms type
    try {
      const { data, error } = await supabase.auth.verifyOtp({
        phone: "+91" + phone, token: entered, type: "sms",
      });
      if(!error) { verified = true; }
      else lastError = error;
    } catch(e) { lastError = e; }

    // Strategy 2: Without country code prefix
    if(!verified) {
      try {
        const { data, error } = await supabase.auth.verifyOtp({
          phone: phone, token: entered, type: "sms",
        });
        if(!error) { verified = true; }
        else lastError = error;
      } catch(e) { lastError = e; }
    }

    // Strategy 3: phone_change type (some Twilio Verify configs need this)
    if(!verified) {
      try {
        const { data, error } = await supabase.auth.verifyOtp({
          phone: "+91" + phone, token: entered, type: "phone_change",
        });
        if(!error) { verified = true; }
      } catch(e) {}
    }

    if(verified) {
      await handleVerifiedLogin(phone, role, handleExpertLogin);
    } else {
      const errMsg = (lastError?.message || "").toLowerCase();
      if(errMsg.includes("expired")) {
        setErr("OTP expired. Please request a new one.");
      } else if(errMsg.includes("rate") || errMsg.includes("limit")) {
        setErr("Too many attempts. Please wait 10 minutes.");
      } else {
        setErr("Incorrect OTP. Please check and try again.");
      }
      setOtp(["","","","","",""]);
      setTimeout(()=>otpRefs.current[0]?.focus(), 100);
    }
    setLoad(false);
  };

  // ── Unified login handler — ROLE takes priority ──
  const handleVerifiedLogin = async (phone, selectedRole, handleExpertLogin) => {
    // Admin login is only via /manage route — never from here
    if(selectedRole==="expert") {
      if(handleExpertLogin) await handleExpertLogin(phone);
      return;
    }

    // Customer flow
    if(selectedRole==="customer") {
      try {
        const {data:existing} = await supabase.from("users").select("*")
          .eq("phone",phone).eq("role","customer").single();
        if(existing?.name) { onLogin({...existing,phone}); return; }
      } catch(e){}
      try {
        const {data:existing} = await supabase.from("users").select("*").eq("phone",phone).single();
        if(existing?.name && existing.role==="customer") {
          onLogin({...existing,phone}); return;
        }
        // Friendly guard: number exists under a DIFFERENT role (e.g. expert).
        if(existing?.name && existing.role && existing.role!=="customer") {
          alert("This number is registered as a "+existing.role+", not a customer. Please go back and log in as "+existing.role+".");
          return;
        }
      } catch(e){}
      // Also check the professionals table so a known expert isn't sent to customer signup.
      try {
        const {data:pro} = await supabase.from("professionals").select("name").eq("phone",phone).single();
        if(pro?.name) {
          alert("This number is registered as an expert. Please go back and log in as an expert.");
          return;
        }
      } catch(e){}
      setStep("customer_register");
      return;
    }

    // Fallback: check DB for existing user
    try {
      const {data:existing} = await supabase.from("users").select("*").eq("phone",phone).single();
      if(existing?.name) { onLogin({...existing,phone}); return; }
    } catch(e){}
    setStep("customer_register");
  };

  const handleOtp = (i, e) => {
    const v = e.target.value.replace(/\D/g,"").slice(-1);
    const n = [...otp]; n[i] = v; setOtp(n);
    if (v && i < 5) otpRefs.current[i+1]?.focus();
  };
  const handleKey = (i, e) => {
    if (e.key==="Backspace") { const n=[...otp]; n[i]=""; setOtp(n); if(i>0) otpRefs.current[i-1]?.focus(); }
    if (e.key==="Enter" && otp.join("").length>=4) verifyOTP();
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g,"").slice(0,6);
    if(pasted.length>0){ const n=["","","","","",""]; pasted.split("").forEach((ch,i)=>{n[i]=ch;}); setOtp(n); otpRefs.current[Math.min(pasted.length,5)]?.focus(); }
  };

  const selectedRole = ROLES.find(r=>r.id===role);

  // ── EXPERT REGISTRATION FORM ──────────────────
  // ── CUSTOMER REGISTRATION ──────────────────
  if(step==="customer_register") {
    return <CustomerRegisterInline phone={phone} onDone={(userData)=>onLogin(userData)} lang={lang}/>;
  }

  // ── EXPERT REGISTRATION FORM ──────────────────
  if(step==="register") return (
    <div style={{minHeight:"100vh",background:"#F4F6FA",display:"flex",flexDirection:"column"}}>
      <div style={{background:"linear-gradient(145deg,#065F46,#047857)",padding:"52px 20px 24px",borderRadius:"0 0 28px 28px"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
          <button onClick={()=>regStep>1?setRegStep(s=>s-1):setStep("otp")} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer"}}>← Back</button>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,.7)",fontSize:11,letterSpacing:1}}>STEP {regStep} OF 4</div>
            <div style={{color:"white",fontWeight:900,fontSize:17}}>
              {regStep===1?"Personal Details":regStep===2?"Skills & Experience":regStep===3?"Documents & Selfie":"Review & Submit"}
            </div>
          </div>
          <span style={{color:"rgba(255,255,255,.5)",fontSize:12}}>{regStep}/4</span>
        </div>
        <div style={{display:"flex",gap:6}}>
          {[1,2,3,4].map(i=><div key={i} style={{flex:1,height:4,borderRadius:4,background:regStep>=i?"white":"rgba(255,255,255,.25)",transition:"all .3s"}}/>)}
        </div>
      </div>

      <div style={{flex:1,padding:"20px 20px 120px",overflowY:"auto"}}>

        {/* ── STEP 1: PERSONAL DETAILS ── */}
        {regStep===1&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:17,marginBottom:4}}>Personal Information</div>
            <div style={{color:"#9A9A9A",fontSize:12,marginBottom:20}}>All fields marked * are required</div>

            {[
              {label:"Full Name *",key:"name",placeholder:"As per Aadhaar card",type:"text"},
              {label:"Mobile Number",key:"phone_display",placeholder:"+91 "+phone,type:"text",disabled:true,value:"+91 "+phone},
              {label:"Email Address",key:"email",placeholder:"example@email.com",type:"email"},
              {label:"Full Address *",key:"address",placeholder:"House no, street, area, landmark",type:"text"},
              {label:"City *",key:"city",placeholder:"e.g. Lucknow",type:"text"},
              {label:"State *",key:"state",placeholder:"e.g. Uttar Pradesh",type:"text"},
              {label:"PIN Code *",key:"pin",placeholder:"226001",type:"tel"},
            ].map(f=>(
              <div key={f.key} style={{marginBottom:14}}>
                <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>{f.label}</div>
                <input type={f.type} value={f.disabled?f.value:(regData[f.key]||"")} disabled={f.disabled}
                  onChange={e=>setRegData(d=>({...d,[f.key]:e.target.value}))}
                  placeholder={f.placeholder}
                  style={{width:"100%",padding:"13px 16px",background:f.disabled?"#F4F6FA":"white",border:`1.5px solid ${regData[f.key]?"#065F46":"#E8E8E8"}`,borderRadius:14,fontSize:14,color:f.disabled?"#9A9A9A":"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
              </div>
            ))}

            {/* Date of Birth - Calendar Picker */}
            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>Date of Birth * (Min age: 18)</div>
              <input type="date"
                max={new Date(Date.now()-18*365.25*24*3600*1000).toISOString().split("T")[0]}
                value={regData.dob||""}
                onChange={e=>setRegData(d=>({...d,dob:e.target.value}))}
                style={{width:"100%",padding:"13px 16px",background:"white",border:`1.5px solid ${regData.dob?"#065F46":"#E8E8E8"}`,borderRadius:14,fontSize:14,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
              {regData.dob&&<div style={{fontSize:11,color:"#065F46",marginTop:4,fontWeight:600}}>
                Age: {Math.floor((Date.now()-new Date(regData.dob))/(365.25*24*3600*1000))} years
              </div>}
            </div>

            {/* Gender Dropdown */}
            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>Gender *</div>
              <select value={regData.gender||""} onChange={e=>setRegData(d=>({...d,gender:e.target.value}))}
                style={{width:"100%",padding:"13px 16px",background:"white",border:`1.5px solid ${regData.gender?"#065F46":"#E8E8E8"}`,borderRadius:14,fontSize:14,color:regData.gender?"#0D0D0D":"#9A9A9A",boxSizing:"border-box",outline:"none",appearance:"none"}}>
                <option value="">Select gender</option>
                <option value="Male">👨 Male</option>
                <option value="Female">👩 Female</option>
                <option value="Other">🧑 Other</option>
                <option value="Prefer not to say">🤐 Prefer not to say</option>
              </select>
            </div>

            {/* Languages */}
            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:8}}>Languages Known *</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {["Hindi","English","Urdu","Bhojpuri","Awadhi"].map(l=>{
                  const sel=(regData.languages||[]).includes(l);
                  return <button key={l} onClick={()=>setRegData(d=>({...d,languages:sel?(d.languages||[]).filter(x=>x!==l):[...(d.languages||[]),l]}))}
                    style={{padding:"8px 16px",background:sel?"#065F46":"white",border:`1.5px solid ${sel?"#065F46":"#E8E8E8"}`,borderRadius:20,color:sel?"white":"#545454",fontWeight:600,fontSize:12,cursor:"pointer"}}>
                    {l}
                  </button>;
                })}
              </div>
            </div>
          </div>
        )}

        {/* ── STEP 2: SKILLS & EXPERIENCE ── */}
        {regStep===2&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:17,marginBottom:4}}>Skills & Experience</div>
            <div style={{color:"#9A9A9A",fontSize:12,marginBottom:20}}>Tell us about your expertise</div>

            <div style={{marginBottom:18}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:8}}>Service Categories * (Select all that apply)</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {["Salon & Beauty","Cleaning","Electrician","Plumbing","AC Service","Carpenter","Pest Control","Painting"].map(s=>{
                  const sel=(regData.skills||[]).includes(s);
                  return <button key={s} onClick={()=>setRegData(d=>({...d,skills:sel?(d.skills||[]).filter(x=>x!==s):[...(d.skills||[]),s]}))}
                    style={{padding:"8px 14px",background:sel?"#065F46":"white",border:`1.5px solid ${sel?"#065F46":"#E8E8E8"}`,borderRadius:20,color:sel?"white":"#545454",fontWeight:600,fontSize:12,cursor:"pointer"}}>
                    {s}
                  </button>;
                })}
              </div>
            </div>

            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>Years of Experience *</div>
              <select value={regData.experience||""} onChange={e=>setRegData(d=>({...d,experience:e.target.value}))}
                style={{width:"100%",padding:"13px 16px",background:"white",border:`1.5px solid ${regData.experience?"#065F46":"#E8E8E8"}`,borderRadius:14,fontSize:14,color:regData.experience?"#0D0D0D":"#9A9A9A",boxSizing:"border-box",outline:"none",appearance:"none"}}>
                <option value="">Select experience</option>
                {["Less than 1 year","1-2 years","2-3 years","3-5 years","5-7 years","7-10 years","10+ years"].map(e=><option key={e} value={e}>{e}</option>)}
              </select>
            </div>

            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>Previous Company / Work (Optional)</div>
              <input type="text" value={regData.prevCompany||""} onChange={e=>setRegData(d=>({...d,prevCompany:e.target.value}))}
                placeholder="Where did you work before?"
                style={{width:"100%",padding:"13px 16px",background:"white",border:"1.5px solid #E8E8E8",borderRadius:14,fontSize:14,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
            </div>

            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>Short Bio (Optional)</div>
              <textarea value={regData.bio||""} onChange={e=>setRegData(d=>({...d,bio:e.target.value}))}
                placeholder="Tell customers about yourself and your work experience..."
                style={{width:"100%",padding:"13px 16px",background:"white",border:"1.5px solid #E8E8E8",borderRadius:14,fontSize:14,color:"#0D0D0D",boxSizing:"border-box",outline:"none",resize:"none",height:80,lineHeight:1.5}}/>
            </div>

            <div style={{marginBottom:14}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:8}}>Service Areas * (Select areas you can serve)</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {AREAS.slice(0,12).map(a=>{
                  const sel=(regData.serviceAreas||[]).includes(a);
                  return <button key={a} onClick={()=>setRegData(d=>({...d,serviceAreas:sel?(d.serviceAreas||[]).filter(x=>x!==a):[...(d.serviceAreas||[]),a]}))}
                    style={{padding:"6px 12px",background:sel?"#065F46":"white",border:`1.5px solid ${sel?"#065F46":"#E8E8E8"}`,borderRadius:20,color:sel?"white":"#545454",fontWeight:600,fontSize:11,cursor:"pointer"}}>
                    📍 {a}
                  </button>;
                })}
              </div>
            </div>
          </div>
        )}

        {/* ── STEP 3: DOCUMENTS & SELFIE ── */}
        {regStep===3&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:17,marginBottom:4}}>Upload Documents</div>
            <div style={{color:"#9A9A9A",fontSize:12,marginBottom:20}}>All documents required for verification</div>

            {/* Live Selfie - Camera only */}
            <div style={{marginBottom:20,background:"white",borderRadius:18,padding:16,border:`2px solid ${regData.selfie?"#065F46":"#E8E8E8"}`}}>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14,marginBottom:4}}>📸 Live Selfie * <span style={{color:"#DC2626",fontSize:11}}>(Front camera only)</span></div>
              <div style={{fontSize:12,color:"#9A9A9A",marginBottom:12}}>Take a clear photo of your face. Ensure good lighting.</div>
              {regData.selfie?(
                <div style={{textAlign:"center"}}>
                  <img src={regData.selfie} alt="selfie" style={{width:160,height:160,borderRadius:"50%",objectFit:"cover",border:"4px solid #065F46",display:"block",margin:"0 auto 12px"}}/>
                  <div style={{color:"#065F46",fontWeight:700,fontSize:13,marginBottom:8}}>✅ Selfie Captured!</div>
                  <button onClick={()=>setRegData(d=>({...d,selfie:null}))}
                    style={{padding:"8px 20px",background:"#FEE2E2",border:"none",borderRadius:10,color:"#DC2626",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                    🔄 Retake
                  </button>
                </div>
              ):(
                <LiveSelfieCamera onCapture={img=>setRegData(d=>({...d,selfie:img}))}/>
              )}
            </div>

            {/* Aadhaar */}
            <div style={{marginBottom:16}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>Aadhaar Card Number * (12 digits)</div>
              <input type="tel" maxLength={12} value={regData.aadhaar||""} onChange={e=>setRegData(d=>({...d,aadhaar:e.target.value.replace(/\D/g,"")}))}
                placeholder="XXXX XXXX XXXX"
                style={{width:"100%",padding:"13px 16px",background:"white",border:`1.5px solid ${(regData.aadhaar||"").length===12?"#065F46":"#E8E8E8"}`,borderRadius:14,fontSize:16,letterSpacing:2,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
              {(regData.aadhaar||"").length>0&&(regData.aadhaar||"").length<12&&<div style={{fontSize:11,color:"#DC2626",marginTop:4}}>{12-(regData.aadhaar||"").length} more digits needed</div>}
            </div>

            {/* Aadhaar photos */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
              {[["aadhaarFront","Aadhaar Front *"],["aadhaarBack","Aadhaar Back *"]].map(([key,label])=>(
                <div key={key}>
                  <div style={{fontWeight:600,color:"#545454",fontSize:12,marginBottom:6}}>{label}</div>
                  <label style={{display:"block",cursor:"pointer"}}>
                    {regData[key]?(
                      <div style={{position:"relative"}}>
                        <img src={regData[key]} alt={label} style={{width:"100%",height:90,objectFit:"cover",borderRadius:12,border:"2px solid #065F46"}}/>
                        <div style={{position:"absolute",top:4,right:4,background:"#065F46",borderRadius:6,padding:"2px 6px"}}>
                          <span style={{color:"white",fontSize:9,fontWeight:700}}>✅</span>
                        </div>
                      </div>
                    ):(
                      <div style={{height:90,background:"#F4F6FA",border:"2px dashed #E8E8E8",borderRadius:12,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                        <span style={{fontSize:24,marginBottom:4}}>📄</span>
                        <span style={{fontSize:10,color:"#9A9A9A",fontWeight:600}}>Tap to upload</span>
                      </div>
                    )}
                    <input type="file" accept="image/*,application/pdf" style={{display:"none"}}
                      onChange={e=>{const f=e.target.files[0];if(f){
                        const reader=new FileReader();
                        reader.onload=ev=>{
                          if(f.type.includes("pdf")){setRegData(d=>({...d,[key]:"pdf:"+f.name}));return;}
                          const img=new Image();
                          img.onload=()=>{
                            const canvas=document.createElement("canvas");
                            const maxSize=600;
                            let w=img.width,h=img.height;
                            if(w>maxSize){h=h*maxSize/w;w=maxSize;}
                            canvas.width=w;canvas.height=h;
                            canvas.getContext("2d").drawImage(img,0,0,w,h);
                            setRegData(d=>({...d,[key]:canvas.toDataURL("image/jpeg",0.7)}));
                          };
                          img.src=ev.target.result;
                        };
                        reader.readAsDataURL(f);
                      }}}/>
                  </label>
                </div>
              ))}
            </div>

            {/* PAN */}
            <div style={{marginBottom:16}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:13,marginBottom:6}}>PAN Card Number * (10 characters)</div>
              <input type="text" maxLength={10} value={regData.pan||""} onChange={e=>setRegData(d=>({...d,pan:e.target.value.toUpperCase()}))}
                placeholder="ABCDE1234F"
                style={{width:"100%",padding:"13px 16px",background:"white",border:`1.5px solid ${(regData.pan||"").length===10?"#065F46":"#E8E8E8"}`,borderRadius:14,fontSize:16,letterSpacing:2,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
            </div>

            {/* PAN photo */}
            <div style={{marginBottom:16}}>
              <div style={{fontWeight:600,color:"#545454",fontSize:12,marginBottom:6}}>PAN Card Photo *</div>
              <label style={{display:"block",cursor:"pointer"}}>
                {regData.panPhoto?(
                  <div style={{position:"relative"}}>
                    <img src={regData.panPhoto} alt="PAN" style={{width:"100%",height:100,objectFit:"cover",borderRadius:14,border:"2px solid #065F46"}}/>
                    <div style={{position:"absolute",top:6,right:6,background:"#065F46",borderRadius:8,padding:"3px 8px"}}>
                      <span style={{color:"white",fontSize:10,fontWeight:700}}>✅ Uploaded</span>
                    </div>
                  </div>
                ):(
                  <div style={{height:100,background:"#F4F6FA",border:"2px dashed #E8E8E8",borderRadius:14,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
                    <span style={{fontSize:28,marginBottom:6}}>💳</span>
                    <span style={{fontSize:12,color:"#9A9A9A",fontWeight:600}}>Upload PAN Card Photo</span>
                  </div>
                )}
                <input type="file" accept="image/*,application/pdf" style={{display:"none"}}
                  onChange={e=>{const f=e.target.files[0];if(f){
                    const reader=new FileReader();
                    reader.onload=ev=>{
                      if(f.type.includes("pdf")){setRegData(d=>({...d,panPhoto:"pdf:"+f.name}));return;}
                      const img=new Image();
                      img.onload=()=>{
                        const canvas=document.createElement("canvas");
                        const maxSize=600;let w=img.width,h=img.height;
                        if(w>maxSize){h=h*maxSize/w;w=maxSize;}
                        canvas.width=w;canvas.height=h;
                        canvas.getContext("2d").drawImage(img,0,0,w,h);
                        setRegData(d=>({...d,panPhoto:canvas.toDataURL("image/jpeg",0.7)}));
                      };
                      img.src=ev.target.result;
                    };
                    reader.readAsDataURL(f);
                  }}}/>              </label>
            </div>

            {/* Bank Details */}
            <div style={{background:"#F4F6FA",borderRadius:16,padding:16,marginBottom:16}}>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14,marginBottom:12}}>🏦 Bank Account Details</div>
              {[
                {label:"Account Holder Name *",key:"bankHolder",placeholder:"As per bank records"},
                {label:"Bank Account Number *",key:"bankAccount",placeholder:"Enter account number",type:"tel"},
                {label:"Confirm Account Number *",key:"bankAccountConfirm",placeholder:"Re-enter account number",type:"tel"},
                {label:"IFSC Code *",key:"ifsc",placeholder:"e.g. HDFC0001234"},
                {label:"Bank Name *",key:"bankName",placeholder:"e.g. HDFC Bank"},
              ].map(f=>(
                <div key={f.key} style={{marginBottom:12}}>
                  <div style={{fontWeight:600,color:"#545454",fontSize:12,marginBottom:5}}>{f.label}</div>
                  <input type={f.type||"text"} value={regData[f.key]||""}
                    onChange={e=>setRegData(d=>({...d,[f.key]:e.target.value}))}
                    placeholder={f.placeholder}
                    style={{width:"100%",padding:"11px 14px",background:"white",border:`1.5px solid ${regData[f.key]?"#065F46":"#E8E8E8"}`,borderRadius:12,fontSize:13,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
                </div>
              ))}
              {/* Cancelled cheque upload */}
              <div>
                <div style={{fontWeight:600,color:"#545454",fontSize:12,marginBottom:6}}>Cancelled Cheque / Passbook (Optional)</div>
                <label style={{display:"block",cursor:"pointer"}}>
                  {regData.bankProof?(
                    <div style={{background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:10,padding:"10px 14px",display:"flex",alignItems:"center",gap:8}}>
                      <span style={{fontSize:20}}>✅</span>
                      <span style={{fontSize:12,color:"#065F46",fontWeight:600}}>Bank proof uploaded</span>
                    </div>
                  ):(
                    <div style={{background:"white",border:"2px dashed #E8E8E8",borderRadius:10,padding:"12px",textAlign:"center"}}>
                      <span style={{fontSize:20}}>📁</span>
                      <div style={{fontSize:11,color:"#9A9A9A",marginTop:4}}>Upload cancelled cheque or passbook</div>
                    </div>
                  )}
                  <input type="file" accept="image/*,application/pdf" style={{display:"none"}}
                    onChange={e=>{const f=e.target.files[0];if(f){const r=new FileReader();r.onload=ev=>setRegData(d=>({...d,bankProof:ev.target.result}));r.readAsDataURL(f);}}}/>
                </label>
              </div>
            </div>
          </div>
        )}

        {/* ── STEP 4: REVIEW & SUBMIT ── */}
        {regStep===4&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:17,marginBottom:4}}>Review & Submit</div>
            <div style={{color:"#9A9A9A",fontSize:12,marginBottom:20}}>Please verify all details before submitting</div>

            {/* Personal */}
            <div style={{background:"white",borderRadius:16,padding:16,marginBottom:14,border:"1px solid #E8E8E8"}}>
              <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:12}}>👤 Personal Details</div>
              {[["Name",regData.name],["Phone","+91 "+phone],["DOB",regData.dob],["Gender",regData.gender],["City",regData.city+" - "+regData.pin],["Languages",(regData.languages||[]).join(", ")]].map(([l,v])=>v&&(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #F4F6FA"}}>
                  <span style={{color:"#9A9A9A",fontSize:12}}>{l}</span>
                  <span style={{color:"#0D0D0D",fontSize:12,fontWeight:600,maxWidth:200,textAlign:"right"}}>{v}</span>
                </div>
              ))}
            </div>

            {/* Professional */}
            <div style={{background:"white",borderRadius:16,padding:16,marginBottom:14,border:"1px solid #E8E8E8"}}>
              <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:12}}>🛠️ Professional Details</div>
              {[["Skills",(regData.skills||[]).join(", ")],["Experience",regData.experience],["Service Areas",(regData.serviceAreas||[]).slice(0,3).join(", ")+"..."]].map(([l,v])=>v&&(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #F4F6FA"}}>
                  <span style={{color:"#9A9A9A",fontSize:12}}>{l}</span>
                  <span style={{color:"#0D0D0D",fontSize:12,fontWeight:600,maxWidth:200,textAlign:"right"}}>{v}</span>
                </div>
              ))}
            </div>

            {/* Documents */}
            <div style={{background:"white",borderRadius:16,padding:16,marginBottom:14,border:"1px solid #E8E8E8"}}>
              <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:12}}>📄 Documents</div>
              {[["Selfie",regData.selfie],["Aadhaar Front",regData.aadhaarFront],["Aadhaar Back",regData.aadhaarBack],["PAN Card",regData.panPhoto]].map(([l,v])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #F4F6FA",alignItems:"center"}}>
                  <span style={{color:"#9A9A9A",fontSize:12}}>{l}</span>
                  <span style={{color:v?"#065F46":"#DC2626",fontSize:12,fontWeight:700}}>{v?"✅ Uploaded":"❌ Missing"}</span>
                </div>
              ))}
            </div>

            {/* Bank */}
            <div style={{background:"white",borderRadius:16,padding:16,marginBottom:14,border:"1px solid #E8E8E8"}}>
              <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:12}}>🏦 Bank Details</div>
              {[["Account",regData.bankAccount?"XXXX"+regData.bankAccount.slice(-4):"—"],["IFSC",regData.ifsc||"—"],["Bank",regData.bankName||"—"]].map(([l,v])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #F4F6FA"}}>
                  <span style={{color:"#9A9A9A",fontSize:12}}>{l}</span>
                  <span style={{color:"#0D0D0D",fontSize:12,fontWeight:600}}>{v}</span>
                </div>
              ))}
            </div>

            {/* Selfie preview */}
            {regData.selfie&&(
              <div style={{background:"white",borderRadius:16,padding:16,marginBottom:14,border:"1px solid #E8E8E8",textAlign:"center"}}>
                <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:10}}>🤳 Your Live Selfie</div>
                <img src={regData.selfie} alt="selfie" style={{width:120,height:120,borderRadius:"50%",objectFit:"cover",border:"3px solid #065F46"}}/>
              </div>
            )}

            <div style={{background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:14,padding:"14px 16px"}}>
              <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:4}}>⏳ Verification Process</div>
              <div style={{fontSize:12,color:"#065F46",lineHeight:1.7}}>
                After submission:<br/>
                • Documents verified within <b>24 hours</b><br/>
                • Background check: <b>2-3 days</b><br/>
                • Final approval SMS: <b>within 48 hours</b><br/>
                • You will receive WhatsApp + SMS notifications
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Fixed bottom button */}
      <div style={{position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",width:"100%",maxWidth:430,background:"white",borderTop:"1px solid #E8E8E8",padding:"14px 20px 28px"}}>
        <button onClick={async()=>{
          // Validation per step
          if(regStep===1){
            if(!regData.name?.trim()){alert("Please enter your full name");return;}
            if(!regData.dob){alert("Please select your date of birth");return;}
            if(!regData.gender){alert("Please select your gender");return;}
            if(!regData.city?.trim()){alert("Please enter your city");return;}
            if(!regData.pin||regData.pin.length<6){alert("Please enter valid PIN code");return;}
            if(!regData.address?.trim()){alert("Please enter your address");return;}
            if(!regData.languages?.length){alert("Please select at least one language");return;}
            setRegStep(2); return;
          }
          if(regStep===2){
            if(!regData.skills?.length){alert("Please select at least one service category");return;}
            if(!regData.experience){alert("Please select your years of experience");return;}
            if(!regData.serviceAreas?.length){alert("Please select at least one service area");return;}
            setRegStep(3); return;
          }
          if(regStep===3){
            if(!regData.selfie){alert("Please take a live selfie — this is mandatory");return;}
            if(!regData.aadhaar||regData.aadhaar.length<12){alert("Please enter valid 12-digit Aadhaar number");return;}
            if(!regData.aadhaarFront){alert("Please upload Aadhaar card front photo");return;}
            if(!regData.aadhaarBack){alert("Please upload Aadhaar card back photo");return;}
            if(!regData.pan||regData.pan.length<10){alert("Please enter valid PAN number");return;}
            if(!regData.panPhoto){alert("Please upload PAN card photo");return;}
            if(!regData.bankAccount){alert("Please enter bank account number");return;}
            if(regData.bankAccount!==regData.bankAccountConfirm){alert("Bank account numbers do not match");return;}
            if(!regData.ifsc){alert("Please enter IFSC code");return;}
            if(!regData.bankName){alert("Please enter bank name");return;}
            setRegStep(4); return;
          }
          // Step 4 - Submit
          setLoad(true);
          try {
            const normalizedPhone = phone.replace(/^\+91/,"").replace(/\D/g,"").slice(-10);

            // Upload images — if storage fails, save base64 directly to DB
            const safeUpload = async (data, fileName) => {
              if(!data) return "";
              try {
                const url = await uploadImage(data, fileName, normalizedPhone, regData.name);
                // If uploadImage returned base64 back (upload failed), store empty string
                // We'll save base64 in a separate column or just mark as pending
                if(url && url.startsWith("http")) return url;
                // Storage failed — try to save as-is if small enough, else return marker
                return url || "";
              } catch(e) {
                console.error("Upload error for", fileName, e);
                return "";
              }
            };

            const [selfieUrl, aadhaarFrontUrl, aadhaarBackUrl, panUrl] = await Promise.all([
              safeUpload(regData.selfie, `selfie.jpg`),
              safeUpload(regData.aadhaarFront, `aadhaar_front.jpg`),
              safeUpload(regData.aadhaarBack, `aadhaar_back.jpg`),
              safeUpload(regData.panPhoto, `pan_card.jpg`),
            ]);

            console.log("Upload results:", { selfieUrl, aadhaarFrontUrl, aadhaarBackUrl, panUrl });

            const proData = {
              phone: normalizedPhone,
              name:regData.name, email:regData.email||"",
              dob:regData.dob, gender:regData.gender,
              address:regData.address, city:regData.city||"Lucknow",
              state:regData.state||"Uttar Pradesh", pin:regData.pin,
              category:(regData.skills||[])[0]||"General",
              skills:(regData.skills||[]).join(","),
              experience:regData.experience, languages:(regData.languages||[]).join(","),
              service_areas:(regData.serviceAreas||[]).join(","),
              bio:regData.bio||"", prev_company:regData.prevCompany||"",
              aadhaar_last4: String(regData.aadhaar||"").slice(-4),
              pan_number:regData.pan,
              bank_account:regData.bankAccount, bank_ifsc:regData.ifsc,
              bank_name:regData.bankName, bank_holder:regData.bankHolder||regData.name,
              selfie_url: selfieUrl,
              aadhaar_front_url: aadhaarFrontUrl,
              aadhaar_back_url: aadhaarBackUrl,
              pan_url: panUrl,
              bank_proof_url: regData.bankProof ? "uploaded" : "",
              // Store base64 as backup if storage upload failed
              selfie_b64: !selfieUrl && regData.selfie ? regData.selfie.slice(0,100) : null,
              docs_submitted: true,
              verification_status:"pending", status:"offline",
              rating:5.0, jobs_done:0, earnings:0,
              registered_at:new Date().toISOString(),
            };

            const {error:proErr} = await supabase.from("professionals").upsert(proData,{onConflict:"phone"});
            if(proErr) {
              console.error("Pro upsert error:", proErr);
              alert("Submission error: " + proErr.message + "\nPlease try again.");
              setLoad(false);
              return;
            }

            await supabase.from("users").upsert({
              phone: normalizedPhone, name:regData.name, role:"expert",
              verification_status:"pending", area:regData.city||"Lucknow"
            },{onConflict:"phone"});

            onLogin({phone: normalizedPhone, name:regData.name, role:"expert", area:regData.city||"Lucknow", verification_status:"pending"});
          } catch(e){
            console.error("Registration error:", e);
            alert("Something went wrong: " + (e.message||"Unknown error") + "\nPlease try again.");
          }
          setLoad(false);
        }} disabled={loading} className="tap"
          style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:18,color:"white",fontWeight:800,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 8px 24px rgba(6,95,70,.3)"}}>
          {loading?<Spinner/>:regStep===4?"🚀 Submit Application":"Continue →"}
        </button>
        <div style={{textAlign:"center",color:"#9A9A9A",fontSize:11,marginTop:10}}>
          Step {regStep} of 4 · Your data is encrypted and secure 🔒
        </div>
      </div>
    </div>
  );

  // ── ROLE SELECTION ────────────────────────────
  if(step==="role") return (
    <div style={{minHeight:"100vh",background:"#F4F6FA",display:"flex",flexDirection:"column"}}>
      {/* Hero */}
      <div style={{position:"relative",overflow:"hidden",borderRadius:"0 0 36px 36px",height:260}}>
        <img src="/images/lucknow.jpg" alt="Lucknow"
          style={{width:"100%",height:"100%",objectFit:"cover",display:"block",filter:"brightness(.4)"}}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(to bottom,rgba(15,45,92,.4),rgba(15,45,92,.9))"}}/>
        <div style={{position:"absolute",inset:0,padding:"52px 24px 28px",display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <Logo size={36} white/>
              <div>
                <div style={{color:"white",fontWeight:900,fontSize:20,letterSpacing:-.4}}>GharPe</div>
                <div style={{color:"rgba(255,255,255,.6)",fontSize:9,letterSpacing:2}}>घर पे · LUCKNOW</div>
              </div>
            </div>
            <button onClick={()=>setLang(l=>l==="en"?"hi":"en")}
              style={{background:"rgba(255,255,255,.15)",border:"1px solid rgba(255,255,255,.3)",borderRadius:20,padding:"6px 14px",color:"white",fontWeight:600,fontSize:12,cursor:"pointer"}}>
              {L?"🇮🇳 हिंदी":"🇬🇧 ENG"}
            </button>
          </div>
          <div>
            <div style={{color:"rgba(255,255,255,.7)",fontSize:12,letterSpacing:.5,marginBottom:4}}>WELCOME TO</div>
            <div style={{color:"white",fontWeight:900,fontSize:26,letterSpacing:-.5,lineHeight:1.2}}>
              {L?"Muskuraiye, Aap Lucknow Mein Hain! 😊":"मुस्कुराइए, आप लखनऊ में हैं! 😊"}
            </div>
            <div style={{color:"rgba(255,255,255,.6)",fontSize:12,marginTop:6,fontStyle:"italic"}}>
              Nawabi city's #1 home services platform
            </div>
          </div>
        </div>
      </div>

      {/* Role selection */}
      <div style={{padding:"24px 20px",flex:1}}>
        <div style={{fontWeight:900,color:"#0D0D0D",fontSize:20,marginBottom:4,letterSpacing:-.4}}>
          {L?"Continue as":"जारी रखें"}
        </div>
        <div style={{color:"#9A9A9A",fontSize:13,marginBottom:20}}>
          {L?"Select your role to get started":"अपनी भूमिका चुनें"}
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {ROLES.map((r,i)=>(
            <button key={r.id} onClick={()=>{setRole(r.id);setStep("phone");}} className="fu tap"
              style={{background:"white",border:`2px solid ${r.light}`,borderRadius:22,padding:"18px 20px",cursor:"pointer",textAlign:"left",boxShadow:"0 4px 20px rgba(0,0,0,.07)",animationDelay:`${i*80}ms`,display:"flex",alignItems:"center",gap:16,position:"relative",overflow:"hidden"}}>
              {/* Accent bar */}
              <div style={{position:"absolute",left:0,top:0,bottom:0,width:5,background:r.grad,borderRadius:"22px 0 0 22px"}}/>
              {/* Icon circle */}
              <div style={{width:54,height:54,borderRadius:18,background:r.light,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0}}>
                {r.icon}
              </div>
              <div style={{flex:1}}>
                <div style={{fontWeight:900,color:"#0D0D0D",fontSize:16,letterSpacing:-.2}}>{L?r.label:r.labelHi}</div>
                <div style={{fontSize:12,color:"#9A9A9A",marginTop:3}}>{L?r.desc:r.descHi}</div>
              </div>
              <div style={{width:34,height:34,borderRadius:12,background:r.light,display:"flex",alignItems:"center",justifyContent:"center",color:r.color,fontWeight:800,fontSize:18,flexShrink:0}}>
                →
              </div>
            </button>
          ))}
        </div>

        {/* Trust badges */}
        <div style={{display:"flex",justifyContent:"space-around",marginTop:28,padding:"16px",background:"white",borderRadius:18,border:"1px solid #E8E8E8"}}>
          {[["🔒","Secure"],["⭐","Trusted"],["🇮🇳","Made in India"],["🏆","#1 Lucknow"]].map(([ic,txt])=>(
            <div key={txt} style={{textAlign:"center"}}>
              <div style={{fontSize:18,marginBottom:4}}>{ic}</div>
              <div style={{fontSize:10,fontWeight:700,color:"#9A9A9A"}}>{txt}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // ── PHONE + OTP SCREEN ───────────────────────
  return (
    <div style={{minHeight:"100vh",background:"#F4F6FA",display:"flex",flexDirection:"column"}}>
      {/* Header */}
      <div style={{background:selectedRole?.grad,padding:"52px 20px 28px",borderRadius:"0 0 32px 32px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-40,right:-40,width:160,height:160,borderRadius:"50%",background:"rgba(255,255,255,.06)"}}/>
        <button onClick={()=>{setStep("role");setPhone("");setOtp(["","","","","",""]);setErr("");}}
          style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:20,display:"inline-flex",alignItems:"center",gap:6}}>
          ← {L?"Back":"वापस"}
        </button>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
          <div style={{width:48,height:48,borderRadius:16,background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>
            {selectedRole?.icon}
          </div>
          <div>
            <div style={{color:"rgba(255,255,255,.7)",fontSize:11,letterSpacing:.5}}>{step==="phone"?"STEP 1 OF 2":"STEP 2 OF 2"}</div>
            <div style={{color:"white",fontWeight:900,fontSize:20,letterSpacing:-.4}}>
              {step==="phone"?(L?"Enter Mobile Number":"मोबाइल नंबर दर्ज करें"):(L?"Enter OTP":"OTP दर्ज करें")}
            </div>
          </div>
        </div>
        {step==="otp"&&(
          <div>
            <div style={{color:"rgba(255,255,255,.8)",fontSize:13}}>
              OTP sent to <b style={{color:"white"}}>+91 {phone}</b>
              <button onClick={()=>{setStep("phone");setOtp(["","","","","",""]);setErr("");}}
                style={{background:"none",border:"none",color:"#FBBF24",fontWeight:700,fontSize:13,cursor:"pointer",marginLeft:8}}>Change</button>
            </div>
            <div style={{color:"rgba(255,255,255,.55)",fontSize:11,marginTop:4}}>
              Please check your SMS inbox
            </div>
          </div>
        )}
      </div>

      <div style={{flex:1,padding:"24px 20px"}}>
        {step==="phone"&&(
          <div className="fu">
            <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Mobile Number</div>
            <div style={{background:"white",borderRadius:16,display:"flex",alignItems:"center",border:`2px solid ${phone.length===10?selectedRole?.color||D.navy:"#E8E8E8"}`,transition:"border .2s",overflow:"hidden",marginBottom:6}}>
              <div style={{padding:"0 16px",borderRight:"1px solid #E8E8E8",display:"flex",alignItems:"center",gap:6,height:56}}>
                <span style={{fontSize:18}}>🇮🇳</span>
                <span style={{color:"#545454",fontWeight:600,fontSize:14}}>+91</span>
              </div>
              <input type="tel" maxLength={10} value={phone}
                onChange={e=>setPhone(e.target.value.replace(/\D/g,""))}
                onKeyDown={e=>{if(e.key==="Enter"&&phone.length===10)sendOTP();}}
                placeholder="Enter 10-digit number"
                style={{flex:1,border:"none",background:"transparent",padding:"16px",fontSize:16,fontWeight:700,color:"#0D0D0D",outline:"none",letterSpacing:.5}}
              />
              {phone.length===10&&<span style={{paddingRight:16,fontSize:20,color:"#00875A"}}>✓</span>}
            </div>
            {err&&<div style={{background:"#FEE2E2",borderRadius:10,padding:"10px 14px",marginTop:8,color:"#DC2626",fontSize:13}}>{err}</div>}

            {/* Role info card */}
            <div style={{background:`${selectedRole?.light}`,border:`1px solid ${selectedRole?.color}22`,borderRadius:14,padding:"14px 16px",marginTop:20}}>
              <div style={{fontWeight:700,color:selectedRole?.color,fontSize:13,marginBottom:6}}>
                {selectedRole?.icon} {L?selectedRole?.label:selectedRole?.labelHi}
              </div>
              <div style={{fontSize:12,color:"#545454",lineHeight:1.6}}>
                {role==="customer"&&"Book salon, cleaning, electrician and more services at your doorstep."}
                {role==="expert"&&"Join 500+ experts earning ₹15,000-₹50,000/month with GharPe."}
                {role==="admin"&&"Access the complete GharPe business management dashboard."}
              </div>
            </div>
          </div>
        )}

        {step==="otp"&&(
          <div className="fu">
            <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:16}}>Enter 6-digit OTP</div>
            <div style={{display:"flex",gap:10,justifyContent:"center",marginBottom:8}}>
              {otp.map((v,i)=>(
                <input key={i} ref={el=>otpRefs.current[i]=el} value={v}
                  onChange={e=>handleOtp(i,e)} onKeyDown={e=>handleKey(i,e)}
                  onPaste={i===0?handlePaste:undefined}
                  maxLength={1} inputMode="numeric"
                  style={{width:46,height:58,textAlign:"center",fontSize:24,fontWeight:900,
                    background:"white",
                    border:`2.5px solid ${v?(selectedRole?.color||D.navy):"#E8E8E8"}`,
                    borderRadius:16,color:selectedRole?.color||D.navy,outline:"none",
                    boxShadow:v?`0 4px 12px ${selectedRole?.color||D.navy}22`:"none",transition:"all .15s"}}
                />
              ))}
            </div>
            <div style={{textAlign:"center",marginTop:14,marginBottom:16}}>
              {cd>0
                ?<span style={{color:"#9A9A9A",fontSize:13}}>Resend in <b style={{color:"#0D0D0D"}}>{cd}s</b></span>
                :<button onClick={()=>{setCd(30);sendOTP();}} style={{background:"none",border:"none",color:selectedRole?.color||D.navy,fontWeight:700,fontSize:13,cursor:"pointer"}}>Resend OTP</button>
              }
            </div>
            {err&&<div style={{background:"#FEE2E2",borderRadius:10,padding:"10px 14px",color:"#DC2626",fontSize:13,marginBottom:16}}>{err}</div>}

            {/* Helpful tips - fills blank space nicely */}
            <div style={{background:"white",borderRadius:16,padding:16,border:"1px solid #E8E8E8",marginTop:8}}>
              <div style={{fontWeight:700,color:"#545454",fontSize:12,marginBottom:12}}>💡 Tips</div>
              {[
                {icon:"📱", text:"Check your SMS inbox for the 6-digit code"},
                {icon:"⏱️", text:"OTP is valid for 10 minutes only"},
                {icon:"🔒", text:"Never share your OTP with anyone"},
                {icon:"📵", text:"Not received? Check if DND is enabled on your number"},
              ].map(({icon,text})=>(
                <div key={text} style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                  <span style={{fontSize:16,flexShrink:0}}>{icon}</span>
                  <span style={{fontSize:12,color:"#9A9A9A",lineHeight:1.5}}>{text}</span>
                </div>
              ))}
            </div>

            {/* Support link */}
            <div style={{textAlign:"center",marginTop:16}}>
              <span style={{fontSize:12,color:"#9A9A9A"}}>Having trouble? </span>
              <a href="https://wa.me/919695525881?text=OTP not received on GharPe"
                target="_blank" rel="noreferrer"
                style={{fontSize:12,color:selectedRole?.color||D.navy,fontWeight:700,textDecoration:"none"}}>
                WhatsApp Support →
              </a>
            </div>
          </div>
        )}
      </div>

      {/* CTA Button */}
      <div style={{padding:"16px 20px 36px"}}>
        <button onClick={step==="phone"?sendOTP:verifyOTP}
          disabled={step==="phone"?phone.length!==10:(otp.join("").length<4||loading)}
          className="tap"
          style={{width:"100%",padding:"17px",
            background:(step==="phone"?phone.length===10:(otp.join("").length>=4&&!loading))?selectedRole?.grad||"#0F2D5C":"#D1D5DB",
            border:"none",borderRadius:18,color:"white",fontWeight:800,fontSize:16,
            cursor:(step==="phone"?phone.length===10:otp.join("").length>=4&&!loading)?"pointer":"not-allowed",
            display:"flex",alignItems:"center",justifyContent:"center",gap:8,transition:"all .25s",
            boxShadow:(step==="phone"?phone.length===10:otp.join("").length>=4)?`0 8px 28px ${selectedRole?.color||"#0F2D5C"}44`:"none"}}>
          {loading?<Spinner/>:(step==="phone"?"Get OTP →":"Verify & Continue →")}
        </button>
        <p style={{textAlign:"center",color:"#9A9A9A",fontSize:11,marginTop:14,lineHeight:1.6}}>
          By continuing you agree to GharPe's Terms & Privacy Policy
        </p>
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  DYNAMIC BOOKING FLOW — Smart forms per service
// ══════════════════════════════════════════════════

// Dynamic questions per service category
const SERVICE_QUESTIONS = {
  "Salon & Beauty": [
    {id:"service_type", label:"Service Type", type:"chips", required:true,
     options:["Haircut","Facial","Waxing","Manicure","Pedicure","Makeup","Hair Color"]},
    {id:"gender", label:"For whom?", type:"chips", required:true,
     options:["Female","Male","Child"]},
    {id:"notes", label:"Any special requests?", type:"text", placeholder:"e.g. specific style, allergies..."},
  ],
  "Cleaning": [
    {id:"clean_type", label:"Cleaning Type", type:"chips", required:true,
     options:["Basic Cleaning","Deep Cleaning","Move-in/Move-out"]},
    {id:"rooms", label:"Number of Bedrooms", type:"stepper", min:1, max:10, default:2},
    {id:"bathrooms", label:"Number of Bathrooms", type:"stepper", min:1, max:5, default:1},
    {id:"kitchen", label:"Kitchen cleaning included?", type:"toggle"},
    {id:"balcony", label:"Balcony cleaning included?", type:"toggle"},
    {id:"photos", label:"Upload area photos (optional)", type:"photos"},
  ],
  "Electrician": [
    {id:"issue_type", label:"Type of Issue", type:"chips", required:true,
     options:["Fan Installation","Switch/Socket","Wiring","Short Circuit","AC Wiring","Inverter","Other"]},
    {id:"urgency", label:"Urgency Level", type:"chips", required:true,
     options:["Normal (today)","Urgent (2 hrs)","Emergency (ASAP)"]},
    {id:"description", label:"Describe the issue", type:"text", placeholder:"e.g. fan not working, sparks from switch..."},
    {id:"photos", label:"Upload photos/videos", type:"photos"},
  ],
  "Plumbing": [
    {id:"issue_type", label:"Issue Type", type:"chips", required:true,
     options:["Tap Repair","Pipe Leak","Drainage Block","Toilet Issue","Water Pump","New Installation"]},
    {id:"urgency", label:"Urgency", type:"chips", required:true,
     options:["Normal","Urgent","Emergency"]},
    {id:"description", label:"Describe the problem", type:"text", placeholder:"e.g. kitchen tap leaking, bathroom blocked..."},
    {id:"photos", label:"Upload photos", type:"photos"},
  ],
  "AC Service": [
    {id:"ac_brand", label:"AC Brand", type:"chips",
     options:["Voltas","LG","Samsung","Daikin","Hitachi","Blue Star","Other"]},
    {id:"issue_type", label:"Service Required", type:"chips", required:true,
     options:["Regular Service","Deep Cleaning","Gas Refill","Not Cooling","Installation","Uninstallation"]},
    {id:"ac_count", label:"Number of ACs", type:"stepper", min:1, max:5, default:1},
    {id:"photos", label:"Upload AC photos", type:"photos"},
  ],
  "Carpenter": [
    {id:"work_type", label:"Work Type", type:"chips", required:true,
     options:["Furniture Repair","Door/Window Fix","Cabinet Install","Bed Assembly","Wardrobe","Custom Work"]},
    {id:"material", label:"Material Available?", type:"chips",
     options:["I have material","Need material","Not sure"]},
    {id:"description", label:"Describe the work", type:"text", placeholder:"e.g. wooden chair broken leg, wardrobe door..."},
    {id:"photos", label:"Upload photos", type:"photos"},
  ],
  "Pest Control": [
    {id:"pest_type", label:"Pest Type", type:"chips", required:true,
     options:["Cockroaches","Termites","Rodents","Mosquitoes","Bed Bugs","Lizards","All Pests"]},
    {id:"area_size", label:"Area Size", type:"chips", required:true,
     options:["1 BHK","2 BHK","3 BHK","4+ BHK","Office","Shop"]},
    {id:"pets_home", label:"Pets at home?", type:"toggle"},
    {id:"notes", label:"Additional notes", type:"text", placeholder:"e.g. specifically in kitchen..."},
  ],
  "Painting": [
    {id:"paint_type", label:"Painting Type", type:"chips", required:true,
     options:["Interior","Exterior","Both"]},
    {id:"rooms", label:"Number of Rooms", type:"stepper", min:1, max:10, default:2},
    {id:"walls", label:"Walls per room approx.", type:"stepper", min:1, max:6, default:4},
    {id:"ceiling", label:"Ceiling painting?", type:"toggle"},
    {id:"putty", label:"Putty/Primer needed?", type:"toggle"},
    {id:"paint_brand", label:"Paint Brand Preference", type:"chips",
     options:["Asian Paints","Berger","Nerolac","Dulux","Any"]},
    {id:"photos", label:"Upload room photos", type:"photos"},
  ],
};

const Booking = ({cat,user,lang,onBack,onDone}) => {
  const [step,setStep]       = useState(1);
  const [sel,setSel]         = useState(null);
  const [date,setDate]       = useState("");
  const [time,setTime]       = useState("");
  const [area,setArea]       = useState(user?.area||"");
  const [addr,setAddr]       = useState("");
  const [showArea,setShowArea] = useState(false);
  const [saving,setSaving]   = useState(false);
  const [answers,setAnswers] = useState({});   // dynamic form answers
  const [photos,setPhotos]   = useState([]);   // uploaded photos
  const [steppers,setSteppers] = useState({});
  const [toggles,setToggles] = useState({});
  const L = lang==="en";
  const ok2 = date&&time&&area&&addr;
  const total = sel ? sel.p+29+Math.round(sel.p*.18) : 0;
  const questions = SERVICE_QUESTIONS[cat.en] || [];

  const confirmBooking = async () => {
    setSaving(true);
    try {
      const bookingId = "GP" + Math.floor(Date.now()/1000);
      const bookingData = {
        id: bookingId,
        customer_phone: user.phone,
        customer_name: user.name||"Customer",
        service_name: sel.n,
        category: cat.en,
        area, address:addr, date, time,
        amount: sel.p,
        status: "pending",
        payment_method: "cash",
        payment_status: "unpaid",
        pro_phone: null,
        pro_name: null,
        booking_details: JSON.stringify({...answers, ...steppers, ...toggles}),
      };
      const { data, error } = await supabase.from("bookings").insert(bookingData).select().single();
      if(error) throw error;
      // Random service-start OTP (customer shows it to the expert to begin the job)
      await supabase.from("booking_secrets").insert({ booking_id: bookingId, otp: String(Math.floor(1000+Math.random()*9000)) });
      // Auto-assign nearest available expert
      autoAssignExpert({...bookingData, id:bookingId, category:cat.en, area});
      onDone(data||{id:bookingId});
      return data;
    } catch(e) {
      console.error(e);
      const fallback = {id:"GP"+Math.floor(Date.now()/1000)};
      onDone(fallback);
      return fallback;
    } finally { setSaving(false); }
  };

  // ── SECURE ONLINE PAYMENT (server-verified) ────────────────────────────────
  //  The browser no longer decides the price or marks a booking "paid".
  //  1. Create the booking as UNPAID.
  //  2. Ask the create-order Edge Function for a Razorpay order (server sets amount).
  //  3. After checkout, verify-payment Edge Function verifies the signature + amount
  //     and is the ONLY thing that flips the booking to "paid".
  const openRazorpay = async () => {
    setSaving(true);
    const FUNCTIONS_BASE = "https://lwwygijjslkezxpycpgn.supabase.co/functions/v1";
    const ANON = "sb_publishable_Ep4nBdwjVDJRYEPx3XTv2Q_DEXrwFJb";
    const authHeader = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      return "Bearer " + (session?.access_token || ANON);
    };
    try {
      // 1. Create the booking as UNPAID first.
      const bookingId = "GP" + Math.floor(Date.now()/1000);
      const { error: insertErr } = await supabase.from("bookings").insert({
        id: bookingId,
        customer_phone: user.phone,
        customer_name: user.name||"Customer",
        service_name: sel.n, category: cat.en,
        area, address:addr, date, time, amount: sel.p,
        status: "pending", payment_method: "online",
        payment_status: "unpaid",
        booking_details: JSON.stringify({...answers,...steppers,...toggles}),
      });
      if(insertErr) throw insertErr;
      // Random service-start OTP for this booking
      await supabase.from("booking_secrets").insert({ booking_id: bookingId, otp: String(Math.floor(1000+Math.random()*9000)) });

      // 2. Server creates the order and decides the real amount.
      const orderRes = await fetch(FUNCTIONS_BASE + "/create-order", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: await authHeader() },
        body: JSON.stringify({ booking_id: bookingId }),
      });
      const order = await orderRes.json();
      if(!orderRes.ok) throw new Error(order.error || "Could not start payment");

      // 3. Open Razorpay checkout bound to that order.
      const options = {
        key: order.key_id,
        order_id: order.order_id,
        amount: order.amount,
        currency: "INR",
        name: "GharPe",
        description: "Home Service Booking",
        prefill: { contact: "+91"+user.phone, name: user.name||"Customer" },
        theme: { color: "#0F2D5C" },
        handler: async function(response) {
          try {
            // 4. Server verifies signature + amount, then marks paid.
            const verifyRes = await fetch(FUNCTIONS_BASE + "/verify-payment", {
              method: "POST",
              headers: { "Content-Type": "application/json", Authorization: await authHeader() },
              body: JSON.stringify({
                booking_id: bookingId,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });
            const result = await verifyRes.json();
            if(!verifyRes.ok) throw new Error(result.error || "Verification failed");
            setSaving(false);
            onDone({ id: bookingId, payment_id: response.razorpay_payment_id });
          } catch(e) {
            setSaving(false);
            alert("Payment received (ID: " + response.razorpay_payment_id + ") but confirmation is still processing. If your booking isn't confirmed shortly, contact support with this ID.");
          }
        },
        modal: { ondismiss: () => setSaving(false) },
      };
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function(resp){
        setSaving(false);
        alert("Payment failed: " + (resp.error?.description || "Please try again."));
      });
      rzp.open();
    } catch(e) {
      setSaving(false);
      alert(e.message || "Could not start payment. Please try again.");
    }
  };

  // ── RENDER DYNAMIC QUESTION ──────────────────
  const renderQuestion = (q) => {
    if(q.type==="chips") return (
      <div key={q.id} style={{marginBottom:20}}>
        <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:10}}>
          {q.label}{q.required&&<span style={{color:"#DC2626"}}> *</span>}
        </div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {q.options.map(opt=>{
            const sel2 = answers[q.id]===opt;
            return <button key={opt} onClick={()=>setAnswers(a=>({...a,[q.id]:opt}))}
              style={{padding:"8px 16px",background:sel2?cat.accent:"white",
                border:`1.5px solid ${sel2?cat.accent:"#E8E8E8"}`,
                borderRadius:22,color:sel2?"white":"#545454",fontWeight:600,
                fontSize:12,cursor:"pointer",transition:"all .2s"}}>
              {opt}
            </button>;
          })}
        </div>
      </div>
    );

    if(q.type==="stepper") return (
      <div key={q.id} style={{marginBottom:20}}>
        <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:10}}>{q.label}</div>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <button onClick={()=>setSteppers(s=>({...s,[q.id]:Math.max(q.min,((s[q.id]||q.default||1))-1)}))}
            style={{width:40,height:40,borderRadius:12,background:"#F4F6FA",border:"1.5px solid #E8E8E8",fontSize:20,cursor:"pointer",color:"#0D0D0D",fontWeight:700}}>−</button>
          <div style={{fontSize:24,fontWeight:900,color:"#0D0D0D",minWidth:32,textAlign:"center"}}>
            {steppers[q.id]||q.default||1}
          </div>
          <button onClick={()=>setSteppers(s=>({...s,[q.id]:Math.min(q.max,((s[q.id]||q.default||1))+1)}))}
            style={{width:40,height:40,borderRadius:12,background:"#F4F6FA",border:"1.5px solid #E8E8E8",fontSize:20,cursor:"pointer",color:"#0D0D0D",fontWeight:700}}>+</button>
        </div>
      </div>
    );

    if(q.type==="toggle") return (
      <div key={q.id} style={{marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center",background:"white",borderRadius:14,padding:"14px 16px",border:"1.5px solid #E8E8E8"}}>
        <span style={{fontWeight:600,color:"#0D0D0D",fontSize:14}}>{q.label}</span>
        <button onClick={()=>setToggles(t=>({...t,[q.id]:!t[q.id]}))}
          style={{width:48,height:26,borderRadius:13,background:toggles[q.id]?cat.accent:"#E8E8E8",border:"none",cursor:"pointer",position:"relative",transition:"background .2s"}}>
          <div style={{position:"absolute",top:3,left:toggles[q.id]?24:3,width:20,height:20,borderRadius:"50%",background:"white",transition:"left .2s",boxShadow:"0 2px 4px rgba(0,0,0,.2)"}}/>
        </button>
      </div>
    );

    if(q.type==="text") return (
      <div key={q.id} style={{marginBottom:20}}>
        <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:8}}>{q.label}</div>
        <textarea value={answers[q.id]||""} onChange={e=>setAnswers(a=>({...a,[q.id]:e.target.value}))}
          placeholder={q.placeholder}
          style={{width:"100%",padding:"13px 16px",background:"white",border:"1.5px solid #E8E8E8",borderRadius:14,fontSize:14,resize:"none",height:80,boxSizing:"border-box",outline:"none",color:"#0D0D0D",lineHeight:1.5}}
        />
      </div>
    );

    if(q.type==="photos") return (
      <div key={q.id} style={{marginBottom:20}}>
        <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:8}}>{q.label}</div>
        <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
          {photos.map((p,i)=>(
            <div key={i} style={{position:"relative",width:80,height:80}}>
              <img src={p} alt="" style={{width:80,height:80,borderRadius:12,objectFit:"cover",border:"1.5px solid #E8E8E8"}}/>
              <button onClick={()=>setPhotos(prev=>prev.filter((_,j)=>j!==i))}
                style={{position:"absolute",top:-6,right:-6,width:20,height:20,borderRadius:"50%",background:"#DC2626",border:"none",color:"white",fontSize:12,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
            </div>
          ))}
          {photos.length<5&&(
            <label style={{width:80,height:80,borderRadius:12,border:"2px dashed #E8E8E8",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",background:"#F4F6FA"}}>
              <span style={{fontSize:24}}>📷</span>
              <span style={{fontSize:9,color:"#9A9A9A",marginTop:2}}>Add Photo</span>
              <input type="file" accept="image/*" multiple style={{display:"none"}}
                onChange={e=>{
                  Array.from(e.target.files).forEach(file=>{
                    const reader = new FileReader();
                    reader.onload = ev => setPhotos(prev=>[...prev,ev.target.result]);
                    reader.readAsDataURL(file);
                  });
                }}/>
            </label>
          )}
        </div>
        {photos.length>0&&<div style={{fontSize:11,color:"#9A9A9A",marginTop:6}}>{photos.length} photo(s) added</div>}
      </div>
    );
    return null;
  };

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh",paddingBottom:130}}>
      {/* Header */}
      <div style={{background:`linear-gradient(145deg,${cat.accent},${cat.accent}CC)`,padding:"52px 20px 24px",borderRadius:"0 0 24px 24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
          <button onClick={step===1?onBack:()=>setStep(s=>s-1)}
            style={{width:38,height:38,background:"rgba(255,255,255,.2)",border:"none",borderRadius:12,cursor:"pointer",color:"white",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center"}}>←</button>
          <div style={{flex:1}}>
            <div style={{color:"rgba(255,255,255,.7)",fontSize:11,letterSpacing:1}}>STEP {step} OF {step<=2?3:3}</div>
            <div style={{color:"white",fontWeight:800,fontSize:16}}>
              {step===1?"Choose Service":step===2?"Service Details":step===3?"Schedule & Address":"Confirm Booking"}
            </div>
          </div>
          <span style={{fontSize:28}}>{cat.icon}</span>
        </div>
        <div style={{display:"flex",gap:5}}>
          {[1,2,3,4].map(i=><div key={i} style={{flex:1,height:3,borderRadius:4,background:step>=i?"white":"rgba(255,255,255,.25)",transition:"all .4s"}}/>)}
        </div>
      </div>

      <div style={{padding:"20px 16px"}}>

        {/* STEP 1 — SELECT SERVICE */}
        {step===1&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:14}}>Choose a service</div>
            {cat.items.map(sv=>{
              const on=sel?.n===sv.n;
              return(
                <button key={sv.n} onClick={()=>setSel(sv)} className="tap"
                  style={{display:"flex",alignItems:"center",background:"white",border:`2px solid ${on?cat.accent:"#E8E8E8"}`,borderRadius:16,padding:"14px 16px",marginBottom:10,width:"100%",cursor:"pointer",boxShadow:on?`0 0 0 3px ${cat.accent}22`:"0 1px 3px rgba(0,0,0,.04)",transition:"all .2s"}}>
                  <div style={{width:22,height:22,borderRadius:"50%",border:`2.5px solid ${on?cat.accent:"#E8E8E8"}`,background:on?cat.accent:"white",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginRight:14,transition:"all .2s"}}>
                    {on&&<div style={{width:8,height:8,borderRadius:"50%",background:"white"}}/>}
                  </div>
                  <div style={{flex:1,textAlign:"left"}}>
                    <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{sv.n}</div>
                    <div style={{display:"flex",gap:8,marginTop:3}}>
                      <Stars r={sv.r} s={10}/>
                      <span style={{color:"#9A9A9A",fontSize:10}}>· {sv.t}</span>
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontWeight:900,color:cat.accent,fontSize:17}}>₹{sv.p}</div>
                    <div style={{fontSize:10,color:"#9A9A9A"}}>+taxes</div>
                  </div>
                </button>
              );
            })}
          </div>
        )}

        {/* STEP 2 — DYNAMIC SERVICE DETAILS */}
        {step===2&&(
          <div className="fu">
            <div style={{background:"white",borderRadius:16,padding:"12px 16px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center",border:"1px solid #E8E8E8"}}>
              <div>
                <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{sel?.n}</div>
                <div style={{color:"#9A9A9A",fontSize:12,marginTop:2}}>{cat.en} · {sel?.t}</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontWeight:900,color:cat.accent,fontSize:17}}>₹{sel?.p}</span>
                <button onClick={()=>setStep(1)} style={{background:"#F4F6FA",border:"none",borderRadius:8,padding:"4px 10px",color:"#545454",fontSize:11,fontWeight:600,cursor:"pointer"}}>Change</button>
              </div>
            </div>

            {questions.length>0?(
              <div>
                <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:16}}>Service Details</div>
                {questions.map(q=>renderQuestion(q))}
              </div>
            ):(
              <div style={{background:"white",borderRadius:16,padding:20,textAlign:"center",color:"#9A9A9A",border:"1px solid #E8E8E8"}}>
                No additional details needed. Continue to schedule!
              </div>
            )}
          </div>
        )}

        {/* STEP 3 — SCHEDULE */}
        {step===3&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:14}}>When do you need it?</div>

            <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:10}}>Select Date</div>
            <div style={{display:"flex",gap:8,marginBottom:20}}>
              {[L?"Today":"आज",L?"Tomorrow":"कल",L?"Day After":"परसों"].map(d=>(
                <button key={d} onClick={()=>setDate(d)} className="tap"
                  style={{flex:1,padding:"13px 4px",background:date===d?cat.accent:"white",border:`2px solid ${date===d?cat.accent:"#E8E8E8"}`,borderRadius:14,color:date===d?"white":"#0D0D0D",fontWeight:700,fontSize:13,cursor:"pointer",transition:"all .2s",boxShadow:date===d?`0 4px 12px ${cat.accent}44`:"none"}}>
                  {d}
                </button>
              ))}
            </div>

            <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:10}}>Select Time</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:20}}>
              {["9:00 AM","11:00 AM","1:00 PM","3:00 PM","5:00 PM","7:00 PM"].map(t=>(
                <button key={t} onClick={()=>setTime(t)} className="tap"
                  style={{padding:"12px 4px",background:time===t?cat.accent:"white",border:`2px solid ${time===t?cat.accent:"#E8E8E8"}`,borderRadius:13,color:time===t?"white":"#0D0D0D",fontWeight:700,fontSize:13,cursor:"pointer",transition:"all .2s"}}>
                  {t}
                </button>
              ))}
            </div>

            <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Your Area</div>
            <button onClick={()=>setShowArea(!showArea)} className="tap"
              style={{width:"100%",padding:"14px 16px",background:"white",border:`2px solid ${area?cat.accent:"#E8E8E8"}`,borderRadius:14,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:showArea?0:18,transition:"border .2s"}}>
              <span style={{fontWeight:area?700:400,color:area?"#0D0D0D":"#9A9A9A",fontSize:14}}>{area?`📍 ${area}`:"Select area in Lucknow"}</span>
              <span style={{color:"#9A9A9A"}}>{showArea?"▲":"▼"}</span>
            </button>
            {showArea&&(
              <div className="su" style={{background:"white",border:"1px solid #E8E8E8",borderRadius:14,maxHeight:200,overflowY:"auto",marginBottom:18,boxShadow:"0 12px 32px rgba(0,0,0,.12)"}}>
                {AREAS.map(a=>(
                  <div key={a} onClick={()=>{setArea(a);setShowArea(false);}} className="tap"
                    style={{padding:"12px 16px",borderBottom:"1px solid #F4F6FA",cursor:"pointer",fontSize:14,fontWeight:a===area?700:400,color:a===area?cat.accent:"#0D0D0D",background:a===area?cat.bg:"white"}}>
                    📍 {a}
                  </div>
                ))}
              </div>
            )}

            <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Full Address</div>
            <textarea value={addr} onChange={e=>setAddr(e.target.value)}
              placeholder="House no., building, street, landmark..."
              style={{width:"100%",padding:"14px 16px",background:"white",border:`2px solid ${addr?cat.accent:"#E8E8E8"}`,borderRadius:14,fontSize:14,resize:"none",height:80,boxSizing:"border-box",outline:"none",color:"#0D0D0D",lineHeight:1.5,transition:"border .2s"}}
            />
          </div>
        )}

        {/* STEP 4 — CONFIRM */}
        {step===4&&(
          <div className="fu">
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:14}}>Review Your Booking</div>

            {/* Service card */}
            <div style={{background:"white",borderRadius:18,marginBottom:12,border:"1px solid #E8E8E8",overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
              <div style={{background:`linear-gradient(135deg,${cat.accent},${cat.accent}CC)`,padding:"14px 16px",display:"flex",gap:12,alignItems:"center"}}>
                <div style={{width:52,height:52,borderRadius:15,background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>{cat.icon}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:800,color:"white",fontSize:15}}>{sel?.n}</div>
                  <div style={{color:"rgba(255,255,255,.8)",fontSize:12,marginTop:2}}>{cat.en} · {sel?.t}</div>
                </div>
                <div style={{fontWeight:900,color:"white",fontSize:22}}>₹{sel?.p}</div>
              </div>
              <div style={{padding:"14px 16px"}}>
                {[["📅",`${date} at ${time}`],["📍",area],["🏠",addr]].map(([ic,v],i)=>(
                  <div key={i} style={{display:"flex",gap:12,padding:"8px 0",borderBottom:i<2?"1px solid #F4F6FA":"none"}}>
                    <span style={{fontSize:15,width:22,textAlign:"center"}}>{ic}</span>
                    <span style={{color:"#545454",fontSize:13,flex:1}}>{v}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Service details summary */}
            {Object.keys({...answers,...steppers,...toggles}).length>0&&(
              <div style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:12,border:"1px solid #E8E8E8"}}>
                <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:10}}>Service Details</div>
                {Object.entries({...answers,...steppers}).map(([k,v])=>(
                  v&&<div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{color:"#9A9A9A",fontSize:12,textTransform:"capitalize"}}>{k.replace(/_/g," ")}</span>
                    <span style={{color:"#0D0D0D",fontSize:12,fontWeight:600}}>{v}</span>
                  </div>
                ))}
                {Object.entries(toggles).filter(([,v])=>v).map(([k])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{color:"#9A9A9A",fontSize:12,textTransform:"capitalize"}}>{k.replace(/_/g," ")}</span>
                    <span style={{color:"#065F46",fontSize:12,fontWeight:600}}>✓ Yes</span>
                  </div>
                ))}
                {photos.length>0&&(
                  <div>
                    <div style={{color:"#9A9A9A",fontSize:12,marginBottom:6}}>{photos.length} photo(s) attached</div>
                    <div style={{display:"flex",gap:6}}>
                      {photos.map((p,i)=><img key={i} src={p} alt="" style={{width:44,height:44,borderRadius:8,objectFit:"cover"}}/>)}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Bill */}
            <div style={{background:"white",borderRadius:16,padding:16,marginBottom:12,border:"1px solid #E8E8E8"}}>
              <div style={{fontWeight:800,color:"#0D0D0D",fontSize:14,marginBottom:12}}>Bill Summary</div>
              {[["Service charge","₹"+sel?.p],["Platform fee","₹29"],["GST (18%)","₹"+Math.round((sel?.p||0)*.18)]].map(([l,v],i)=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",marginBottom:i<2?10:12}}>
                  <span style={{color:"#9A9A9A",fontSize:13}}>{l}</span>
                  <span style={{color:"#0D0D0D",fontSize:13,fontWeight:600}}>{v}</span>
                </div>
              ))}
              <div style={{height:1,background:"#F4F6FA",margin:"8px 0"}}/>
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8}}>
                <span style={{fontWeight:800,color:"#0D0D0D",fontSize:15}}>Total Payable</span>
                <span style={{fontWeight:900,color:cat.accent,fontSize:20}}>₹{total}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Sticky CTA */}
      <div style={{position:"fixed",bottom:0,left:"50%",transform:"translateX(-50%)",width:"100%",maxWidth:430,background:"white",borderTop:"1px solid #E8E8E8",padding:"14px 16px 28px",boxShadow:"0 -8px 24px rgba(0,0,0,.06)"}}>
        {sel&&step>=3&&(
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
            <span style={{color:"#9A9A9A",fontSize:13}}>{sel.n}</span>
            <span style={{fontWeight:900,color:cat.accent,fontSize:18}}>₹{step===4?total:sel.p}</span>
          </div>
        )}
        {step===4 ? (
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <button className="tap" onClick={openRazorpay}
              style={{width:"100%",padding:"15px",background:"linear-gradient(135deg,#00875A,#00A66E)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 8px 24px rgba(0,135,90,.35)"}}>
              💳 Pay ₹{total} — UPI / Card
            </button>
            <button className="tap" onClick={confirmBooking} disabled={saving}
              style={{width:"100%",padding:"15px",background:saving?"#D1D5DB":`linear-gradient(135deg,#0F2D5C,#1A4080)`,border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:saving?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:saving?"none":"0 8px 24px rgba(15,45,92,.35)"}}>
              {saving?<><Spinner/> Saving...</>:"💵 Pay Cash After Service"}
            </button>
          </div>
        ):(
          <button onClick={()=>{
            if(step===1&&sel)setStep(2);
            else if(step===2)setStep(3);
            else if(step===3&&ok2)setStep(4);
          }} disabled={step===1?!sel:step===3?!ok2:false}
            className="tap"
            style={{width:"100%",padding:"16px",
              background:(step===1?sel:step===3?ok2:true)?`linear-gradient(135deg,${cat.accent},${cat.accent}CC)`:"#D1D5DB",
              border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:16,
              cursor:(step===1?sel:step===3?ok2:true)?"pointer":"not-allowed",
              transition:"all .25s",display:"flex",alignItems:"center",justifyContent:"center",gap:8,
              boxShadow:(step===1?sel:step===3?ok2:true)?`0 8px 24px ${cat.accent}44`:"none"}}>
            {step===1?"Continue →":step===2?"Next: Schedule →":step===3?"Review Booking →":""}
          </button>
        )}
      </div>
    </div>
  );
};

const Confirmed = ({booking,onHome}) => (
  <div style={{minHeight:"100vh",background:"white",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:32,textAlign:"center"}}>
    <div className="pop" style={{width:96,height:96,borderRadius:"50%",background:"#DCFCE7",display:"flex",alignItems:"center",justifyContent:"center",fontSize:52,marginBottom:20}}>✅</div>
    <h2 style={{fontSize:26,fontWeight:900,color:D.ink,letterSpacing:-.5,marginBottom:8}}>Booking Confirmed!</h2>
    <p style={{color:D.sub,fontSize:14,lineHeight:1.7,marginBottom:8}}>Your professional will arrive at the scheduled time.</p>
    <p style={{color:D.muted,fontSize:13,marginBottom:28}}>WhatsApp confirmation will be sent shortly 📱</p>
    <div style={{background:D.navyXL,borderRadius:16,padding:"16px 32px",marginBottom:28,border:`1px solid ${D.border}`}}>
      <div style={{fontSize:12,color:D.muted,marginBottom:4}}>Booking ID</div>
      <div style={{fontSize:22,fontWeight:900,color:D.navy,letterSpacing:1}}>{booking?.id||"GP"+Math.floor(Date.now()/1000)}</div>
      {booking?.payment_id&&<div style={{fontSize:11,color:D.green,marginTop:4}}>✅ Paid Online</div>}
    </div>
    <button onClick={onHome} className="tap" style={{padding:"15px 40px",background:`linear-gradient(135deg,${D.navy},${D.navyL})`,border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:16,cursor:"pointer",boxShadow:`0 8px 24px rgba(15,45,92,.4)`,marginBottom:14}}>
      Back to Home
    </button>
  </div>
);

const CHome = ({user,lang,setLang,onBook,onLogout,onProfile}) => {
  const [search,setSearch] = useState("");
  const [activeTab,setActiveTab] = useState("All");
  const L = lang==="en";

  const TABS = [
    {id:"All",label:"All",icon:"🏠"},
    {id:"Salon",label:"Salon",icon:"💄"},
    {id:"Clean",label:"Cleaning",icon:"🧹"},
    {id:"Electr",label:"Electric",icon:"⚡"},
    {id:"Plumb",label:"Plumbing",icon:"🔧"},
    {id:"AC",label:"AC",icon:"❄️"},
    {id:"Paint",label:"Painting",icon:"🎨"},
  ];

  const PHOTOS = {
    "Salon & Beauty":"/images/salon.jpg",
    "Cleaning":"/images/cleaning.jpg",
    "Electrician":"/images/electrician.jpg",
    "Plumbing":"/images/plumbing.jpg",
    "AC Service":"/images/ac.jpg",
    "Carpenter":"/images/carpenter.jpg",
    "Pest Control":"/images/pest.jpg",
    "Painting":"/images/painting.jpg",
  };

  const filtered = SERVICES.filter(s=>{
    const name = L?s.en:s.hi;
    const matchSearch = name.toLowerCase().includes(search.toLowerCase());
    const matchTab = activeTab==="All" || s.en.toLowerCase().includes(activeTab.toLowerCase());
    return matchSearch && matchTab;
  });

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh",paddingBottom:100}}>
      {/* STICKY HEADER */}
      <div style={{background:"white",position:"sticky",top:0,zIndex:100,boxShadow:"0 1px 0 #EBEBEB"}}>
        <div style={{padding:"46px 18px 0"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div>
              <div style={{fontSize:20,fontWeight:900,color:"#0D0D0D",letterSpacing:-.4}}>
                {L?"Home Services":"होम सर्विस"} 🏠
              </div>
              <div style={{display:"flex",alignItems:"center",gap:4,marginTop:3}}>
                <span style={{fontSize:13}}>📍</span>
                <span style={{fontSize:12,fontWeight:700,color:"#0F2D5C"}}>{user.area||"Gomti Nagar"}</span>
                <span style={{fontSize:11,color:"#9A9A9A"}}>· Lucknow</span>
              </div>
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <button onClick={()=>setLang(l=>l==="en"?"hi":"en")}
                style={{background:"#F4F6FA",border:"none",borderRadius:20,padding:"7px 13px",color:"#545454",fontWeight:700,fontSize:11,cursor:"pointer"}}>
                {L?"हिंदी":"ENG"}
              </button>
              <button onClick={()=>onProfile()} className="tap" style={{position:"relative",background:"none",border:"none",cursor:"pointer"}}>
                <div style={{width:38,height:38,borderRadius:13,background:"linear-gradient(135deg,#0F2D5C,#1A4080)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontWeight:800,color:"white",boxShadow:"0 4px 12px rgba(15,45,92,.3)"}}>
                  {(user.name||"U")[0]}
                </div>
                <div style={{position:"absolute",bottom:1,right:1,width:10,height:10,background:"#22C55E",borderRadius:"50%",border:"2px solid white"}}/>
              </button>
            </div>
          </div>
          <div style={{position:"relative",marginBottom:14}}>
            <div style={{position:"absolute",left:14,top:"50%",transform:"translateY(-50%)",fontSize:15,color:"#9A9A9A",pointerEvents:"none"}}>🔍</div>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder={L?"Search salon, cleaning, plumber...":"सेवा खोजें..."}
              style={{width:"100%",padding:"13px 16px 13px 42px",background:"#F4F6FA",border:`1.5px solid ${search?"#0F2D5C":"transparent"}`,borderRadius:15,fontSize:14,color:"#0D0D0D",boxSizing:"border-box",outline:"none",fontWeight:500}}
            />
            {search&&<button onClick={()=>setSearch("")} style={{position:"absolute",right:14,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"#9A9A9A",fontSize:18,cursor:"pointer",lineHeight:1}}>✕</button>}
          </div>
        </div>
        <div style={{display:"flex",gap:8,overflowX:"auto",padding:"0 18px 14px",msOverflowStyle:"none",scrollbarWidth:"none"}}>
          {TABS.map(t=>{
            const on=activeTab===t.id;
            return(
              <button key={t.id} onClick={()=>setActiveTab(t.id)} className="tap"
                style={{flexShrink:0,display:"flex",alignItems:"center",gap:5,padding:"8px 16px",background:on?"#0F2D5C":"#F4F6FA",border:"none",borderRadius:22,color:on?"white":"#545454",fontWeight:700,fontSize:12,cursor:"pointer",transition:"all .2s",boxShadow:on?"0 4px 12px rgba(15,45,92,.3)":"none",whiteSpace:"nowrap"}}>
                <span style={{fontSize:13}}>{t.icon}</span>{t.label}
              </button>
            );
          })}
        </div>
      </div>

      <div style={{padding:"16px 18px 0"}}>
        {/* HERO BANNER */}
        {!search&&(
          <div className="fu" style={{borderRadius:24,overflow:"hidden",marginBottom:20,position:"relative",height:186,boxShadow:"0 12px 40px rgba(15,45,92,.22)"}}>
            <img src="/images/cleaning.jpg"
              alt="cleaning" referrerPolicy="no-referrer" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
            <div style={{position:"absolute",inset:0,background:"linear-gradient(110deg,rgba(10,22,60,.93) 0%,rgba(10,22,60,.55) 55%,rgba(10,22,60,.1) 100%)"}}/>
            <div style={{position:"absolute",inset:0,padding:"22px 22px",display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
              <div>
                <div style={{background:"#FF5722",borderRadius:10,padding:"4px 12px",display:"inline-flex",alignItems:"center",gap:5,marginBottom:12}}>
                  <span style={{fontSize:11}}>🔥</span>
                  <span style={{color:"white",fontSize:10,fontWeight:800,letterSpacing:.6}}>LIMITED TIME OFFER</span>
                </div>
                <div style={{color:"white",fontSize:28,fontWeight:900,lineHeight:1.15,letterSpacing:-.6}}>
                  First Booking<br/><span style={{color:"#FBBF24"}}>30% OFF</span>
                </div>
                <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginTop:5}}>
                  Code <span style={{color:"#FBBF24",fontWeight:800,background:"rgba(251,191,36,.15)",padding:"1px 6px",borderRadius:5}}>GHARPE30</span>
                </div>
              </div>
              <button className="tap" onClick={()=>onBook(SERVICES[0])}
                style={{alignSelf:"flex-start",background:"white",border:"none",borderRadius:14,padding:"10px 22px",color:"#0F2D5C",fontWeight:900,fontSize:13,cursor:"pointer",boxShadow:"0 4px 16px rgba(0,0,0,.25)"}}>
                Book Now →
              </button>
            </div>
          </div>
        )}

        {/* STATS */}
        {!search&&(
          <div className="fu" style={{display:"flex",gap:10,marginBottom:20}}>
            {[["10K+","Bookings","#EFF6FF","#1D4ED8"],["4.8★","Rating","#FEF9C3","#A16207"],["500+","Pros","#DCFCE7","#15803D"],["27","Areas","#F3E8FF","#6D28D9"]].map(([v,l,bg,c])=>(
              <div key={l} style={{flex:1,background:bg,borderRadius:16,padding:"12px 8px",textAlign:"center",border:`1px solid ${c}22`}}>
                <div style={{fontWeight:900,color:c,fontSize:17,letterSpacing:-.3}}>{v}</div>
                <div style={{fontSize:10,color:c,opacity:.75,marginTop:2,fontWeight:700}}>{l}</div>
              </div>
            ))}
          </div>
        )}

        {/* HEADING */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontWeight:900,color:"#0D0D0D",fontSize:18,letterSpacing:-.4}}>
            {search?`"${search}"`:(activeTab==="All"?(L?"All Services":"सभी सेवाएं"):activeTab)}
          </div>
          <span style={{color:"#9A9A9A",fontSize:13}}>{filtered.length} found</span>
        </div>

        {/* SERVICE CARDS */}
        <div style={{display:"flex",flexDirection:"column",gap:18}}>
          {filtered.map((s,i)=>(
            <button key={s.id} onClick={()=>onBook(s)} className="fu tap"
              style={{background:"white",border:"none",borderRadius:26,overflow:"hidden",cursor:"pointer",textAlign:"left",boxShadow:"0 4px 24px rgba(0,0,0,.09)",animationDelay:`${i*50}ms`,display:"block",width:"100%",padding:0}}>
              {/* PHOTO */}
              <div style={{position:"relative",height:176,overflow:"hidden",background:`linear-gradient(135deg,${s.accent}33,${s.bg})`}}>
                <img src={PHOTOS[s.en]||PHOTOS["Cleaning"]} alt={s.en}
                  referrerPolicy="no-referrer"
                  onError={e=>{e.target.style.background=`linear-gradient(135deg,${s.accent}44,${s.bg})`;e.target.style.minHeight="176px";e.target.src="";}}
                  style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(0,0,0,.72) 0%,rgba(0,0,0,.15) 55%,transparent 100%)"}}/>
                {/* TOP LEFT BADGE */}
                <div style={{position:"absolute",top:14,left:14,background:s.accent+"EE",backdropFilter:"blur(8px)",borderRadius:14,padding:"6px 14px",display:"flex",alignItems:"center",gap:6}}>
                  <span style={{fontSize:14}}>{s.icon}</span>
                  <span style={{color:"white",fontSize:12,fontWeight:800}}>{L?s.en:s.hi}</span>
                </div>
                {/* TOP RIGHT RATING */}
                <div style={{position:"absolute",top:14,right:14,background:"rgba(255,255,255,.95)",borderRadius:22,padding:"5px 11px",display:"flex",alignItems:"center",gap:4,boxShadow:"0 2px 8px rgba(0,0,0,.12)"}}>
                  <span style={{color:"#FBBF24",fontSize:13}}>★</span>
                  <span style={{color:"#0D0D0D",fontSize:12,fontWeight:900}}>{s.items[0].r}</span>
                </div>
                {/* BOTTOM INFO */}
                <div style={{position:"absolute",bottom:0,left:0,right:0,padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"flex-end"}}>
                  <span style={{color:"rgba(255,255,255,.75)",fontSize:11,fontWeight:600}}>{s.items.length} services · {s.items[0].t}</span>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"rgba(255,255,255,.6)",fontSize:10}}>from</div>
                    <div style={{color:"white",fontWeight:900,fontSize:22,lineHeight:1}}>₹{s.items[0].p}</div>
                  </div>
                </div>
              </div>
              {/* CARD BODY */}
              <div style={{padding:"14px 16px 0"}}>
                <div style={{fontWeight:900,color:"#0D0D0D",fontSize:16,letterSpacing:-.3}}>{L?s.en:s.hi}</div>
                <div style={{fontSize:12,color:"#9A9A9A",marginTop:4,marginBottom:12}}>{s.sub}</div>
                {/* CHIPS */}
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {s.items.slice(0,3).map(it=>(
                    <div key={it.n} style={{background:s.bg,borderRadius:22,padding:"6px 13px",display:"flex",alignItems:"center",gap:5}}>
                      <span style={{color:s.accent,fontSize:11,fontWeight:800}}>{it.n}</span>
                      <span style={{color:s.accent,fontSize:10,opacity:.75}}>₹{it.p}</span>
                    </div>
                  ))}
                  {s.items.length>3&&<div style={{background:"#F4F6FA",borderRadius:22,padding:"6px 13px"}}><span style={{color:"#9A9A9A",fontSize:11,fontWeight:700}}>+{s.items.length-3}</span></div>}
                </div>
              </div>
              {/* BOOK BUTTON */}
              <div style={{margin:"14px 16px 16px",background:`linear-gradient(135deg,${s.accent}EE,${s.accent})`,borderRadius:16,padding:"13px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",boxShadow:`0 4px 16px ${s.accent}55`}}>
                <div>
                  <div style={{color:"rgba(255,255,255,.75)",fontSize:10,fontWeight:600}}>TAP TO BOOK</div>
                  <div style={{color:"white",fontWeight:900,fontSize:14}}>{L?s.en:s.hi}</div>
                </div>
                <div style={{background:"rgba(255,255,255,.2)",borderRadius:12,padding:"8px 16px",color:"white",fontWeight:800,fontSize:13}}>
                  Book →
                </div>
              </div>
            </button>
          ))}
        </div>
        <div style={{height:24}}/>
      </div>
    </div>
  );
};

const CBookings = ({user,lang,onTrack}) => {
  const [bookings,setBookings] = useState([]);
  const [loading,setLoading]   = useState(true);
  const [tracking,setTracking] = useState(null);
  const [ratingBooking,setRatingBooking] = useState(null);
  const L = lang==="en";

  useEffect(()=>{
    const load = async () => {
      try {
        const phone = (user.phone||"").replace("+91","").trim();
        // Try direct phone filter first
        const { data: direct, error: e1 } = await supabase
          .from("bookings").select("*")
          .eq("customer_phone", phone)
          .order("created_at",{ascending:false});
        
        if(direct && direct.length>0){
          setBookings(direct);
        } else {
          // Try with +91 prefix
          const { data: withPrefix } = await supabase
            .from("bookings").select("*")
            .eq("customer_phone", "+91"+phone)
            .order("created_at",{ascending:false});
          
          if(withPrefix && withPrefix.length>0){
            setBookings(withPrefix);
          } else {
            // Fallback: get all and filter client-side
            const { data: all } = await supabase
              .from("bookings").select("*")
              .order("created_at",{ascending:false}).limit(50);
            const mine = (all||[]).filter(b=>{
              const bp=(b.customer_phone||"").replace("+91","").trim();
              return bp===phone;
            });
            setBookings(mine.length>0?mine:all||[]);
          }
        }
      } catch(e){console.error("Booking fetch error:",e);}
      setLoading(false);
    };
    load();
  },[user.phone]);

  if(tracking) return(
    <div style={{background:D.bg,minHeight:"100vh",paddingBottom:90}}>
      <div style={{background:`linear-gradient(145deg,${D.navy},${D.navyL})`,padding:"52px 16px 24px",borderRadius:"0 0 24px 24px"}}>
        <button onClick={()=>setTracking(null)} style={{background:"rgba(255,255,255,.12)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:16}}>← Back</button>
        <div style={{color:"white",fontWeight:900,fontSize:20}}>Track Order</div>
        <div style={{color:"rgba(255,255,255,.65)",fontSize:13,marginTop:4}}>#{tracking.id}</div>
      </div>
      <div style={{padding:"20px 16px"}}>
        {[
          {label:"Booking Confirmed",desc:"Your booking has been received",done:true,icon:"✅"},
          {label:"Professional Assigned",desc:"Finding best professional for you",done:tracking.status!=="pending",icon:"👨‍🔧"},
          {label:"On the Way",desc:"Professional is heading to your location",done:tracking.status==="in-progress"||tracking.status==="completed",icon:"🛵"},
          {label:"Service Started",desc:"Professional has arrived",done:tracking.status==="completed",icon:"🔧"},
          {label:"Completed",desc:"Service completed successfully",done:tracking.status==="completed",icon:"🎉"},
        ].map((step,i)=>(
          <div key={i} style={{display:"flex",gap:14,marginBottom:8}}>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
              <div style={{width:40,height:40,borderRadius:"50%",background:step.done?D.navy:"white",border:`2px solid ${step.done?D.navy:D.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>
                {step.done?step.icon:<span style={{color:D.muted,fontSize:12}}>{i+1}</span>}
              </div>
              {i<4&&<div style={{width:2,height:28,background:step.done?D.navy:D.border,marginTop:4}}/>}
            </div>
            <div style={{paddingTop:8,paddingBottom:8}}>
              <div style={{fontWeight:700,color:step.done?D.ink:D.muted,fontSize:14}}>{step.label}</div>
              <div style={{fontSize:12,color:D.muted,marginTop:2}}>{step.desc}</div>
            </div>
          </div>
        ))}

        <div style={{background:"white",borderRadius:16,padding:16,marginTop:12,border:`1px solid ${D.border}`}}>
          <div style={{fontWeight:800,color:D.ink,fontSize:14,marginBottom:12}}>Booking Details</div>
          {[["Service",tracking.service_name],["Date",`${tracking.date} at ${tracking.time}`],["Area",tracking.area],["Payment",tracking.payment_status==="paid"?"✅ Paid Online":"💵 Pay after service"]].map(([l,v])=>(
            <div key={l} style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
              <span style={{color:D.muted,fontSize:13}}>{l}</span>
              <span style={{color:D.ink,fontSize:13,fontWeight:600}}>{v}</span>
            </div>
          ))}
          <HR/>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:10}}>
            <span style={{fontWeight:800,color:D.ink}}>Total</span>
            <span style={{fontWeight:900,color:D.navy,fontSize:18}}>₹{tracking.amount}</span>
          </div>
        </div>

        <a href={`https://wa.me/919000000001?text=Hi, help needed for booking #${tracking.id}`}
          style={{display:"flex",alignItems:"center",gap:10,background:"#25D366",borderRadius:14,padding:"13px 16px",marginTop:16,textDecoration:"none"}}>
          <span style={{fontSize:22}}>💬</span>
          <div>
            <div style={{color:"white",fontWeight:700,fontSize:14}}>Need Help?</div>
            <div style={{color:"rgba(255,255,255,.8)",fontSize:12}}>Chat on WhatsApp</div>
          </div>
        </a>
      </div>
    </div>
  );

  return(
    <div style={{background:"#F4F6FA",minHeight:"100vh",paddingBottom:90}}>
      {ratingBooking&&<RatingModal booking={ratingBooking} onClose={()=>setRatingBooking(null)} onSubmit={()=>setRatingBooking(null)}/>}
      <div style={{background:"white",padding:"52px 16px 14px",borderBottom:`1px solid ${D.border}`,position:"sticky",top:0,zIndex:50}}>
        <div style={{fontWeight:900,color:D.ink,fontSize:22,letterSpacing:-.5}}>{L?"My Bookings":"मेरी बुकिंग"}</div>
        <div style={{color:D.muted,fontSize:12,marginTop:2}}>{bookings.length} bookings</div>
      </div>
      <div style={{padding:"16px"}}>
        {loading&&<div style={{textAlign:"center",padding:40,color:D.muted}}>Loading bookings...</div>}
        {!loading&&bookings.length===0&&(
          <div style={{background:"white",borderRadius:16,padding:"40px 20px",textAlign:"center",color:D.muted,border:`1px solid ${D.border}`}}>
            <div style={{fontSize:48,marginBottom:12}}>📋</div>
            <div style={{fontWeight:700,color:D.ink,fontSize:16,marginBottom:8}}>No bookings yet!</div>
            <div>Book your first home service 🏠</div>
          </div>
        )}
        {bookings.map((b,i)=>(
          <div key={b.id} className="fu" style={{background:"white",borderRadius:20,marginBottom:14,border:`1px solid ${D.border}`,overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,.05)",animationDelay:`${i*50}ms`}}>
            <div style={{height:4,background:b.status==="confirmed"?"#22C55E":b.status==="in-progress"?"#F59E0B":b.status==="completed"?"#3B82F6":"#E2E8F0"}}/>
            <div style={{padding:"14px 16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                <span style={{fontWeight:800,color:D.ink,fontSize:15}}>{b.service_name}</span>
                <StatusPill status={b.status}/>
              </div>
              <div style={{background:D.bg,borderRadius:10,padding:"8px 12px",fontSize:12,color:D.sub,marginBottom:10}}>
                📅 {b.date} at {b.time} · 📍 {b.area}
              </div>
              {b.payment_status==="paid"&&<div style={{fontSize:11,color:D.green,fontWeight:700,marginBottom:8}}>✅ Paid Online</div>}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",paddingTop:10,borderTop:`1px solid ${D.border}`}}>
                <div>
                  <div style={{fontSize:12,color:D.muted}}>#{b.id}</div>
                  <div style={{fontWeight:900,color:D.navy,fontSize:17}}>₹{b.amount}</div>
                </div>
                <button onClick={()=>{setTracking(b);if(onTrack)onTrack(b);}} style={{background:D.navyXL,border:`1px solid ${D.navy}22`,borderRadius:10,padding:"8px 14px",color:D.navy,fontWeight:700,fontSize:12,cursor:"pointer"}}>
                  🔍 Track Order
                </button>
              </div>
            </div>
            {b.status==="in-progress"&&(
              <div style={{background:D.navy,padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{color:"white",fontSize:13,fontWeight:600}}>🛵 Professional is on the way!</span>
                <button onClick={()=>{setTracking(b);if(onTrack)onTrack(b);}} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:8,padding:"5px 12px",color:"white",fontWeight:700,fontSize:12,cursor:"pointer"}}>Track</button>
              </div>
            )}
            {b.status==="awaiting-confirmation"&&(
              <div style={{background:"#FFFBEB",padding:"12px 16px",borderTop:"1px solid #FDE68A"}}>
                <div style={{fontSize:12,color:"#92400E",fontWeight:700,marginBottom:8}}>Did the expert complete your service?</div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={async()=>{try{await supabase.from("bookings").update({status:"completed"}).eq("id",b.id);setBookings(prev=>prev.map(x=>x.id===b.id?{...x,status:"completed"}:x));}catch(e){alert("Could not confirm. Please try again.");}}} className="tap"
                    style={{flex:2,padding:"10px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:10,color:"white",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                    ✅ Yes, completed
                  </button>
                  <button onClick={()=>setRatingBooking(b)} className="tap"
                    style={{flex:1,padding:"10px",background:"white",border:"1px solid #E8E8E8",borderRadius:10,color:"#545454",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                    Report issue
                  </button>
                </div>
              </div>
            )}
            {b.status==="completed"&&(
              <div style={{background:"#F4F6FA",padding:"10px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderTop:"1px solid #E8E8E8"}}>
                <span style={{color:"#545454",fontSize:12}}>Rate your experience</span>
                <button onClick={()=>setRatingBooking(b)} className="tap"
                  style={{background:"linear-gradient(135deg,#FBBF24,#F59E0B)",border:"none",borderRadius:10,padding:"6px 14px",color:"#0D0D0D",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                  ⭐ Rate Now
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  WALLET SYSTEM — Customer + Expert + Admin
// ══════════════════════════════════════════════════

// ══════════════════════════════════════════════════
//  CUSTOMER INLINE REGISTRATION
// ══════════════════════════════════════════════════
const CustomerRegisterInline = ({phone, onDone, lang}) => {
  const [name,setName]       = useState("");
  const [area,setArea]       = useState("");
  const [dob,setDob]         = useState("");
  const [gender,setGender]   = useState("");
  const [showArea,setShowArea] = useState(false);
  const [loading,setLoading] = useState(false);
  const L = lang==="en";

  const save = async () => {
    if(!name.trim()){alert("Please enter your name");return;}
    if(!dob){alert("Please select your date of birth");return;}
    if(!gender){alert("Please select your gender");return;}
    if(!area){alert("Please select your area");return;}
    setLoading(true);
    const userData = {phone,name:name.trim(),dob,gender,area,role:"customer",verification_status:"approved",points:100};
    try {
      await supabase.from("users").upsert(userData,{onConflict:"phone"});
    } catch(e){console.error(e);}
    onDone(userData);
    setLoading(false);
  };

  return (
    <div style={{minHeight:"100vh",background:"#F4F6FA",display:"flex",flexDirection:"column"}}>
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 24px 32px",borderRadius:"0 0 32px 32px"}}>
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:60,marginBottom:12}}>👋</div>
          <h1 style={{color:"white",fontWeight:900,fontSize:24,letterSpacing:-.5,marginBottom:8}}>Welcome to GharPe!</h1>
          <p style={{color:"rgba(255,255,255,.7)",fontSize:13}}>Complete your profile to start booking</p>
          <div style={{background:"rgba(255,255,255,.12)",borderRadius:12,padding:"8px 16px",display:"inline-flex",marginTop:12,alignItems:"center",gap:8}}>
            <span style={{fontSize:16}}>🎁</span>
            <span style={{color:"#FBBF24",fontWeight:700,fontSize:13}}>100 Points + 30% OFF first booking!</span>
          </div>
        </div>
      </div>

      <div style={{flex:1,padding:"24px 20px",overflowY:"auto"}}>
        {/* Verified phone */}
        <div style={{background:"#E8EEF8",borderRadius:14,padding:"12px 16px",marginBottom:20,display:"flex",gap:10,alignItems:"center"}}>
          <span style={{fontSize:18}}>📱</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,color:"#545454",fontWeight:600}}>VERIFIED NUMBER</div>
            <div style={{fontWeight:800,color:"#0F2D5C",fontSize:15}}>+91 {phone}</div>
          </div>
          <span style={{color:"#065F46",fontSize:20}}>✅</span>
        </div>

        {/* Name */}
        <div style={{marginBottom:16}}>
          <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Full Name *</div>
          <input value={name} onChange={e=>setName(e.target.value)}
            placeholder="Enter your full name"
            style={{width:"100%",padding:"14px 16px",background:"white",border:`2px solid ${name?"#0F2D5C":"#E8E8E8"}`,borderRadius:14,fontSize:15,fontWeight:600,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
        </div>

        {/* DOB */}
        <div style={{marginBottom:16}}>
          <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Date of Birth *</div>
          <input type="date" value={dob} onChange={e=>setDob(e.target.value)}
            max={new Date(Date.now()-13*365.25*24*3600*1000).toISOString().split("T")[0]}
            style={{width:"100%",padding:"14px 16px",background:"white",border:`2px solid ${dob?"#0F2D5C":"#E8E8E8"}`,borderRadius:14,fontSize:15,color:"#0D0D0D",boxSizing:"border-box",outline:"none"}}/>
        </div>

        {/* Gender */}
        <div style={{marginBottom:16}}>
          <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Gender *</div>
          <select value={gender} onChange={e=>setGender(e.target.value)}
            style={{width:"100%",padding:"14px 16px",background:"white",border:`2px solid ${gender?"#0F2D5C":"#E8E8E8"}`,borderRadius:14,fontSize:15,color:gender?"#0D0D0D":"#9A9A9A",boxSizing:"border-box",outline:"none",appearance:"none"}}>
            <option value="">Select gender</option>
            <option value="Male">👨 Male</option>
            <option value="Female">👩 Female</option>
            <option value="Other">🧑 Other</option>
            <option value="Prefer not to say">🤐 Prefer not to say</option>
          </select>
        </div>

        {/* Area */}
        <div style={{marginBottom:24}}>
          <div style={{fontWeight:700,color:"#545454",fontSize:13,marginBottom:8}}>Your Area in Lucknow *</div>
          <button onClick={()=>setShowArea(!showArea)}
            style={{width:"100%",padding:"14px 16px",background:"white",border:`2px solid ${area?"#0F2D5C":"#E8E8E8"}`,borderRadius:14,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:area?700:400,color:area?"#0D0D0D":"#9A9A9A",fontSize:14}}>{area?`📍 ${area}`:"Select your area"}</span>
            <span style={{color:"#9A9A9A"}}>{showArea?"▲":"▼"}</span>
          </button>
          {showArea&&(
            <div style={{background:"white",border:"1px solid #E8E8E8",borderRadius:14,maxHeight:200,overflowY:"auto",marginTop:8,boxShadow:"0 12px 32px rgba(0,0,0,.12)"}}>
              {AREAS.map(a=>(
                <div key={a} onClick={()=>{setArea(a);setShowArea(false);}}
                  style={{padding:"13px 16px",borderBottom:"1px solid #F4F6FA",cursor:"pointer",fontSize:14,fontWeight:a===area?700:400,color:a===area?"#0F2D5C":"#0D0D0D"}}>
                  📍 {a}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{padding:"16px 20px 36px",background:"white",borderTop:"1px solid #E8E8E8"}}>
        <button onClick={save} disabled={loading} className="tap"
          style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#0F2D5C,#1A4080)",border:"none",borderRadius:18,color:"white",fontWeight:800,fontSize:16,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 8px 24px rgba(15,45,92,.3)"}}>
          {loading?<Spinner/>:"Create My Account 🚀"}
        </button>
        <p style={{textAlign:"center",color:"#9A9A9A",fontSize:11,marginTop:12}}>By creating account you agree to GharPe's Terms & Privacy Policy</p>
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  CUSTOMER ONBOARD (for existing users without name)
// ══════════════════════════════════════════════════
const CustomerOnboard = ({user, onDone}) => {
  const [name,setName] = useState("");
  const [area,setArea] = useState("");
  const [loading,setLoading] = useState(false);
  const [showArea,setShowArea] = useState(false);

  const save = async () => {
    if(!name.trim()||!area){alert("Please fill all fields");return;}
    setLoading(true);
    const updated = {...user,name:name.trim(),area,points:100};
    try{ await supabase.from("users").upsert({...updated},{onConflict:"phone"}); }catch(e){}
    onDone(updated);
    setLoading(false);
  };

  return (
    <div style={{minHeight:"100vh",background:"#F4F6FA",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{fontSize:60,marginBottom:16}}>🏠</div>
      <h2 style={{fontWeight:900,fontSize:22,color:"#0D0D0D",marginBottom:8}}>Complete Your Profile</h2>
      <p style={{color:"#9A9A9A",fontSize:13,marginBottom:24,textAlign:"center"}}>Just 2 quick steps!</p>
      <div style={{width:"100%",maxWidth:360}}>
        <input value={name} onChange={e=>setName(e.target.value)}
          placeholder="Your full name"
          style={{width:"100%",padding:"14px 16px",background:"white",border:"2px solid #E8E8E8",borderRadius:14,fontSize:15,color:"#0D0D0D",boxSizing:"border-box",outline:"none",marginBottom:12}}/>
        <button onClick={()=>setShowArea(!showArea)}
          style={{width:"100%",padding:"14px 16px",background:"white",border:"2px solid #E8E8E8",borderRadius:14,cursor:"pointer",display:"flex",justifyContent:"space-between",marginBottom:showArea?0:16}}>
          <span style={{color:area?"#0D0D0D":"#9A9A9A"}}>{area?`📍 ${area}`:"Select area in Lucknow"}</span>
          <span>▼</span>
        </button>
        {showArea&&(
          <div style={{background:"white",border:"1px solid #E8E8E8",borderRadius:14,maxHeight:180,overflowY:"auto",marginBottom:16,boxShadow:"0 8px 24px rgba(0,0,0,.1)"}}>
            {AREAS.map(a=><div key={a} onClick={()=>{setArea(a);setShowArea(false);}} style={{padding:"12px 16px",borderBottom:"1px solid #F4F6FA",cursor:"pointer",fontSize:14}}>📍 {a}</div>)}
          </div>
        )}
        <button onClick={save} disabled={loading}
          style={{width:"100%",padding:"15px",background:"linear-gradient(135deg,#0F2D5C,#1A4080)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:"pointer"}}>
          {loading?<Spinner/>:"Get Started 🚀"}
        </button>
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  REFER & EARN
// ══════════════════════════════════════════════════
const ReferEarn = ({user, onBack}) => {
  const [copied,setCopied] = useState(false);
  const code = "GHARPE"+(user.phone||"").slice(-4);

  const copy = () => {
    navigator.clipboard.writeText(code).then(()=>{setCopied(true);setTimeout(()=>setCopied(false),2000);});
  };
  const share = () => {
    if(navigator.share) navigator.share({title:"GharPe",text:`Use my code ${code} and get ₹200 off! 🏠`,url:"https://mygharpe.com"});
    else copy();
  };

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh"}}>
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 20px 28px",borderRadius:"0 0 28px 28px"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:16}}>← Back</button>
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:52,marginBottom:8}}>🎁</div>
          <div style={{color:"white",fontWeight:900,fontSize:24}}>Refer & Earn</div>
          <div style={{color:"rgba(255,255,255,.7)",fontSize:13,marginTop:4}}>Earn ₹200 for every friend!</div>
        </div>
      </div>
      <div style={{padding:"20px 16px"}}>
        <div style={{background:"linear-gradient(135deg,#FBBF24,#F59E0B)",borderRadius:20,padding:20,marginBottom:16,textAlign:"center"}}>
          <div style={{fontWeight:600,color:"#78350F",fontSize:12,marginBottom:6,letterSpacing:.5}}>YOUR REFERRAL CODE</div>
          <div style={{fontWeight:900,color:"#0D0D0D",fontSize:34,letterSpacing:3,marginBottom:16}}>{code}</div>
          <div style={{display:"flex",gap:10}}>
            <button onClick={copy} className="tap" style={{flex:1,padding:"12px",background:"white",border:"none",borderRadius:12,color:"#0D0D0D",fontWeight:800,fontSize:13,cursor:"pointer"}}>
              {copied?"✅ Copied!":"📋 Copy"}
            </button>
            <button onClick={share} className="tap" style={{flex:1,padding:"12px",background:"rgba(0,0,0,.12)",border:"none",borderRadius:12,color:"#0D0D0D",fontWeight:800,fontSize:13,cursor:"pointer"}}>
              📤 Share
            </button>
          </div>
        </div>
        {[
          {icon:"📤",title:"Share your code",desc:"Share with friends & family"},
          {icon:"📱",title:"Friend registers",desc:"They sign up using your code"},
          {icon:"💰",title:"Both earn ₹200",desc:"Credit added after first booking"},
        ].map((s,i)=>(
          <div key={i} className="fu" style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:10,display:"flex",gap:14,alignItems:"center",border:"1px solid #E8E8E8",animationDelay:`${i*60}ms`}}>
            <div style={{width:44,height:44,borderRadius:14,background:"#E8EEF8",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>{s.icon}</div>
            <div>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{s.title}</div>
              <div style={{fontSize:12,color:"#9A9A9A",marginTop:2}}>{s.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  HELP SCREEN
// ══════════════════════════════════════════════════
const HelpScreen = ({user, onBack, onChat}) => {
  const [open,setOpen] = useState(null);
  const FAQS = [
    ["How to book a service?","Home → Select service → Choose date & time → Address → Pay"],
    ["Can I cancel my booking?","Free if 2+ hours before. 50% charge within 2 hours."],
    ["What payment methods?","UPI (GPay/PhonePe/Paytm), Card, Net Banking, Cash after service."],
    ["Are professionals verified?","Yes! All experts pass document check + background verification."],
    ["Refund policy?","Online payments: 5-7 working days. Contact us for disputes."],
    ["How to track my order?","My Bookings → Select booking → Track Order button."],
    ["Not satisfied with service?","Contact us within 24 hours for free re-service or refund."],
  ];
  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh",paddingBottom:30}}>
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 20px 28px",borderRadius:"0 0 28px 28px"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:16}}>← Back</button>
        <div style={{color:"white",fontWeight:900,fontSize:22}}>Help & Support</div>
        <div style={{color:"rgba(255,255,255,.65)",fontSize:13,marginTop:4}}>We're here 24/7</div>
      </div>
      <div style={{padding:"20px 16px"}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:20}}>
          {[
            {icon:"🤖",title:"AI Chat",desc:"Instant answers",color:"#6D28D9",bg:"#F3E8FF",action:onChat},
            {icon:"💬",title:"WhatsApp",desc:"+91 9000000001",color:"#065F46",bg:"#ECFDF5",action:()=>window.open("https://wa.me/919000000001")},
            {icon:"📞",title:"Call Us",desc:"+91 9000000001",color:"#1D4ED8",bg:"#EFF6FF",action:()=>window.open("tel:+919000000001")},
            {icon:"📧",title:"Email",desc:"support@mygharpe.com",color:"#DC2626",bg:"#FEE2E2",action:()=>window.open("mailto:support@mygharpe.com")},
          ].map(c=>(
            <button key={c.title} onClick={c.action} className="tap"
              style={{background:c.bg,border:`1px solid ${c.color}22`,borderRadius:18,padding:"16px 12px",cursor:"pointer",textAlign:"left",display:"flex",flexDirection:"column",gap:6}}>
              <span style={{fontSize:26}}>{c.icon}</span>
              <div style={{fontWeight:800,color:c.color,fontSize:14}}>{c.title}</div>
              <div style={{fontSize:10,color:"#9A9A9A"}}>{c.desc}</div>
            </button>
          ))}
        </div>
        <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:12}}>FAQs</div>
        {FAQS.map(([q,a],i)=>(
          <div key={i} style={{background:"white",borderRadius:14,marginBottom:8,border:"1px solid #E8E8E8",overflow:"hidden"}}>
            <button onClick={()=>setOpen(open===i?null:i)}
              style={{width:"100%",padding:"14px 16px",background:"none",border:"none",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",textAlign:"left"}}>
              <span style={{fontWeight:700,color:"#0D0D0D",fontSize:14,flex:1,paddingRight:10}}>{q}</span>
              <span style={{color:"#9A9A9A",fontSize:16,transition:"transform .2s",transform:open===i?"rotate(180deg)":"none"}}>▼</span>
            </button>
            {open===i&&<div style={{padding:"0 16px 14px",fontSize:13,color:"#545454",lineHeight:1.7,borderTop:"1px solid #F4F6FA"}}>{a}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  LIVE TRACKING
// ══════════════════════════════════════════════════
const LiveTracking = ({booking, onBack}) => {
  const [status,setStatus] = useState(booking?.status||"confirmed");
  const [eta,setEta]       = useState(15);
  const [startOtp,setStartOtp] = useState(null);

  useEffect(()=>{
    (async()=>{
      try{
        const {data} = await supabase.from("booking_secrets").select("otp").eq("booking_id",booking.id).single();
        if(data) setStartOtp(data.otp);
      }catch(e){}
    })();
  },[booking.id]);

  useEffect(()=>{
    const poll = setInterval(async()=>{
      try{
        const {data} = await supabase.from("bookings").select("status").eq("id",booking.id).single();
        if(data) setStatus(data.status);
      }catch(e){}
    },10000);
    return ()=>clearInterval(poll);
  },[booking.id]);

  useEffect(()=>{
    if(status==="confirmed"||status==="in-progress"){
      const t=setInterval(()=>setEta(e=>Math.max(1,e-1)),15000);
      return ()=>clearInterval(t);
    }
  },[status]);

  const STEPS=[
    {id:"pending",   icon:"📋",label:"Booking Confirmed",   desc:"Your booking has been received"},
    {id:"confirmed", icon:"👨‍🔧",label:"Expert Assigned",     desc:"Expert is preparing to come"},
    {id:"in-progress",icon:"🛵",label:"Expert On the Way",   desc:`ETA: ${eta} minutes`},
    {id:"arrived",   icon:"🏠",label:"Expert Arrived",      desc:"Expert is at your location"},
    {id:"completed", icon:"✅",label:"Service Completed",   desc:"Job done! Rate your experience"},
  ];
  const activeIdx = Math.max(0,STEPS.findIndex(s=>s.id===status));

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh"}}>
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 20px 24px",borderRadius:"0 0 28px 28px"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:16}}>← Back</button>
        <div style={{color:"white",fontWeight:900,fontSize:20}}>Track Order</div>
        <div style={{color:"rgba(255,255,255,.65)",fontSize:13}}>#{booking.id}</div>
      </div>
      <div style={{padding:"20px 16px"}}>
        {/* Map placeholder */}
        <div style={{background:"white",borderRadius:20,overflow:"hidden",marginBottom:16,border:"1px solid #E8E8E8",height:180,display:"flex",alignItems:"center",justifyContent:"center",position:"relative"}}>
          <div style={{position:"absolute",inset:0,background:"linear-gradient(135deg,#E8EEF8,#C7D7F5)",opacity:.5}}/>
          {[...Array(5)].map((_,i)=><div key={i} style={{position:"absolute",left:0,right:0,top:`${i*25}%`,height:1,background:"#9A9A9A",opacity:.2}}/>)}
          {[...Array(5)].map((_,i)=><div key={i} style={{position:"absolute",top:0,bottom:0,left:`${i*25}%`,width:1,background:"#9A9A9A",opacity:.2}}/>)}
          <div style={{textAlign:"center",position:"relative",zIndex:1}}>
            <div style={{fontSize:48,marginBottom:8}}>{status==="in-progress"?"🛵":status==="completed"?"✅":"👨‍🔧"}</div>
            <div style={{fontWeight:700,color:"#0F2D5C",fontSize:14}}>{status==="in-progress"?`Expert arriving in ${eta} min`:status==="completed"?"Service Completed!":"Locating expert..."}</div>
          </div>
        </div>

        {startOtp && status!=="completed" && status!=="in-progress" && (
          <div style={{background:"linear-gradient(135deg,#0F2D5C,#1A4080)",borderRadius:18,padding:20,color:"white",textAlign:"center",marginBottom:16}}>
            <div style={{fontSize:13,opacity:.7,marginBottom:8}}>Share this OTP with the expert to START service</div>
            <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:8}}>
              {String(startOtp).split("").map((d,i)=>(
                <div key={i} style={{width:48,height:56,background:"rgba(255,255,255,.15)",borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28,fontWeight:900}}>{d}</div>
              ))}
            </div>
            <div style={{fontSize:11,opacity:.6}}>Do NOT share with anyone else</div>
          </div>
        )}

        {/* Steps */}
        <div style={{background:"white",borderRadius:18,padding:"16px",marginBottom:16,border:"1px solid #E8E8E8"}}>
          {STEPS.map((s,i)=>{
            const done=i<=activeIdx;
            const active=i===activeIdx;
            return(
              <div key={s.id} style={{display:"flex",gap:12,marginBottom:i<STEPS.length-1?4:0}}>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                  <div style={{width:36,height:36,borderRadius:12,background:done?"#0F2D5C":"#F4F6FA",border:`2px solid ${done?"#0F2D5C":"#E8E8E8"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0,boxShadow:active?"0 4px 12px rgba(15,45,92,.3)":"none"}}>
                    {done?s.icon:<span style={{color:"#9A9A9A",fontSize:11}}>{i+1}</span>}
                  </div>
                  {i<STEPS.length-1&&<div style={{width:2,height:24,background:done?"#0F2D5C":"#E8E8E8",margin:"3px 0"}}/>}
                </div>
                <div style={{paddingTop:8,paddingBottom:4}}>
                  <div style={{fontWeight:active?800:done?600:400,color:done?"#0D0D0D":"#9A9A9A",fontSize:13}}>{s.label}</div>
                  {active&&<div style={{fontSize:11,color:"#0F2D5C",fontWeight:600,marginTop:1}}>{s.desc}</div>}
                </div>
              </div>
            );
          })}
        </div>

        {/* Booking details */}
        <div style={{background:"white",borderRadius:16,padding:16,marginBottom:12,border:"1px solid #E8E8E8"}}>
          {[["🛠️","Service",booking.service_name],["📅","Date",`${booking.date} at ${booking.time}`],["📍","Area",booking.area],["💰","Amount","₹"+booking.amount]].map(([ic,l,v])=>(
            <div key={l} style={{display:"flex",gap:10,padding:"7px 0",borderBottom:"1px solid #F4F6FA",alignItems:"center"}}>
              <span style={{fontSize:15,width:20}}>{ic}</span>
              <span style={{color:"#9A9A9A",fontSize:12,width:55,flexShrink:0}}>{l}</span>
              <span style={{color:"#0D0D0D",fontSize:13,fontWeight:600}}>{v}</span>
            </div>
          ))}
        </div>

        <a href="https://wa.me/919000000001" style={{display:"flex",alignItems:"center",gap:12,background:"#25D366",borderRadius:16,padding:"14px 18px",textDecoration:"none"}}>
          <span style={{fontSize:24}}>💬</span>
          <div>
            <div style={{color:"white",fontWeight:700,fontSize:14}}>Need Help?</div>
            <div style={{color:"rgba(255,255,255,.8)",fontSize:12}}>WhatsApp support</div>
          </div>
        </a>
      </div>
    </div>
  );
};


const WalletScreen = ({user, lang, onBack}) => {
  const [transactions,setTransactions] = useState([]);
  const [balance,setBalance]           = useState(0);
  const [loading,setLoading]           = useState(true);
  const [withdrawAmt,setWithdrawAmt]   = useState("");
  const [showWithdraw,setShowWithdraw] = useState(false);
  const [withdrawLoading,setWithdrawLoading] = useState(false);
  const [withdrawDone,setWithdrawDone] = useState(false);
  const [proData,setProData]           = useState(null);
  const L = lang==="en";
  const isExpert = user.role==="expert"||user.role==="pro";

  useEffect(()=>{
    const load = async () => {
      try {
        if(isExpert){
          const {data:pro} = await supabase.from("professionals")
            .select("earnings,pending_payout,bank_account,bank_name,bank_ifsc,bank_holder")
            .eq("phone",user.phone).single();
          if(pro){ setProData(pro); setBalance(pro.earnings||0); }
        }
        if(isExpert){
          // Expert sees jobs assigned to them
          const {data:txns} = await supabase.from("bookings")
            .select("*").eq("pro_phone",user.phone)
            .order("created_at",{ascending:false}).limit(20);
          setTransactions(txns||[]);
        } else {
          // Customer sees their own bookings
          const phone = (user.phone||"").replace("+91","").trim();
          const {data:txns} = await supabase.from("bookings")
            .select("*").eq("customer_phone",phone)
            .order("created_at",{ascending:false}).limit(20);
          setTransactions(txns||[]);
        }
      } catch(e){ console.error(e); }
      setLoading(false);
    };
    load();
  },[user.phone]);

  const handleWithdraw = async () => {
    const amt = Number(withdrawAmt);
    if(!amt||amt<100){ alert("Minimum withdrawal is ₹100"); return; }
    setWithdrawLoading(true);
    try {
      // The SERVER validates the amount against real earnings (HIGH-2 fix).
      const { data:{ session } } = await supabase.auth.getSession();
      const res = await fetch("https://lwwygijjslkezxpycpgn.supabase.co/functions/v1/request-withdrawal", {
        method:"POST",
        headers:{ "Content-Type":"application/json", Authorization:"Bearer "+(session?.access_token||"sb_publishable_Ep4nBdwjVDJRYEPx3XTv2Q_DEXrwFJb") },
        body: JSON.stringify({ amount: amt }),
      });
      const r = await res.json();
      if(!res.ok) throw new Error(r.error||"Withdrawal failed");
      setWithdrawDone(true);
      setShowWithdraw(false);
      alert("✅ Withdrawal request submitted! Transfer in 2-3 working days.");
    } catch(e){ alert(e.message||"Could not submit withdrawal. Please try again."); }
    setWithdrawLoading(false);
  };

  const expertEarned = Math.round(balance*.8);
  const platformCut  = Math.round(balance*.2);

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh",paddingBottom:30}}>
      {/* Header */}
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 20px 28px",borderRadius:"0 0 28px 28px"}}>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
          <button onClick={onBack} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer"}}>← Back</button>
          <div style={{color:"white",fontWeight:900,fontSize:18}}>
            {isExpert?"My Earnings":"Booking History"}
          </div>
        </div>

        {/* Balance */}
        <div style={{background:"rgba(255,255,255,.12)",borderRadius:20,padding:20,border:"1px solid rgba(255,255,255,.15)"}}>
          <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginBottom:6}}>
            {isExpert?"Total Earnings":"Total Spent"}
          </div>
          <div style={{color:"white",fontSize:38,fontWeight:900,letterSpacing:-1}}>₹{balance.toLocaleString()}</div>
          {isExpert&&proData?.pending_payout>0&&(
            <div style={{color:"#FBBF24",fontSize:13,marginTop:6,fontWeight:600}}>
              ⏳ ₹{proData.pending_payout} pending transfer
            </div>
          )}
        </div>

        {/* Stats */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginTop:12}}>
          {(isExpert?[
            {v:"₹"+expertEarned.toLocaleString(),l:"Your Share"},
            {v:"₹"+platformCut.toLocaleString(),l:"Platform Fee"},
            {v:transactions.filter(t=>t.status==="completed").length+"",l:"Jobs Done"},
          ]:[
            {v:transactions.length+"",l:"Bookings"},
            {v:"₹0",l:"Saved"},
            {v:"0",l:"Points"},
          ]).map(({v,l})=>(
            <div key={l} style={{background:"rgba(255,255,255,.1)",borderRadius:14,padding:"12px 8px",textAlign:"center"}}>
              <div style={{color:"white",fontWeight:900,fontSize:16}}>{v}</div>
              <div style={{color:"rgba(255,255,255,.6)",fontSize:10,marginTop:2}}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{padding:"20px 16px"}}>
        {/* Payment flow - only show for experts */}
        {isExpert&&(
        <div style={{background:"white",borderRadius:18,padding:16,marginBottom:16,border:"1px solid #E8E8E8"}}>
          <div style={{fontWeight:800,color:"#0D0D0D",fontSize:14,marginBottom:12}}>💸 Earnings Breakdown</div>
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {[
              {l:"Total Booking Value",v:"₹"+balance.toLocaleString(),c:"#0F2D5C",bg:"#E8EEF8"},
              {l:"Platform Commission (20%)",v:"- ₹"+platformCut.toLocaleString(),c:"#DC2626",bg:"#FEE2E2"},
              {l:"Your Earnings (80%)",v:"₹"+expertEarned.toLocaleString(),c:"#065F46",bg:"#ECFDF5"},
            ].map(item=>(
              <div key={item.l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:item.bg,borderRadius:10,padding:"10px 14px"}}>
                <span style={{fontSize:12,color:"#545454",fontWeight:600}}>{item.l}</span>
                <span style={{fontSize:14,fontWeight:800,color:item.c}}>{item.v}</span>
              </div>
            ))}
          </div>
        </div>
        )}

        {/* Bank details for expert */}
        {isExpert&&proData&&(
          <div style={{background:"white",borderRadius:16,padding:16,marginBottom:16,border:"1px solid #E8E8E8"}}>
            <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14,marginBottom:10}}>🏦 Bank Account</div>
            {[
              ["Account Holder",proData.bank_holder||user.name],
              ["Account No","XXXX"+String(proData.bank_account||"").slice(-4)],
              ["IFSC",proData.bank_ifsc||"—"],
              ["Bank",proData.bank_name||"—"],
            ].map(([l,v])=>(
              <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid #F4F6FA"}}>
                <span style={{color:"#9A9A9A",fontSize:13}}>{l}</span>
                <span style={{fontWeight:700,color:"#0D0D0D",fontSize:13}}>{v}</span>
              </div>
            ))}
          </div>
        )}

        {/* Withdraw button */}
        {isExpert&&!withdrawDone&&(
          <button onClick={()=>setShowWithdraw(true)} className="tap"
            style={{width:"100%",padding:"15px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:"pointer",marginBottom:16,boxShadow:"0 8px 24px rgba(6,95,70,.3)"}}>
            💸 Withdraw to Bank Account
          </button>
        )}
        {withdrawDone&&(
          <div style={{background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:14,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontWeight:700,color:"#065F46",fontSize:13}}>✅ Withdrawal Requested!</div>
            <div style={{fontSize:12,color:"#065F46",marginTop:4}}>Bank transfer in 2-3 working days to {proData?.bank_name}</div>
          </div>
        )}

        {/* Transactions */}
        <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:14}}>Transaction History</div>
        {loading&&<div style={{textAlign:"center",padding:30,color:"#9A9A9A"}}>Loading...</div>}
        {!loading&&transactions.length===0&&(
          <div style={{background:"white",borderRadius:16,padding:"32px 20px",textAlign:"center",color:"#9A9A9A",border:"1px solid #E8E8E8"}}>
            <div style={{fontSize:40,marginBottom:10}}>💳</div>
            <div style={{fontWeight:700,color:"#0D0D0D",fontSize:15}}>No transactions yet</div>
          </div>
        )}
        {transactions.map((t,i)=>{
          const amt = isExpert?Math.round((t.amount||0)*.8):(t.amount||0);
          const isPaid = t.payment_status==="paid";
          const isOnline = t.payment_method==="online"||t.payment_method==="upi"||t.payment_method==="card";
          const isCash = t.payment_method==="cash";
          const methodIcon = isOnline?"💳":isCash?"💵":"💰";
          const methodLabel = isOnline?"Paid via UPI/Card":isCash?"Pay by Cash":"Payment Pending";
          const statusColor = isPaid?"#065F46":isCash&&t.status==="completed"?"#A16207":"#DC2626";
          const statusLabel = isPaid?"✅ Paid Online":isCash&&t.status==="completed"?"💵 Cash Collected":isCash?"💵 Cash on Delivery":"⏳ Pending";
          return(
            <div key={t.id} className="fu" style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:10,border:`1px solid ${isPaid?"#BBF7D0":isCash?"#FDE68A":"#E8E8E8"}`,display:"flex",gap:12,alignItems:"center",animationDelay:`${i*40}ms`}}>
              <div style={{width:44,height:44,borderRadius:14,background:isPaid?"#ECFDF5":isCash?"#FEF9C3":"#F4F6FA",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>
                {methodIcon}
              </div>
              <div style={{flex:1}}>
                <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13}}>{t.service_name}</div>
                <div style={{fontSize:11,color:"#9A9A9A",marginTop:2}}>{t.date} · {t.area} · #{t.id}</div>
                <div style={{fontSize:10,color:"#9A9A9A",marginTop:1}}>{methodLabel}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontWeight:900,color:isExpert?"#065F46":"#0F2D5C",fontSize:16}}>
                  {isExpert?"+":"-"}₹{amt}
                </div>
                <div style={{fontSize:10,fontWeight:700,color:statusColor,marginTop:2}}>
                  {statusLabel}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Withdraw Modal */}
      {showWithdraw&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:999,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={()=>setShowWithdraw(false)}>
          <div style={{background:"white",borderRadius:"28px 28px 0 0",padding:"24px 20px 40px",width:"100%",maxWidth:430}} onClick={e=>e.stopPropagation()}>
            <div style={{width:40,height:4,background:"#E8E8E8",borderRadius:4,margin:"0 auto 20px"}}/>
            <div style={{fontWeight:900,color:"#0D0D0D",fontSize:20,marginBottom:4}}>Withdraw Money</div>
            <div style={{color:"#9A9A9A",fontSize:13,marginBottom:6}}>Available balance: <b style={{color:"#065F46"}}>₹{balance.toLocaleString()}</b></div>
            {proData&&(
              <div style={{background:"#ECFDF5",borderRadius:12,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#065F46"}}>
                🏦 Transfer to: {proData.bank_name} · XXXX{String(proData.bank_account||"").slice(-4)}
              </div>
            )}
            <div style={{background:"#F4F6FA",borderRadius:14,display:"flex",alignItems:"center",marginBottom:8,border:"1.5px solid #E8E8E8",overflow:"hidden"}}>
              <span style={{padding:"0 16px",fontSize:20,fontWeight:700,color:"#0D0D0D"}}>₹</span>
              <input type="number" value={withdrawAmt} onChange={e=>setWithdrawAmt(e.target.value)}
                placeholder="Enter amount"
                style={{flex:1,border:"none",background:"transparent",padding:"16px 0",fontSize:24,fontWeight:900,color:"#0D0D0D",outline:"none"}}/>
            </div>
            <div style={{display:"flex",gap:8,marginBottom:16}}>
              {[100,500,1000].map(amt=>(
                <button key={amt} onClick={()=>setWithdrawAmt(String(amt))}
                  style={{flex:1,padding:"8px",background:"#F4F6FA",border:"1.5px solid #E8E8E8",borderRadius:10,color:"#0D0D0D",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                  ₹{amt}
                </button>
              ))}
              <button onClick={()=>setWithdrawAmt(String(balance))}
                style={{flex:1,padding:"8px",background:"#ECFDF5",border:"1.5px solid #6EE7B7",borderRadius:10,color:"#065F46",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                All
              </button>
            </div>
            <div style={{fontSize:11,color:"#9A9A9A",marginBottom:20}}>Min ₹100 · Transfer in 2-3 working days</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setShowWithdraw(false)} style={{flex:1,padding:"14px",background:"#F4F6FA",border:"none",borderRadius:14,color:"#545454",fontWeight:700,cursor:"pointer"}}>Cancel</button>
              <button onClick={handleWithdraw} disabled={withdrawLoading} className="tap"
                style={{flex:2,padding:"14px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:14,color:"white",fontWeight:800,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                {withdrawLoading?<Spinner/>:"💸 Request Transfer"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const RatingModal = ({booking, onClose, onSubmit}) => {
  const [rating, setRating]   = useState(0);
  const [hovered, setHovered] = useState(0);
  const [review, setReview]   = useState("");
  const [photos, setPhotos]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(false);

  const handleSubmit = async () => {
    if(rating===0){ alert("Please select a rating"); return; }
    setLoading(true);
    try {
      await supabase.from("reviews").insert({
        booking_id: booking.id,
        customer_phone: booking.customer_phone,
        pro_phone: booking.pro_phone||"",
        service_name: booking.service_name,
        rating,
        review,
        created_at: new Date().toISOString(),
      });
      // Update professional average rating
      if(booking.pro_phone) {
        const { data: allReviews } = await supabase
          .from("reviews").select("rating").eq("pro_phone", booking.pro_phone);
        if(allReviews&&allReviews.length>0) {
          const avg = allReviews.reduce((s,r)=>s+r.rating,0)/allReviews.length;
          await supabase.from("professionals")
            .update({rating: Math.round(avg*10)/10, jobs_done: allReviews.length})
            .eq("phone", booking.pro_phone);
        }
      }
      setDone(true);
    } catch(e) {
      console.error(e);
      setDone(true); // show success anyway
    }
    setLoading(false);
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={onClose}>
      <div className="su" style={{background:"white",borderRadius:"28px 28px 0 0",padding:"24px 20px 40px",width:"100%",maxWidth:430}} onClick={e=>e.stopPropagation()}>
        <div style={{width:40,height:4,background:"#E8E8E8",borderRadius:4,margin:"0 auto 20px"}}/>

        {done?(
          <div style={{textAlign:"center",padding:"20px 0"}}>
            <div style={{fontSize:60,marginBottom:16}}>🌟</div>
            <div style={{fontWeight:900,color:"#0D0D0D",fontSize:22,marginBottom:8}}>Thank You!</div>
            <div style={{color:"#9A9A9A",fontSize:14,marginBottom:24}}>Your review helps others choose better!</div>
            <button onClick={onClose} className="tap"
              style={{padding:"14px 40px",background:"linear-gradient(135deg,#0F2D5C,#1A4080)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:"pointer"}}>
              Done ✓
            </button>
          </div>
        ):(
          <>
            <div style={{fontWeight:900,color:"#0D0D0D",fontSize:20,marginBottom:4}}>Rate Your Experience</div>
            <div style={{color:"#9A9A9A",fontSize:13,marginBottom:24}}>{booking.service_name} · #{booking.id}</div>

            {/* Star rating */}
            <div style={{textAlign:"center",marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:8}}>
                {[1,2,3,4,5].map(s=>(
                  <button key={s}
                    onMouseEnter={()=>setHovered(s)}
                    onMouseLeave={()=>setHovered(0)}
                    onClick={()=>setRating(s)}
                    style={{background:"none",border:"none",cursor:"pointer",padding:0,transition:"transform .1s",transform:(hovered||rating)>=s?"scale(1.2)":"scale(1)"}}>
                    <span style={{fontSize:40,color:(hovered||rating)>=s?"#FBBF24":"#E8E8E8",transition:"color .1s"}}>★</span>
                  </button>
                ))}
              </div>
              <div style={{fontSize:14,fontWeight:600,color:"#545454"}}>
                {rating===0?"Tap to rate":[,"Poor","Fair","Good","Very Good","Excellent!"][rating]}
              </div>
            </div>

            {/* Written review */}
            <div style={{marginBottom:16}}>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:8}}>Write a Review (Optional)</div>
              <textarea value={review} onChange={e=>setReview(e.target.value)}
                placeholder="How was your experience? What did you like or dislike?"
                style={{width:"100%",padding:"13px 16px",background:"#F4F6FA",border:"1.5px solid #E8E8E8",borderRadius:14,fontSize:14,resize:"none",height:90,boxSizing:"border-box",outline:"none",color:"#0D0D0D",lineHeight:1.5}}
              />
            </div>

            {/* Photo upload */}
            <div style={{marginBottom:20}}>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:8}}>Add Photos (Optional)</div>
              <div style={{display:"flex",gap:8}}>
                {photos.map((p,i)=>(
                  <div key={i} style={{position:"relative",width:64,height:64}}>
                    <img src={p} alt="" style={{width:64,height:64,borderRadius:10,objectFit:"cover"}}/>
                    <button onClick={()=>setPhotos(prev=>prev.filter((_,j)=>j!==i))}
                      style={{position:"absolute",top:-6,right:-6,width:18,height:18,borderRadius:"50%",background:"#DC2626",border:"none",color:"white",fontSize:10,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                  </div>
                ))}
                {photos.length<3&&(
                  <label style={{width:64,height:64,borderRadius:10,border:"2px dashed #E8E8E8",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",background:"#F4F6FA"}}>
                    <span style={{fontSize:20}}>📷</span>
                    <input type="file" accept="image/*" style={{display:"none"}}
                      onChange={e=>{
                        const file=e.target.files[0];
                        if(file){const r=new FileReader();r.onload=ev=>setPhotos(p=>[...p,ev.target.result]);r.readAsDataURL(file);}
                      }}/>
                  </label>
                )}
              </div>
            </div>

            <button onClick={handleSubmit} disabled={loading||rating===0} className="tap"
              style={{width:"100%",padding:"16px",background:rating>0?"linear-gradient(135deg,#FBBF24,#F59E0B)":"#D1D5DB",border:"none",borderRadius:16,color:rating>0?"#0D0D0D":"white",fontWeight:800,fontSize:16,cursor:rating>0?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              {loading?<Spinner/>:"Submit Review ⭐"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

// Reviews display component
const ReviewsList = ({proPhone, onClose}) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats]     = useState({avg:0,total:0,dist:{5:0,4:0,3:0,2:0,1:0}});

  useEffect(()=>{
    const load = async () => {
      try {
        const { data } = await supabase.from("reviews").select("*")
          .eq("pro_phone", proPhone).order("created_at",{ascending:false});
        const r = data||[];
        setReviews(r);
        if(r.length>0){
          const avg = r.reduce((s,x)=>s+x.rating,0)/r.length;
          const dist = {5:0,4:0,3:0,2:0,1:0};
          r.forEach(x=>dist[x.rating]=(dist[x.rating]||0)+1);
          setStats({avg:Math.round(avg*10)/10,total:r.length,dist});
        }
      } catch(e){ console.error(e); }
      setLoading(false);
    };
    load();
  },[proPhone]);

  return (
    <div style={{position:"fixed",inset:0,background:"white",zIndex:999,overflowY:"auto"}}>
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 20px 28px"}}>
        <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer",marginBottom:16}}>← Back</button>
        <div style={{color:"white",fontWeight:900,fontSize:20,marginBottom:16}}>Ratings & Reviews</div>
        <div style={{display:"flex",gap:16,alignItems:"center"}}>
          <div style={{textAlign:"center"}}>
            <div style={{color:"#FBBF24",fontSize:48,fontWeight:900,lineHeight:1}}>{stats.avg||"—"}</div>
            <div style={{display:"flex",gap:2,justifyContent:"center",margin:"6px 0"}}>
              {[1,2,3,4,5].map(s=><span key={s} style={{color:s<=Math.round(stats.avg)?"#FBBF24":"rgba(255,255,255,.3)",fontSize:16}}>★</span>)}
            </div>
            <div style={{color:"rgba(255,255,255,.65)",fontSize:12}}>{stats.total} reviews</div>
          </div>
          <div style={{flex:1}}>
            {[5,4,3,2,1].map(s=>{
              const pct = stats.total>0?(stats.dist[s]||0)/stats.total*100:0;
              return(
                <div key={s} style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                  <span style={{color:"rgba(255,255,255,.7)",fontSize:11,width:8}}>{s}</span>
                  <span style={{color:"#FBBF24",fontSize:11}}>★</span>
                  <div style={{flex:1,height:4,background:"rgba(255,255,255,.2)",borderRadius:4}}>
                    <div style={{width:`${pct}%`,height:"100%",background:"#FBBF24",borderRadius:4,transition:"width .5s"}}/>
                  </div>
                  <span style={{color:"rgba(255,255,255,.5)",fontSize:10,width:20}}>{stats.dist[s]||0}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div style={{padding:"16px"}}>
        {loading&&<div style={{textAlign:"center",padding:40,color:"#9A9A9A"}}>Loading reviews...</div>}
        {!loading&&reviews.length===0&&(
          <div style={{textAlign:"center",padding:40,color:"#9A9A9A"}}>
            <div style={{fontSize:40,marginBottom:10}}>⭐</div>
            <div style={{fontWeight:700,color:"#0D0D0D",fontSize:15}}>No reviews yet</div>
          </div>
        )}
        {reviews.map((r,i)=>(
          <div key={r.id||i} className="fu" style={{background:"white",borderRadius:16,padding:"16px",marginBottom:12,border:"1px solid #E8E8E8",boxShadow:"0 2px 8px rgba(0,0,0,.04)",animationDelay:`${i*40}ms`}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{width:36,height:36,borderRadius:12,background:"#E8EEF8",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#0F2D5C",fontSize:14}}>
                  {(r.customer_phone||"C").slice(-1)}
                </div>
                <div>
                  <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13}}>Customer ****{r.customer_phone?.slice(-4)}</div>
                  <div style={{fontSize:11,color:"#9A9A9A"}}>{r.service_name}</div>
                </div>
              </div>
              <div style={{display:"flex",gap:1}}>
                {[1,2,3,4,5].map(s=><span key={s} style={{color:s<=r.rating?"#FBBF24":"#E8E8E8",fontSize:14}}>★</span>)}
              </div>
            </div>
            {r.review&&<div style={{fontSize:13,color:"#545454",lineHeight:1.6}}>{r.review}</div>}
            <div style={{fontSize:11,color:"#9A9A9A",marginTop:8}}>
              {new Date(r.created_at).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  AI CHATBOT SUPPORT — Powered by Claude AI
// ══════════════════════════════════════════════════
const ChatSupport = ({user, onClose}) => {
  const [messages, setMessages] = useState([
    {role:"assistant", content:"Namaste! 🙏 Main GharPe ka AI assistant hoon. Main aapki kaise madad kar sakta hoon?\n\nHello! I'm GharPe's AI assistant. How can I help you today?", time: new Date()}
  ]);
  const [input, setInput]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [escalated, setEscalated] = useState(false);
  const [ticketId, setTicketId] = useState(null);
  const messagesEndRef           = useRef(null);

  useEffect(()=>{
    messagesEndRef.current?.scrollIntoView({behavior:"smooth"});
  },[messages]);

  const QUICK_REPLIES = [
    "How to book a service?",
    "Track my order",
    "Payment issue",
    "Cancel booking",
    "Refund policy",
    "Talk to human",
  ];

  const sendMessage = async (text) => {
    const msg = text || input.trim();
    if(!msg) return;
    setInput("");

    // Add user message
    const userMsg = {role:"user", content:msg, time:new Date()};
    setMessages(prev=>[...prev, userMsg]);
    setLoading(true);

    // Check for escalation request
    if(msg.toLowerCase().includes("human") || msg.toLowerCase().includes("agent") || msg.toLowerCase().includes("support")) {
      setTimeout(async()=>{
        const tid = "TKT"+Math.floor(Date.now()/1000);
        setTicketId(tid);
        setEscalated(true);
        try {
          await supabase.from("support_tickets").insert({
            id: tid,
            customer_phone: user.phone,
            customer_name: user.name||"Customer",
            issue: msg,
            status: "open",
            priority: "normal",
            conversation: JSON.stringify([...messages,{role:"user",content:msg}]),
            created_at: new Date().toISOString(),
          });
        } catch(e){ console.error("ticket save error:",e); }
        setMessages(prev=>[...prev,{
          role:"assistant",
          content:`I'm connecting you to a human support agent now. 🧑‍💼\n\n**Ticket ID: ${tid}**\n\nOur team will contact you on +91 ${user.phone} within 30 minutes.\n\nWorking hours: 9 AM - 9 PM daily`,
          time:new Date(),
          isEscalation:true
        }]);
        setLoading(false);
      },1000);
      return;
    }

    try {
      // Call Claude AI API
      const response = await fetch("https://api.anthropic.com/v1/messages", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:1000,
          system:`You are GharPe's friendly AI customer support assistant for a home services app in Lucknow, India. 
GharPe offers: Salon & Beauty, Cleaning, Electrician, Plumbing, AC Service, Carpenter, Pest Control, Painting.
Pricing starts from ₹199. Website: mygharpe.com. WhatsApp: +91 9000000001.
Booking: Select service → Schedule → Pay (UPI/Cash/Card). 
Cancellation: Free before 2 hours of booking. 50% charge within 2 hours.
Refund: Online payments refunded in 5-7 working days.
Payment split: Customer pays → 20% to GharPe → 80% to professional.
The user's phone is: ${user.phone}.
Answer in Hinglish (mix of Hindi and English) to be friendly. Keep responses concise and helpful.
If you cannot resolve after 2 attempts, suggest talking to a human agent.`,
          messages: [...messages, userMsg].map(m=>({role:m.role, content:m.content}))
        })
      });
      const data = await response.json();
      const reply = data.content?.[0]?.text || "Sorry, I couldn't understand. Please try again or type 'human' to talk to our team.";
      setMessages(prev=>[...prev,{role:"assistant",content:reply,time:new Date()}]);
    } catch(e) {
      // Fallback responses
      const fallbacks = {
        "book": "To book a service:\n1. Select a service from home screen\n2. Choose date & time\n3. Enter your address\n4. Pay online or cash\n\nKitna easy hai! 😊",
        "track": "To track your order:\n1. Go to 'My Bookings' tab\n2. Click on your booking\n3. Tap 'Track Order'\n\nYou can also call your professional directly once assigned! 📱",
        "cancel": "Cancellation policy:\n✅ Free if cancelled 2+ hours before\n⚠️ 50% charge within 2 hours\n❌ No cancellation after professional arrives\n\nTo cancel: My Bookings → Select booking → Cancel",
        "refund": "Refund policy:\n• Online payments: 5-7 working days to original account\n• Cash payments: Not applicable\n• Issues? WhatsApp us: +91 9000000001",
        "payment": "We accept:\n💳 UPI (GPay, PhonePe, Paytm)\n💳 Credit/Debit Card\n💵 Cash after service\n\nAll online payments secured by Razorpay 🔒",
        "price": "GharPe pricing:\n💄 Salon from ₹199\n🧹 Cleaning from ₹399\n⚡ Electrician from ₹249\n🔧 Plumbing from ₹299\n❄️ AC Service from ₹699\n\nFirst booking 30% OFF! Code: GHARPE30",
      };
      const key = Object.keys(fallbacks).find(k=>msg.toLowerCase().includes(k));
      const reply = key ? fallbacks[key] : "Main samajh gaya! 😊 For more help, please WhatsApp us at +91 9000000001 or type 'human' to connect with our team.";
      setMessages(prev=>[...prev,{role:"assistant",content:reply,time:new Date()}]);
    }
    setLoading(false);
  };

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString("en-IN",{hour:"2-digit",minute:"2-digit"});
  };

  return (
    <div style={{position:"fixed",inset:0,background:"white",zIndex:9999,display:"flex",flexDirection:"column"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#0F2D5C,#1A4080)",padding:"52px 20px 20px"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 14px",color:"white",fontSize:13,fontWeight:600,cursor:"pointer"}}>← Back</button>
          <div style={{width:44,height:44,borderRadius:15,background:"linear-gradient(135deg,#6D28D9,#7C3AED)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>🤖</div>
          <div style={{flex:1}}>
            <div style={{color:"white",fontWeight:900,fontSize:16}}>GharPe AI Support</div>
            <div style={{display:"flex",alignItems:"center",gap:6,marginTop:2}}>
              <div style={{width:7,height:7,borderRadius:"50%",background:"#4ADE80"}}/>
              <span style={{color:"rgba(255,255,255,.7)",fontSize:11}}>Always online · Powered by Claude AI</span>
            </div>
          </div>
          {ticketId&&(
            <div style={{background:"rgba(255,255,255,.15)",borderRadius:10,padding:"4px 10px"}}>
              <div style={{color:"rgba(255,255,255,.7)",fontSize:9}}>TICKET</div>
              <div style={{color:"#FBBF24",fontWeight:700,fontSize:11}}>{ticketId}</div>
            </div>
          )}
        </div>
      </div>

      {/* Messages */}
      <div style={{flex:1,overflowY:"auto",padding:"16px",background:"#F4F6FA"}}>
        {messages.map((msg,i)=>(
          <div key={i} style={{display:"flex",justifyContent:msg.role==="user"?"flex-end":"flex-start",marginBottom:12}}>
            {msg.role==="assistant"&&(
              <div style={{width:32,height:32,borderRadius:11,background:"linear-gradient(135deg,#6D28D9,#7C3AED)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0,marginRight:8,marginTop:4}}>🤖</div>
            )}
            <div style={{maxWidth:"78%"}}>
              <div style={{
                background:msg.role==="user"?"linear-gradient(135deg,#0F2D5C,#1A4080)":"white",
                color:msg.role==="user"?"white":"#0D0D0D",
                borderRadius:msg.role==="user"?"18px 18px 4px 18px":"18px 18px 18px 4px",
                padding:"12px 16px",
                fontSize:14,lineHeight:1.6,
                border:msg.isEscalation?"2px solid #6D28D9":"none",
                boxShadow:"0 2px 8px rgba(0,0,0,.08)",
                whiteSpace:"pre-line"
              }}>
                {msg.isEscalation&&<div style={{color:"#6D28D9",fontWeight:700,fontSize:12,marginBottom:6}}>🧑‍💼 CONNECTED TO HUMAN SUPPORT</div>}
                {msg.content}
              </div>
              <div style={{fontSize:10,color:"#9A9A9A",marginTop:4,textAlign:msg.role==="user"?"right":"left"}}>
                {formatTime(msg.time)}
              </div>
            </div>
          </div>
        ))}
        {loading&&(
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
            <div style={{width:32,height:32,borderRadius:11,background:"linear-gradient(135deg,#6D28D9,#7C3AED)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>🤖</div>
            <div style={{background:"white",borderRadius:"18px 18px 18px 4px",padding:"14px 18px",boxShadow:"0 2px 8px rgba(0,0,0,.08)",display:"flex",gap:5,alignItems:"center"}}>
              {[0,1,2].map(i=><div key={i} style={{width:7,height:7,borderRadius:"50%",background:"#9A9A9A",animation:`pulse 1.2s ${i*.2}s infinite`}}/>)}
            </div>
          </div>
        )}
        <div ref={messagesEndRef}/>
      </div>

      {/* Quick replies */}
      {messages.length<=2&&(
        <div style={{padding:"8px 16px",background:"white",borderTop:"1px solid #E8E8E8"}}>
          <div style={{fontSize:11,color:"#9A9A9A",marginBottom:8,fontWeight:600}}>QUICK REPLIES</div>
          <div style={{display:"flex",gap:8,overflowX:"auto",scrollbarWidth:"none",paddingBottom:4}}>
            {QUICK_REPLIES.map(q=>(
              <button key={q} onClick={()=>sendMessage(q)} className="tap"
                style={{flexShrink:0,padding:"8px 14px",background:"#F4F6FA",border:"1px solid #E8E8E8",borderRadius:20,color:"#0F2D5C",fontWeight:600,fontSize:12,cursor:"pointer",whiteSpace:"nowrap"}}>
                {q}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Input */}
      <div style={{padding:"12px 16px 28px",background:"white",borderTop:"1px solid #E8E8E8",display:"flex",gap:10,alignItems:"flex-end"}}>
        <div style={{flex:1,background:"#F4F6FA",borderRadius:20,padding:"10px 16px",border:"1.5px solid #E8E8E8",display:"flex",alignItems:"center"}}>
          <input value={input} onChange={e=>setInput(e.target.value)}
            onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendMessage();}}}
            placeholder="Type your message..."
            style={{flex:1,border:"none",background:"transparent",fontSize:14,color:"#0D0D0D",outline:"none"}}
          />
        </div>
        <button onClick={()=>sendMessage()} disabled={!input.trim()||loading} className="tap"
          style={{width:46,height:46,borderRadius:16,background:input.trim()?"linear-gradient(135deg,#0F2D5C,#1A4080)":"#E8E8E8",border:"none",cursor:input.trim()?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0,boxShadow:input.trim()?"0 4px 12px rgba(15,45,92,.3)":"none",transition:"all .2s"}}>
          {loading?"⏳":"➤"}
        </button>
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  FULL ADMIN DASHBOARD
// ══════════════════════════════════════════════════
// ══════════════════════════════════════════════════
//  FULL ADMIN DASHBOARD v2.0
// ══════════════════════════════════════════════════
const ExpertDetailModal = ({expert: initialExpert, onClose, onUpdate}) => {
  const [expert, setExpert]   = useState(initialExpert);
  const [activeTab, setActiveTab] = useState("personal");
  const [note, setNote]           = useState("");
  const [loading, setLoading]     = useState(false);
  const [fetching, setFetching]   = useState(true);
  const [showNoteInput, setShowNoteInput] = useState(null);

  // Always fetch fresh data from Supabase when modal opens
  useEffect(()=>{
    const fetchFresh = async () => {
      setFetching(true);
      try {
        const { data } = await supabase.from("professionals")
          .select("*").eq("phone", initialExpert.phone).single();
        if(data) setExpert(data);
      } catch(e){ console.error(e); }
      setFetching(false);
    };
    fetchFresh();
  },[initialExpert.phone]);

  const STATUS_COLORS = {
    pending:      {bg:"#FEF9C3",color:"#A16207",label:"⏳ Pending"},
    under_review: {bg:"#FFEDD5",color:"#EA580C",label:"🟠 Under Review"},
    approved:     {bg:"#DCFCE7",color:"#15803D",label:"✅ Approved"},
    rejected:     {bg:"#FEE2E2",color:"#DC2626",label:"❌ Rejected"},
    suspended:    {bg:"#F1F5F9",color:"#475569",label:"⚫ Suspended"},
    more_docs:    {bg:"#EFF6FF",color:"#1D4ED8",label:"📄 More Docs Needed"},
  };

  const updateStatus = async (newStatus) => {
    if(!note.trim()&&newStatus!=="under_review") {
      alert("Please enter a reason/note before proceeding");
      return;
    }
    setLoading(true);
    try {
      const updateData = {
        verification_status: newStatus,
        admin_note: note,
        updated_at: new Date().toISOString(),
        approved_at: newStatus==="approved"?new Date().toISOString():null,
        rejected_reason: newStatus==="rejected"?note:null,
        more_docs_reason: newStatus==="more_docs"?note:null,
        status: newStatus==="approved"?"available":newStatus==="suspended"?"offline":"offline",
      };
      await supabase.from("professionals").update(updateData).eq("phone",expert.phone);
      await supabase.from("users").update({verification_status:newStatus}).eq("phone",expert.phone);
      await supabase.from("audit_logs").insert({
        expert_phone: expert.phone,
        action: newStatus,
        note: note,
        performed_at: new Date().toISOString(),
      });
      const updated = {...expert,...updateData};
      setExpert(updated);
      onUpdate(updated);
      setShowNoteInput(null);
      setNote("");
      alert(newStatus==="approved"?"✅ Expert Approved! They can now accept bookings.":
            newStatus==="rejected"?"❌ Expert Rejected.":
            newStatus==="more_docs"?"📄 More documents requested.":"Status updated!");
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const sc = STATUS_COLORS[expert.verification_status]||STATUS_COLORS.pending;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9999,overflowY:"auto",display:"flex",flexDirection:"column"}}>
      <div style={{background:"white",flex:1,margin:"16px 8px",borderRadius:24,overflow:"hidden",maxWidth:500,alignSelf:"center",width:"100%"}}>
        {/* Header */}
        <div style={{background:"linear-gradient(145deg,#7C3AED,#6D28D9)",padding:"20px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <div style={{color:"white",fontWeight:900,fontSize:18}}>Expert Profile</div>
              {fetching&&<div style={{background:"rgba(255,255,255,.2)",borderRadius:8,padding:"3px 8px"}}>
                <span style={{color:"white",fontSize:10}}>🔄 Loading...</span>
              </div>}
            </div>
            <button onClick={onClose} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:10,padding:"6px 12px",color:"white",fontWeight:700,cursor:"pointer"}}>✕ Close</button>
          </div>
          <div style={{display:"flex",gap:14,alignItems:"center"}}>
            {expert.selfie_url&&expert.selfie_url.startsWith("data:")?
              <img src={expert.selfie_url} alt="selfie" style={{width:60,height:60,borderRadius:20,objectFit:"cover",border:"2px solid rgba(255,255,255,.4)"}}/>:
              <div style={{width:60,height:60,borderRadius:20,background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>👨‍🔧</div>
            }
            <div style={{flex:1}}>
              <div style={{color:"white",fontWeight:900,fontSize:18}}>{expert.name||"Expert"}</div>
              <div style={{color:"rgba(255,255,255,.7)",fontSize:12}}>+91 {expert.phone} · {expert.category}</div>
              <div style={{marginTop:6}}>
                <span style={{background:sc.bg,color:sc.color,padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{sc.label}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",overflowX:"auto",borderBottom:"1px solid #E8E8E8",background:"white"}}>
          {[["personal","👤 Personal"],["docs","📄 Docs"],["bank","🏦 Bank"],["status","🔍 Status"]].map(([id,label])=>(
            <button key={id} onClick={()=>setActiveTab(id)}
              style={{flexShrink:0,padding:"12px 14px",border:"none",borderBottom:`3px solid ${activeTab===id?"#7C3AED":"transparent"}`,background:"white",color:activeTab===id?"#7C3AED":"#9A9A9A",fontWeight:activeTab===id?800:500,fontSize:12,cursor:"pointer",whiteSpace:"nowrap"}}>
              {label}
            </button>
          ))}
        </div>

        <div style={{padding:"16px",maxHeight:"60vh",overflowY:"auto"}}>
          {/* Personal Tab */}
          {activeTab==="personal"&&(
            <div>
              {[
                ["Full Name",expert.name],["Mobile","+91 "+expert.phone],
                ["Email",expert.email||"—"],["Date of Birth",expert.dob||"—"],
                ["Gender",expert.gender||"—"],["City",expert.city||"—"],
                ["State",expert.state||"—"],["PIN Code",expert.pin||"—"],
                ["Address",expert.address||"—"],["Languages",expert.languages||"—"],
                ["Category",expert.category||"—"],["Experience",expert.experience||"—"],
                ["Skills",expert.skills||"—"],["Service Areas",expert.service_areas||"—"],
                ["Bio",expert.bio||"—"],["Registered",expert.registered_at?new Date(expert.registered_at).toLocaleDateString("en-IN"):"—"],
              ].map(([l,v])=>(
                <div key={l} style={{display:"flex",gap:8,padding:"8px 0",borderBottom:"1px solid #F4F6FA"}}>
                  <span style={{color:"#9A9A9A",fontSize:12,width:110,flexShrink:0}}>{l}</span>
                  <span style={{color:"#0D0D0D",fontSize:12,fontWeight:600,flex:1}}>{v||"—"}</span>
                </div>
              ))}
            </div>
          )}

          {/* Documents Tab */}
          {activeTab==="docs"&&(
            <div>
              {fetching&&<div style={{textAlign:"center",padding:16,color:"#9A9A9A",fontSize:13}}>🔄 Loading documents from storage...</div>}
              
              {/* Storage folder link */}
              <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:12,padding:"10px 14px",marginBottom:16}}>
                <div style={{fontWeight:700,color:"#1D4ED8",fontSize:12,marginBottom:2}}>🗂️ Storage Folder</div>
                <div style={{fontSize:11,color:"#9A9A9A"}}>experts/{expert.phone}_{(expert.name||"").replace(/\s+/g,"_")}/</div>
                <a href="https://supabase.com/dashboard/project/lwwygijjslkezxpycpgn/storage/buckets/documents"
                  target="_blank" rel="noopener noreferrer"
                  style={{display:"inline-block",marginTop:6,background:"#1D4ED8",borderRadius:8,padding:"4px 10px",color:"white",fontSize:11,fontWeight:700,textDecoration:"none"}}>
                  Open in Supabase Storage →
                </a>
              </div>

              {/* Helper to render doc */}
              {[
                {label:"🤳 Live Selfie",url:expert.selfie_url,round:true},
                {label:"📄 Aadhaar Front",url:expert.aadhaar_front_url},
                {label:"📄 Aadhaar Back",url:expert.aadhaar_back_url},
                {label:"💳 PAN Card",url:expert.pan_url},
                {label:"🏦 Bank Proof",url:expert.bank_proof_url},
              ].map(({label,url,round})=>(
                <div key={label} style={{marginBottom:16}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{label}</div>
                    <span style={{fontSize:11,fontWeight:700,color:url&&url.length>10?"#065F46":"#DC2626"}}>
                      {url&&url.length>10?"✅ Uploaded":"❌ Missing"}
                    </span>
                  </div>
                  {url&&url.length>10?(
                    <div style={{borderRadius:round?16:14,overflow:"hidden",border:"2px solid #065F46",cursor:"pointer",position:"relative"}}
                      onClick={()=>window.open(url,"_blank")}>
                      <img src={url} alt={label}
                        style={{width:"100%",height:round?160:120,objectFit:"cover",display:"block",borderRadius:round?"50%":"none"}}
                        onError={e=>{
                          e.target.style.display="none";
                          e.target.parentNode.innerHTML=`<div style="height:100px;display:flex;align-items:center;justify-content:center;background:#F4F6FA;color:#9A9A9A;font-size:12px">⚠️ Image load failed — <a href="${url}" target="_blank" style="color:#1D4ED8;margin-left:4px">Open directly</a></div>`;
                        }}
                      />
                      <div style={{position:"absolute",top:0,inset:0,display:"flex",alignItems:"center",justifyContent:"center",opacity:0,hover:"opacity:1",background:"rgba(0,0,0,.3)",transition:"opacity .2s"}}>
                        <span style={{color:"white",fontSize:20}}>🔍</span>
                      </div>
                      <div style={{position:"absolute",bottom:0,left:0,right:0,background:"rgba(0,0,0,.6)",padding:"6px 10px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{color:"white",fontSize:11,fontWeight:600}}>{label}</span>
                        <a href={url} download={label.replace(/[^a-z0-9]/gi,"_")+".jpg"} onClick={e=>e.stopPropagation()}
                          style={{color:"#FBBF24",fontSize:11,fontWeight:700,textDecoration:"none"}}>⬇️ Download</a>
                      </div>
                    </div>
                  ):(
                    <div style={{height:80,background:"#FEE2E2",borderRadius:14,display:"flex",alignItems:"center",justifyContent:"center",border:"2px dashed #FECACA"}}>
                      <span style={{fontSize:12,color:"#DC2626",fontWeight:600}}>❌ Document not uploaded</span>
                    </div>
                  )}
                </div>
              ))}

              {/* Aadhaar & PAN numbers */}
              <div style={{background:"#F4F6FA",borderRadius:12,padding:"12px 14px",marginTop:4}}>
                <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:8}}>Document Numbers</div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <span style={{color:"#9A9A9A",fontSize:12}}>Aadhaar</span>
                  <span style={{fontWeight:700,color:"#0D0D0D",fontSize:12}}>{expert.aadhaar_number?"XXXX XXXX "+expert.aadhaar_number.slice(-4):"Not provided"}</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between"}}>
                  <span style={{color:"#9A9A9A",fontSize:12}}>PAN</span>
                  <span style={{fontWeight:700,color:"#0D0D0D",fontSize:12}}>{expert.pan_number||"Not provided"}</span>
                </div>
              </div>
            </div>
          )}

          {/* Bank Tab */}
          {activeTab==="bank"&&(
            <div>
              {[
                ["Account Holder",expert.bank_holder||expert.name],
                ["Account Number","XXXX"+((expert.bank_account||"").slice(-4))],
                ["IFSC Code",expert.bank_ifsc||"—"],
                ["Bank Name",expert.bank_name||"—"],
              ].map(([l,v])=>(
                <div key={l} style={{display:"flex",gap:8,padding:"12px 0",borderBottom:"1px solid #F4F6FA"}}>
                  <span style={{color:"#9A9A9A",fontSize:13,width:130,flexShrink:0}}>{l}</span>
                  <span style={{color:"#0D0D0D",fontSize:13,fontWeight:700}}>{v||"—"}</span>
                </div>
              ))}
              <div style={{background:"#F4F6FA",borderRadius:12,padding:12,marginTop:12,textAlign:"center"}}>
                {expert.bank_proof_url?"✅ Bank proof uploaded":"⚠️ No bank proof uploaded"}
              </div>
            </div>
          )}

          {/* Status Tab */}
          {activeTab==="status"&&(
            <div>
              <div style={{background:sc.bg,borderRadius:14,padding:14,marginBottom:16,textAlign:"center",border:`1px solid ${sc.color}33`}}>
                <div style={{fontWeight:900,color:sc.color,fontSize:18}}>{sc.label}</div>
              </div>
              {expert.admin_note&&(
                <div style={{background:"#F4F6FA",borderRadius:12,padding:12,marginBottom:12}}>
                  <div style={{fontWeight:700,color:"#0D0D0D",fontSize:12,marginBottom:4}}>Admin Note:</div>
                  <div style={{fontSize:13,color:"#545454"}}>{expert.admin_note}</div>
                </div>
              )}
              {expert.rejected_reason&&(
                <div style={{background:"#FEE2E2",borderRadius:12,padding:12,marginBottom:12}}>
                  <div style={{fontWeight:700,color:"#DC2626",fontSize:12,marginBottom:4}}>❌ Rejection Reason:</div>
                  <div style={{fontSize:13,color:"#DC2626"}}>{expert.rejected_reason}</div>
                </div>
              )}
              {expert.more_docs_reason&&(
                <div style={{background:"#EFF6FF",borderRadius:12,padding:12,marginBottom:12}}>
                  <div style={{fontWeight:700,color:"#1D4ED8",fontSize:12,marginBottom:4}}>📄 More Documents Requested:</div>
                  <div style={{fontSize:13,color:"#1D4ED8"}}>{expert.more_docs_reason}</div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div style={{padding:"14px 16px",borderTop:"1px solid #E8E8E8",background:"white"}}>
          {showNoteInput?(
            <div>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13,marginBottom:8}}>
                {showNoteInput==="approve"?"Approval Note:":showNoteInput==="reject"?"Rejection Reason *:":"Documents Needed *:"}
              </div>
              <textarea value={note} onChange={e=>setNote(e.target.value)}
                placeholder={showNoteInput==="approve"?"e.g. All documents verified successfully":showNoteInput==="reject"?"e.g. PAN card image is unclear":"e.g. Please upload clearer Aadhaar copy"}
                style={{width:"100%",padding:"11px 14px",background:"#F4F6FA",border:"1.5px solid #E8E8E8",borderRadius:12,fontSize:13,resize:"none",height:70,boxSizing:"border-box",outline:"none",marginBottom:10}}/>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>{setShowNoteInput(null);setNote("");}} style={{flex:1,padding:"11px",background:"#F4F6FA",border:"none",borderRadius:12,color:"#545454",fontWeight:700,cursor:"pointer"}}>Cancel</button>
                <button onClick={()=>updateStatus(showNoteInput==="approve"?"approved":showNoteInput==="reject"?"rejected":"more_docs")} disabled={loading}
                  style={{flex:2,padding:"11px",background:showNoteInput==="approve"?"#065F46":showNoteInput==="reject"?"#DC2626":"#1D4ED8",border:"none",borderRadius:12,color:"white",fontWeight:800,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                  {loading?<Spinner/>:showNoteInput==="approve"?"✅ Confirm Approve":showNoteInput==="reject"?"❌ Confirm Reject":"📄 Request Docs"}
                </button>
              </div>
            </div>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {expert.verification_status!=="approved"&&(
                <button onClick={()=>{setShowNoteInput("approve");setNote("Documents verified successfully. Welcome to GharPe!");}} className="tap"
                  style={{padding:"12px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:14,color:"white",fontWeight:800,fontSize:14,cursor:"pointer"}}>
                  ✅ Approve Expert
                </button>
              )}
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>{setShowNoteInput("more_docs");setNote("");}} className="tap"
                  style={{flex:1,padding:"11px",background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:12,color:"#1D4ED8",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                  📄 Need More Docs
                </button>
                {expert.verification_status==="approved"?(
                  <button onClick={()=>{setShowNoteInput("reject");setNote("");}} className="tap"
                    style={{flex:1,padding:"11px",background:"#FEF9C3",border:"1px solid #FDE68A",borderRadius:12,color:"#A16207",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                    ⚫ Suspend
                  </button>
                ):(
                  <button onClick={()=>{setShowNoteInput("reject");setNote("");}} className="tap"
                    style={{flex:1,padding:"11px",background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:12,color:"#DC2626",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                    ❌ Reject
                  </button>
                )}
              </div>
              <button onClick={()=>{updateStatus("under_review");}} className="tap"
                style={{padding:"10px",background:"#F4F6FA",border:"1px solid #E8E8E8",borderRadius:12,color:"#545454",fontWeight:600,fontSize:12,cursor:"pointer"}}>
                🔍 Mark as Under Review
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const AdminDash = ({lang,setLang,onLogout}) => {
  const [tab,setTab]             = useState("dash");
  const [bookings,setBookings]   = useState([]);
  const [experts,setExperts]     = useState([]);
  const [users,setUsers]         = useState([]);
  const [withdrawals,setWithdrawals] = useState([]);
  const [loading,setLoading]     = useState(true);
  const [showChat,setShowChat]   = useState(false);
  const [selectedExpert,setSelectedExpert] = useState(null);
  const [expertFilter,setExpertFilter]     = useState("all");
  const L = lang==="en";

  const loadData = async () => {
    setLoading(true);
    try {
      const [b,e,u,w,t] = await Promise.all([
        supabase.from("bookings").select("*").order("created_at",{ascending:false}),
        supabase.from("professionals").select("*").order("registered_at",{ascending:false}),
        supabase.from("users").select("*").order("created_at",{ascending:false}),
        supabase.from("withdrawal_requests").select("*").order("requested_at",{ascending:false}),
        supabase.from("support_tickets").select("*").order("created_at",{ascending:false}),
      ]);
      setBookings(b.data||[]);
      const pros = e.data||[];
      const expertUsers = (u.data||[]).filter(x=>x.role==="expert"||x.role==="pro");
      const proPhones = pros.map(p=>p.phone);
      const missingExperts = expertUsers.filter(eu=>!proPhones.includes(eu.phone))
        .map(eu=>({phone:eu.phone,name:eu.name||"Expert",category:"General",area:eu.area||"Lucknow",verification_status:eu.verification_status||"pending",status:"offline",rating:5.0,jobs_done:0,earnings:0}));
      setExperts([...pros,...missingExperts]);
      setUsers(u.data||[]);
      setWithdrawals(w.data||[]);
      setTickets(t.data||[]);
    } catch(e){ console.error(e); }
    setLoading(false);
  };

  useEffect(()=>{ loadData(); },[]);

  const updateBookingStatus = async (id,status) => {
    await supabase.from("bookings").update({status}).eq("id",id);
    setBookings(prev=>prev.map(b=>b.id===id?{...b,status}:b));
  };

  const processWithdrawal = async (id,status) => {
    await supabase.from("withdrawal_requests").update({status,processed_at:new Date().toISOString()}).eq("id",id);
    setWithdrawals(prev=>prev.map(w=>w.id===id?{...w,status}:w));
  };

  const rev = bookings.reduce((s,b)=>s+(b.amount||0),0);
  const adminCut = Math.round(rev*.20);
  const pendingExperts = experts.filter(e=>e.verification_status==="pending"||e.verification_status==="under_review").length;
  const pendingWithdrawals = withdrawals.filter(w=>w.status==="pending").length;

  const STATUS_CONFIG = {
    all:          {label:"All Experts",color:"#545454"},
    pending:      {label:"⏳ Pending",color:"#A16207"},
    under_review: {label:"🟠 Under Review",color:"#EA580C"},
    approved:     {label:"✅ Approved",color:"#15803D"},
    rejected:     {label:"❌ Rejected",color:"#DC2626"},
    suspended:    {label:"⚫ Suspended",color:"#475569"},
    more_docs:    {label:"📄 More Docs",color:"#1D4ED8"},
  };

  const [tickets,setTickets]         = useState([]);
  const filteredExperts = expertFilter==="all"?experts:experts.filter(e=>e.verification_status===expertFilter);

  if(showChat) return <ChatSupport user={{phone:"9000000001",name:"Admin"}} onClose={()=>setShowChat(false)}/>;

  const TABS = [
    {id:"dash",    icon:"📊",lbl:"Dashboard"},
    {id:"bookings",icon:"📋",lbl:"Bookings",badge:bookings.filter(b=>b.status==="pending").length},
    {id:"experts", icon:"👨‍🔧",lbl:"Experts",badge:pendingExperts},
    {id:"users",   icon:"👥",lbl:"Users"},
    {id:"tickets", icon:"🎫",lbl:"Tickets",badge:tickets.filter(t=>t.status==="open").length},
    {id:"wallet",  icon:"💰",lbl:"Wallet",badge:pendingWithdrawals},
  ];

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh"}}>
      {selectedExpert&&<ExpertDetailModal expert={selectedExpert} onClose={()=>setSelectedExpert(null)}
        onUpdate={updated=>{setExperts(prev=>prev.map(e=>e.phone===updated.phone?updated:e));setSelectedExpert(updated);}}/>}

      {/* Header */}
      <div style={{background:"linear-gradient(145deg,#7C3AED,#6D28D9)",padding:"52px 16px 0",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <Logo size={34} white/>
            <div>
              <div style={{color:"white",fontWeight:900,fontSize:16}}>Admin Panel</div>
              <div style={{color:"rgba(255,255,255,.6)",fontSize:11}}>GharPe Management</div>
            </div>
          </div>
          <div style={{display:"flex",gap:6}}>
            <button onClick={loadData} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 10px",color:"white",fontSize:16,cursor:"pointer"}}>🔄</button>
            <button onClick={()=>setShowChat(true)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 10px",color:"white",fontSize:16,cursor:"pointer"}}>🤖</button>
            <button onClick={onLogout} style={{background:"rgba(255,255,255,.12)",border:"1px solid rgba(255,255,255,.2)",borderRadius:20,padding:"5px 12px",color:"rgba(255,255,255,.9)",fontWeight:600,fontSize:11,cursor:"pointer"}}>Sign out</button>
          </div>
        </div>
        <div style={{display:"flex",gap:0,overflowX:"auto",scrollbarWidth:"none"}}>
          {TABS.map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)}
              style={{flexShrink:0,padding:"10px 12px 14px",background:"none",border:"none",borderBottom:`3px solid ${tab===t.id?"white":"transparent"}`,color:tab===t.id?"white":"rgba(255,255,255,.55)",fontWeight:tab===t.id?800:500,fontSize:12,cursor:"pointer",display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap",position:"relative"}}>
              {t.icon} {t.lbl}
              {t.badge>0&&<span style={{background:"#FF5722",color:"white",borderRadius:10,fontSize:9,fontWeight:800,padding:"1px 5px"}}>{t.badge}</span>}
            </button>
          ))}
        </div>
      </div>

      <div style={{padding:"16px",paddingBottom:30}}>

        {/* ── DASHBOARD ── */}
        {tab==="dash"&&(
          <div>
            {pendingExperts>0&&(
              <div onClick={()=>setTab("experts")} style={{background:"linear-gradient(135deg,#FBBF24,#F59E0B)",borderRadius:18,padding:"16px 18px",marginBottom:16,cursor:"pointer",display:"flex",alignItems:"center",gap:12}}>
                <span style={{fontSize:28}}>⚠️</span>
                <div>
                  <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15}}>{pendingExperts} Expert{pendingExperts>1?"s":""} Awaiting Review</div>
                  <div style={{fontSize:12,color:"#78350F",marginTop:2}}>Tap to review and approve → </div>
                </div>
              </div>
            )}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
              {[
                {label:"Total Revenue",value:"₹"+rev.toLocaleString(),icon:"💰",bg:"#EFF6FF",c:"#1D4ED8"},
                {label:"Platform Earnings",value:"₹"+adminCut.toLocaleString(),icon:"🏦",bg:"#ECFDF5",c:"#15803D"},
                {label:"Total Bookings",value:bookings.length,icon:"📋",bg:"#FEF9C3",c:"#A16207"},
                {label:"Pending Approvals",value:pendingExperts,icon:"⏳",bg:"#FFEDD5",c:"#EA580C"},
                {label:"Total Experts",value:experts.length,icon:"👨‍🔧",bg:"#F3E8FF",c:"#6D28D9"},
                {label:"Approved Experts",value:experts.filter(e=>e.verification_status==="approved").length,icon:"✅",bg:"#DCFCE7",c:"#15803D"},
                {label:"Total Customers",value:users.filter(u=>u.role==="customer").length,icon:"👥",bg:"#E0F2FE",c:"#0284C7"},
                {label:"Pending Payouts",value:pendingWithdrawals,icon:"💸",bg:"#FCE7F3",c:"#9D174D"},
              ].map(s=>(
                <div key={s.label} style={{background:s.bg,borderRadius:18,padding:"16px",border:`1px solid ${s.c}22`}}>
                  <div style={{fontSize:22,marginBottom:6}}>{s.icon}</div>
                  <div style={{fontWeight:900,color:s.c,fontSize:22,letterSpacing:-.5}}>{s.value}</div>
                  <div style={{fontSize:11,color:s.c,opacity:.7,marginTop:3,fontWeight:600,lineHeight:1.3}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{background:"white",borderRadius:18,padding:16,border:"1px solid #E8E8E8",marginBottom:16}}>
              <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15,marginBottom:12}}>Expert Verification Status</div>
              {Object.entries(STATUS_CONFIG).filter(([k])=>k!=="all").map(([status,cfg])=>{
                const count = experts.filter(e=>e.verification_status===status).length;
                const pct = experts.length>0?count/experts.length*100:0;
                return(
                  <div key={status} style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                    <span style={{fontSize:12,fontWeight:600,color:cfg.color,width:110,flexShrink:0}}>{cfg.label}</span>
                    <div style={{flex:1,height:6,background:"#F4F6FA",borderRadius:4}}>
                      <div style={{width:`${pct}%`,height:"100%",background:cfg.color,borderRadius:4,transition:"width .5s"}}/>
                    </div>
                    <span style={{fontWeight:800,color:cfg.color,fontSize:13,width:20,textAlign:"right"}}>{count}</span>
                  </div>
                );
              })}
            </div>
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15,marginBottom:10}}>Recent Bookings</div>
            {bookings.slice(0,4).map((b,i)=>(
              <div key={b.id} style={{background:"white",borderRadius:14,padding:"12px 14px",marginBottom:8,border:"1px solid #E8E8E8",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13}}>{b.service_name}</div>
                  <div style={{fontSize:11,color:"#9A9A9A",marginTop:2}}>{b.customer_name||b.customer_phone} · {b.area}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <StatusPill status={b.status}/>
                  <div style={{fontWeight:700,color:"#0F2D5C",fontSize:13,marginTop:4}}>₹{b.amount}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── BOOKINGS ── */}
        {tab==="bookings"&&(
          <div>
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:17,marginBottom:14}}>All Bookings ({bookings.length})</div>
            {bookings.map((b,i)=>(
              <div key={b.id} className="fu" style={{background:"white",borderRadius:18,padding:"14px 16px",marginBottom:12,border:"1px solid #E8E8E8",animationDelay:`${i*30}ms`}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <div>
                    <span style={{fontWeight:800,color:"#0D0D0D",fontSize:14}}>{b.service_name}</span>
                    <span style={{fontSize:11,color:"#9A9A9A",marginLeft:8}}>#{b.id}</span>
                  </div>
                  <StatusPill status={b.status}/>
                </div>
                <div style={{fontSize:12,color:"#9A9A9A",marginBottom:8}}>
                  👤 {b.customer_name||b.customer_phone} · 📍 {b.area} · 📅 {b.date}
                  {b.pro_name&&<span style={{color:"#065F46",fontWeight:600}}> · 🔧 {b.pro_name}</span>}
                </div>
                <div style={{background:"#F4F6FA",borderRadius:10,padding:"8px 12px",marginBottom:10,display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:11,color:"#065F46",fontWeight:700}}>Expert: ₹{Math.round((b.amount||0)*.8)}</span>
                  <span style={{fontSize:11,color:"#7C3AED",fontWeight:700}}>GharPe: ₹{Math.round((b.amount||0)*.2)}</span>
                  <span style={{fontSize:11,color:"#0D0D0D",fontWeight:700}}>Total: ₹{b.amount}</span>
                </div>
                <div style={{display:"flex",gap:6}}>
                  {["pending","confirmed","in-progress","completed"].map(s=>(
                    <button key={s} onClick={()=>updateBookingStatus(b.id,s)} className="tap"
                      style={{flex:1,padding:"6px 2px",background:b.status===s?"#7C3AED":"#F4F6FA",border:`1px solid ${b.status===s?"#7C3AED":"#E8E8E8"}`,borderRadius:8,color:b.status===s?"white":"#545454",fontWeight:600,fontSize:8,cursor:"pointer"}}>
                      {s.replace("-"," ").replace(/\w/g,c=>c.toUpperCase())}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── EXPERTS ── */}
        {tab==="experts"&&(
          <div>
            {/* Filter tabs */}
            <div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:16,scrollbarWidth:"none"}}>
              {Object.entries(STATUS_CONFIG).map(([key,cfg])=>{
                const count = key==="all"?experts.length:experts.filter(e=>e.verification_status===key).length;
                return(
                  <button key={key} onClick={()=>setExpertFilter(key)}
                    style={{flexShrink:0,padding:"7px 12px",background:expertFilter===key?"#7C3AED":"white",border:`1px solid ${expertFilter===key?"#7C3AED":"#E8E8E8"}`,borderRadius:20,color:expertFilter===key?"white":cfg.color,fontWeight:700,fontSize:11,cursor:"pointer",whiteSpace:"nowrap"}}>
                    {cfg.label} ({count})
                  </button>
                );
              })}
            </div>

            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:12}}>{filteredExperts.length} Experts</div>

            {filteredExperts.map((e,i)=>{
              const sc = {
                pending:      {bg:"#FEF9C3",color:"#A16207",label:"⏳ Pending"},
                under_review: {bg:"#FFEDD5",color:"#EA580C",label:"🟠 Under Review"},
                approved:     {bg:"#DCFCE7",color:"#15803D",label:"✅ Approved"},
                rejected:     {bg:"#FEE2E2",color:"#DC2626",label:"❌ Rejected"},
                suspended:    {bg:"#F1F5F9",color:"#475569",label:"⚫ Suspended"},
                more_docs:    {bg:"#EFF6FF",color:"#1D4ED8",label:"📄 More Docs"},
              }[e.verification_status]||{bg:"#F4F6FA",color:"#9A9A9A",label:"Unknown"};

              return(
                <div key={e.id||i} className="fu" onClick={async()=>{
                  // Fetch latest expert data before showing modal
                  try {
                    const { data: fresh } = await supabase.from("professionals").select("*").eq("phone",e.phone).single();
                    setSelectedExpert(fresh||e);
                  } catch(err){ setSelectedExpert(e); }
                }}
                  style={{background:"white",borderRadius:18,padding:"14px 16px",marginBottom:12,border:`2px solid ${e.verification_status==="pending"||e.verification_status==="under_review"?"#FDE68A":"#E8E8E8"}`,cursor:"pointer",animationDelay:`${i*40}ms`}}>
                  <div style={{display:"flex",gap:12,alignItems:"center"}}>
                    <div style={{width:48,height:48,borderRadius:16,background:"#F3E8FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>
                      {e.selfie_url&&e.selfie_url.startsWith("data:")?
                        <img src={e.selfie_url} alt="" style={{width:48,height:48,borderRadius:16,objectFit:"cover"}}/>:"👨‍🔧"}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:800,color:"#0D0D0D",fontSize:14}}>{e.name||"Expert"}</div>
                      <div style={{fontSize:11,color:"#9A9A9A",marginTop:1}}>📱 {e.phone} · {e.category}</div>
                      <div style={{fontSize:11,color:"#9A9A9A"}}>📍 {e.city||e.area} · {e.experience||"—"}</div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <span style={{background:sc.bg,color:sc.color,padding:"4px 8px",borderRadius:10,fontSize:10,fontWeight:700,display:"block",marginBottom:4}}>{sc.label}</span>
                      <span style={{color:"#9A9A9A",fontSize:10}}>Tap to review →</span>
                    </div>
                  </div>
                  {(e.verification_status==="pending"||e.verification_status==="under_review")&&(
                    <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid #F4F6FA",display:"flex",gap:8}}>
                      <button onClick={e2=>{e2.stopPropagation();setSelectedExpert(e);}} className="tap"
                        style={{flex:1,padding:"9px",background:"linear-gradient(135deg,#7C3AED,#6D28D9)",border:"none",borderRadius:10,color:"white",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                        👁️ Review Details
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* ── USERS ── */}
        {tab==="users"&&(
          <div>
            <div style={{display:"flex",gap:10,marginBottom:16}}>
              {[
                ["👤",users.filter(u=>u.role==="customer").length,"Customers","#EFF6FF","#1D4ED8"],
                ["🔧",users.filter(u=>u.role==="expert"||u.role==="pro").length,"Experts","#ECFDF5","#15803D"],
                ["🛡️",users.filter(u=>u.role==="admin").length,"Admins","#F3E8FF","#6D28D9"],
              ].map(([ic,v,l,bg,c])=>(
                <div key={l} style={{flex:1,background:bg,borderRadius:14,padding:"12px 8px",textAlign:"center",border:`1px solid ${c}22`}}>
                  <div style={{fontSize:18,marginBottom:4}}>{ic}</div>
                  <div style={{fontWeight:900,color:c,fontSize:18}}>{v}</div>
                  <div style={{fontSize:10,color:c,opacity:.7,fontWeight:600}}>{l}</div>
                </div>
              ))}
            </div>
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:12}}>All Users ({users.length})</div>
            {users.map((u,i)=>(
              <div key={u.id||i} className="fu" style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:10,border:"1px solid #E8E8E8",display:"flex",gap:12,alignItems:"center",animationDelay:`${i*30}ms`}}>
                <div style={{width:42,height:42,borderRadius:14,background:u.role==="admin"?"#F3E8FF":u.role==="expert"||u.role==="pro"?"#ECFDF5":"#EFF6FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>
                  {u.role==="admin"?"🛡️":u.role==="expert"||u.role==="pro"?"🔧":"👤"}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,color:"#0D0D0D",fontSize:13}}>{u.name||"User"}</div>
                  <div style={{fontSize:11,color:"#9A9A9A",marginTop:1}}>📱 {u.phone} · {u.role} · 📍 {u.area||"Lucknow"}</div>
                  {u.dob&&<div style={{fontSize:11,color:"#9A9A9A"}}>🎂 {u.dob} · {u.gender||"—"}</div>}
                </div>
                <span style={{background:u.verification_status==="approved"?"#DCFCE7":"#FEF9C3",color:u.verification_status==="approved"?"#15803D":"#A16207",padding:"3px 8px",borderRadius:10,fontSize:10,fontWeight:700,flexShrink:0}}>
                  {u.verification_status==="approved"?"✅ Verified":"⏳ Pending"}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* ── TICKETS ── */}
        {tab==="tickets"&&(
          <div>
            <div style={{display:"flex",gap:10,marginBottom:16}}>
              {[["🔴",tickets.filter(t=>t.status==="open").length,"Open","#FEE2E2","#DC2626"],
                ["🟡",tickets.filter(t=>t.status==="in-progress").length,"In Progress","#FEF9C3","#A16207"],
                ["🟢",tickets.filter(t=>t.status==="resolved").length,"Resolved","#DCFCE7","#15803D"]].map(([ic,v,l,bg,c])=>(
                <div key={l} style={{flex:1,background:bg,borderRadius:14,padding:"12px 8px",textAlign:"center",border:`1px solid ${c}22`}}>
                  <div style={{fontSize:16,marginBottom:3}}>{ic}</div>
                  <div style={{fontWeight:900,color:c,fontSize:20}}>{v}</div>
                  <div style={{fontSize:10,color:c,opacity:.7,fontWeight:600}}>{l}</div>
                </div>
              ))}
            </div>

            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:14}}>Support Tickets ({tickets.length})</div>

            {tickets.length===0&&(
              <div style={{background:"white",borderRadius:16,padding:"40px 20px",textAlign:"center",color:"#9A9A9A",border:"1px solid #E8E8E8"}}>
                <div style={{fontSize:48,marginBottom:10}}>🎫</div>
                <div style={{fontWeight:700,color:"#0D0D0D",fontSize:15,marginBottom:4}}>No tickets yet</div>
                <div style={{fontSize:13}}>Customer support tickets will appear here</div>
              </div>
            )}

            {tickets.map((t,i)=>{
              const conv = (() => { try { return JSON.parse(t.conversation||"[]"); } catch(e){ return []; }})();
              return (
                <div key={t.id||i} className="fu" style={{background:"white",borderRadius:18,padding:"14px 16px",marginBottom:12,border:`2px solid ${t.status==="open"?"#FECACA":t.status==="in-progress"?"#FDE68A":"#E8E8E8"}`,animationDelay:`${i*40}ms`}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                    <div>
                      <div style={{fontWeight:800,color:"#0D0D0D",fontSize:14}}>#{t.id}</div>
                      <div style={{fontSize:12,color:"#9A9A9A",marginTop:2}}>👤 {t.customer_name} · 📱 {t.customer_phone}</div>
                    </div>
                    <span style={{
                      background:t.status==="open"?"#FEE2E2":t.status==="in-progress"?"#FEF9C3":"#DCFCE7",
                      color:t.status==="open"?"#DC2626":t.status==="in-progress"?"#A16207":"#15803D",
                      padding:"4px 10px",borderRadius:20,fontSize:11,fontWeight:700,height:"fit-content"
                    }}>{t.status==="open"?"🔴 Open":t.status==="in-progress"?"🟡 In Progress":"🟢 Resolved"}</span>
                  </div>

                  <div style={{background:"#F4F6FA",borderRadius:10,padding:"10px 12px",marginBottom:10,fontSize:13,color:"#545454"}}>
                    <b>Issue:</b> {t.issue||"Customer requested human support"}
                  </div>

                  {/* Show conversation */}
                  {conv.length>0&&(
                    <div style={{marginBottom:10}}>
                      <div style={{fontWeight:600,color:"#0D0D0D",fontSize:12,marginBottom:6}}>💬 Chat History ({conv.length} messages)</div>
                      <div style={{maxHeight:150,overflowY:"auto",background:"#F4F6FA",borderRadius:10,padding:10}}>
                        {conv.slice(-6).map((m,j)=>(
                          <div key={j} style={{marginBottom:6,display:"flex",justifyContent:m.role==="user"?"flex-end":"flex-start"}}>
                            <div style={{maxWidth:"80%",background:m.role==="user"?"#0F2D5C":"white",borderRadius:10,padding:"6px 10px",boxShadow:"0 1px 3px rgba(0,0,0,.08)"}}>
                              <div style={{fontSize:11,color:m.role==="user"?"rgba(255,255,255,.7)":"#9A9A9A",marginBottom:2}}>{m.role==="user"?"Customer":"AI Bot"}</div>
                              <div style={{fontSize:12,color:m.role==="user"?"white":"#0D0D0D",lineHeight:1.4}}>{m.content?.slice(0,100)}{m.content?.length>100?"...":""}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div style={{fontSize:11,color:"#9A9A9A",marginBottom:10}}>
                    🕐 {new Date(t.created_at).toLocaleString("en-IN")}
                  </div>

                  {/* Action buttons */}
                  <div style={{display:"flex",gap:8}}>
                    <a href={`https://wa.me/91${t.customer_phone}?text=Hi ${t.customer_name}, regarding your GharPe support ticket #${t.id}`}
                      style={{flex:1,padding:"9px",background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:10,color:"#065F46",fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
                      💬 WhatsApp
                    </a>
                    <button onClick={async()=>{
                      const newStatus = t.status==="open"?"in-progress":t.status==="in-progress"?"resolved":"open";
                      await supabase.from("support_tickets").update({status:newStatus}).eq("id",t.id);
                      setTickets(prev=>prev.map(tk=>tk.id===t.id?{...tk,status:newStatus}:tk));
                    }} className="tap"
                      style={{flex:1,padding:"9px",background:t.status==="open"?"#FEF9C3":t.status==="in-progress"?"#DCFCE7":"#FEE2E2",border:"none",borderRadius:10,color:t.status==="open"?"#A16207":t.status==="in-progress"?"#15803D":"#DC2626",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                      {t.status==="open"?"▶ Start":"✅ Resolve"}
                    </button>
                    <a href={`tel:${t.customer_phone}`}
                      style={{flex:1,padding:"9px",background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:10,color:"#1D4ED8",fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
                      📞 Call
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* ── WALLET ── */}
        {tab==="wallet"&&(
          <div>
            <div style={{background:"linear-gradient(135deg,#7C3AED,#6D28D9)",borderRadius:20,padding:"20px",marginBottom:16,color:"white"}}>
              <div style={{fontSize:12,opacity:.7,marginBottom:4}}>Total Platform Revenue</div>
              <div style={{fontSize:36,fontWeight:900,letterSpacing:-1}}>₹{adminCut.toLocaleString()}</div>
              <div style={{fontSize:12,opacity:.6,marginTop:4}}>20% from ₹{rev.toLocaleString()} total</div>
            </div>
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:16,marginBottom:14}}>
              Withdrawal Requests ({withdrawals.length})
              {pendingWithdrawals>0&&<span style={{background:"#FF5722",color:"white",borderRadius:10,fontSize:11,fontWeight:700,padding:"2px 8px",marginLeft:8}}>{pendingWithdrawals}</span>}
            </div>
            {withdrawals.length===0&&(
              <div style={{background:"white",borderRadius:16,padding:"32px",textAlign:"center",color:"#9A9A9A",border:"1px solid #E8E8E8"}}>
                <div style={{fontSize:40,marginBottom:10}}>💸</div>
                <div style={{fontWeight:700,color:"#0D0D0D"}}>No withdrawal requests</div>
              </div>
            )}
            {withdrawals.map((w,i)=>(
              <div key={w.id||i} className="fu" style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:12,border:`2px solid ${w.status==="pending"?"#FDE68A":"#E8E8E8"}`,animationDelay:`${i*40}ms`}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <div>
                    <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{w.professional_name||"Expert"}</div>
                    <div style={{fontSize:12,color:"#9A9A9A"}}>📱 {w.professional_phone}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontWeight:900,color:"#6D28D9",fontSize:20}}>₹{w.amount}</div>
                    <span style={{background:w.status==="pending"?"#FEF9C3":w.status==="approved"?"#DCFCE7":"#FEE2E2",color:w.status==="pending"?"#A16207":w.status==="approved"?"#15803D":"#DC2626",padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:700}}>{w.status}</span>
                  </div>
                </div>
                <div style={{fontSize:11,color:"#9A9A9A",marginBottom:10}}>Requested: {new Date(w.requested_at).toLocaleDateString("en-IN")}</div>
                {w.status==="pending"&&(
                  <div style={{display:"flex",gap:10}}>
                    <button onClick={()=>processWithdrawal(w.id,"rejected")} className="tap"
                      style={{flex:1,padding:"10px",background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:12,color:"#DC2626",fontWeight:700,fontSize:12,cursor:"pointer"}}>❌ Reject</button>
                    <button onClick={()=>processWithdrawal(w.id,"approved")} className="tap"
                      style={{flex:2,padding:"10px",background:"linear-gradient(135deg,#7C3AED,#6D28D9)",border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:12,cursor:"pointer"}}>✅ Approve Transfer</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const CProfile = ({user,lang,onLogout,onWallet,onChat,onRefer,onHelp}) => {
  const L = lang==="en";
  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh",paddingBottom:90}}>
      <div style={{background:"linear-gradient(145deg,#0F2D5C,#1A4080)",padding:"52px 20px 28px",borderRadius:"0 0 28px 28px"}}>
        <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:16}}>
          <div style={{width:60,height:60,borderRadius:20,background:"rgba(255,255,255,.15)",border:"2px solid rgba(255,255,255,.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,fontWeight:800,color:"white"}}>
            {(user.name||"U")[0]}
          </div>
          <div style={{flex:1}}>
            <div style={{color:"white",fontWeight:900,fontSize:20,letterSpacing:-.3}}>{user.name||"Customer"}</div>
            <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginTop:2}}>📱 +91 {user.phone}</div>
            <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginTop:1}}>📍 {user.area||"Lucknow"}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:10}}>
          {[["🎯",user.points||0,"Points"],["🏠",0,"Bookings"],["⭐","4.8","Rating"]].map(([ic,v,l])=>(
            <div key={l} style={{flex:1,background:"rgba(255,255,255,.1)",borderRadius:14,padding:"10px 8px",textAlign:"center"}}>
              <div style={{color:"white",fontWeight:900,fontSize:16}}>{v}</div>
              <div style={{color:"rgba(255,255,255,.55)",fontSize:10,marginTop:2}}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{padding:"20px 16px"}}>
        {[
          ["📋","My Bookings","View all your bookings",null,"#EFF6FF","#1D4ED8"],
          ["🤖","AI Support","Chat with our AI assistant",onChat,"#F3E8FF","#6D28D9"],
          ["🎁","Refer & Earn","Get ₹200 per referral",onRefer,"#FEF9C3","#A16207"],
          ["❓","Help & Support","FAQs, contact us",onHelp,"#ECFDF5","#065F46"],
          ["📞","Phone","+91 "+user.phone,null,"#F4F6FA","#545454"],
        ].map(([ic,l,v,action,bg,c],i)=>(
          <div key={l} onClick={action||undefined} className="fu"
            style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:10,display:"flex",gap:14,alignItems:"center",border:"1px solid #E8E8E8",cursor:action?"pointer":"default",animationDelay:`${i*35}ms`,boxShadow:"0 2px 6px rgba(0,0,0,.04)"}}>
            <div style={{width:44,height:44,borderRadius:15,background:bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{ic}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{l}</div>
              <div style={{color:"#9A9A9A",fontSize:12,marginTop:2}}>{v}</div>
            </div>
            {action&&<span style={{color:"#9A9A9A",fontSize:20,fontWeight:300}}>›</span>}
          </div>
        ))}

        <button onClick={onLogout} className="tap"
          style={{width:"100%",padding:"15px",background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:16,color:"#DC2626",fontWeight:800,fontSize:15,cursor:"pointer",marginTop:4}}>
          Sign Out
        </button>
      </div>
    </div>
  );
};


const CustomerApp = ({user,lang,setLang,onLogout}) => {
  const [tab,setTab]               = useState("home");
  const [cat,setCat]               = useState(null);
  const [booking,setBooking]       = useState(null);
  const [showWallet,setShowWallet] = useState(false);
  const [showChat,setShowChat]     = useState(false);
  const [showRefer,setShowRefer]   = useState(false);
  const [showHelp,setShowHelp]     = useState(false);
  const [trackBooking,setTrackBooking] = useState(null);
  const [currentUser,setCurrentUser]   = useState(user);
  const [showOnboard,setShowOnboard]   = useState(!user.name);
  const L = lang==="en";

  // Show onboarding for new users without a name
  if(showOnboard) return <CustomerOnboard user={currentUser} onDone={u=>{setCurrentUser(u);setShowOnboard(false);}}/>;

  if(booking)      return <Confirmed booking={booking} onHome={()=>{setBooking(null);setCat(null);setTab("home");}}/>;
  if(cat)          return <Booking cat={cat} user={currentUser} lang={lang} onBack={()=>setCat(null)} onDone={b=>{setBooking(b);setCat(null);}}/>;
  if(showWallet)   return <WalletScreen user={currentUser} lang={lang} onBack={()=>setShowWallet(false)}/>;
  if(showChat)     return <ChatSupport user={currentUser} onClose={()=>setShowChat(false)}/>;
  if(showRefer)    return <ReferEarn user={currentUser} onBack={()=>setShowRefer(false)}/>;
  if(showHelp)     return <HelpScreen user={currentUser} onBack={()=>setShowHelp(false)} onChat={()=>{setShowHelp(false);setShowChat(true);}}/>;
  if(trackBooking) return <LiveTracking booking={trackBooking} onBack={()=>setTrackBooking(null)}/>;

  return(
    <div style={{background:"#F4F6FA",minHeight:"100vh"}}>
      {tab==="home"     && <CHome     user={currentUser} lang={lang} setLang={setLang} onBook={setCat} onLogout={onLogout} onProfile={()=>setTab("profile")}/>}
      {tab==="bookings" && <CBookings user={currentUser} lang={lang} onTrack={setTrackBooking}/>}
      {tab==="profile"  && <CProfile  user={currentUser} lang={lang} onLogout={onLogout}
          onWallet={()=>setShowWallet(true)}
          onChat={()=>setShowChat(true)}
          onRefer={()=>setShowRefer(true)}
          onHelp={()=>setShowHelp(true)}
        />}

      {/* Floating AI chat button */}
      <button onClick={()=>setShowChat(true)} className="tap"
        style={{position:"fixed",bottom:82,right:18,width:52,height:52,borderRadius:18,background:"linear-gradient(135deg,#6D28D9,#7C3AED)",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,boxShadow:"0 8px 24px rgba(109,40,217,.4)",zIndex:100}}>
        🤖
      </button>

      <Nav active={tab} set={setTab} tabs={[
        {id:"home",    icon:"🏠",lbl:L?"Home":"होम"},
        {id:"bookings",icon:"📋",lbl:L?"Bookings":"बुकिंग"},
        {id:"profile", icon:"👤",lbl:L?"Profile":"प्रोफाइल"},
      ]}/>
    </div>
  );
};

// ══════════════════════════════════════════════════
//  EXPERT APPLICATION STATUS DASHBOARD
// ══════════════════════════════════════════════════
// ══════════════════════════════════════════════════
//  EXPERT APP (for approved experts)
// ══════════════════════════════════════════════════
const ExpertApp = ({user, lang, setLang, onLogout}) => {
  const [tab,setTab]           = useState("jobs");
  const [jobs,setJobs]         = useState([]);
  const [proData,setProData]   = useState(null);
  const [loading,setLoading]   = useState(true);
  const [isOnline,setIsOnline] = useState(false);
  const [showChat,setShowChat] = useState(false);
  const [showWallet,setShowWallet]   = useState(false);
  const [showReviews,setShowReviews] = useState(false);
  const [myReviews,setMyReviews]     = useState([]);
  const [newJobAlert,setNewJobAlert] = useState(null); // Rapido-style popup
  const [accepting,setAccepting]     = useState(false);
  const [timer,setTimer]             = useState(30); // 30s to accept
  const timerRef = useRef(null);
  const [otpModal,setOtpModal] = useState(null);   // job awaiting start-OTP
  const [otpInput,setOtpInput] = useState("");
  const [otpErr,setOtpErr]     = useState("");
  const [otpBusy,setOtpBusy]   = useState(false);
  const L = lang==="en";

  const loadData = async () => {
    try {
      const { data: pro } = await supabase.from("professionals")
        .select("*").eq("phone",user.phone).single();
      if(pro){ setProData(pro); setIsOnline(pro.status==="available"); }
      const { data: bookings } = await supabase.from("bookings")
        .select("*").eq("pro_phone",user.phone)
        .order("created_at",{ascending:false});
      setJobs(bookings||[]);
      const { data: reviews } = await supabase.from("reviews")
        .select("*").eq("pro_phone",user.phone)
        .order("created_at",{ascending:false});
      setMyReviews(reviews||[]);
    } catch(e){ console.error(e); }
    setLoading(false);
  };

  useEffect(()=>{ loadData(); },[user.phone]);

  // Real-time: listen for new bookings in expert's area (Rapido style)
  useEffect(()=>{
    if(!isOnline) return;
    const channel = supabase.channel("new_jobs_"+user.phone)
      .on("postgres_changes",{
        event:"INSERT", schema:"public", table:"bookings"
      },(payload)=>{
        const b = payload.new;
        const expertArea = proData?.service_areas||proData?.area||user.area||"";
        const expertSkills = proData?.skills||proData?.category||"";
        // Check if job is in expert's area and matches skills
        const areaMatch = expertArea.includes(b.area) || b.area===proData?.area;
        const skillMatch = expertSkills.toLowerCase().includes((b.category||"").toLowerCase()) || !b.category;
        if((areaMatch||true) && !b.pro_phone) {
          // Show Rapido-style popup
          setNewJobAlert(b);
          setTimer(30);
        }
      })
      .subscribe();
    return ()=>supabase.removeChannel(channel);
  },[isOnline, proData?.area, user.phone]);

  // Countdown timer for job alert
  useEffect(()=>{
    if(!newJobAlert) return;
    timerRef.current = setInterval(()=>{
      setTimer(t=>{
        if(t<=1){
          clearInterval(timerRef.current);
          setNewJobAlert(null); // Auto-dismiss
          return 0;
        }
        return t-1;
      });
    },1000);
    return ()=>clearInterval(timerRef.current);
  },[newJobAlert]);

  const acceptJob = async () => {
    if(!newJobAlert) return;
    setAccepting(true);
    clearInterval(timerRef.current);
    try {
      await supabase.from("bookings").update({
        pro_phone: user.phone,
        pro_name: user.name,
        status: "confirmed"
      }).eq("id", newJobAlert.id);
      setJobs(prev=>[{...newJobAlert, pro_phone:user.phone, pro_name:user.name, status:"confirmed"}, ...prev]);
      setNewJobAlert(null);
    } catch(e){ console.error(e); }
    setAccepting(false);
  };

  const declineJob = () => {
    clearInterval(timerRef.current);
    setNewJobAlert(null);
  };

  const toggleOnline = async () => {
    const newStatus = isOnline?"offline":"available";
    setIsOnline(!isOnline);
    if(newStatus==="offline") setNewJobAlert(null);
    try { await supabase.from("professionals").update({status:newStatus}).eq("phone",user.phone); }
    catch(e){ console.error(e); }
  };

  const EXPERT_FUNCTIONS_BASE = "https://lwwygijjslkezxpycpgn.supabase.co/functions/v1";
  const startJobWithOtp = async () => {
    if(!otpModal) return;
    setOtpErr(""); setOtpBusy(true);
    try {
      const { data:{ session } } = await supabase.auth.getSession();
      const res = await fetch(EXPERT_FUNCTIONS_BASE + "/verify-start-otp", {
        method:"POST",
        headers:{ "Content-Type":"application/json", Authorization:"Bearer "+(session?.access_token||"sb_publishable_Ep4nBdwjVDJRYEPx3XTv2Q_DEXrwFJb") },
        body: JSON.stringify({ booking_id: otpModal.id, otp: otpInput }),
      });
      const r = await res.json();
      if(!res.ok) throw new Error(r.error||"Wrong OTP");
      setJobs(prev=>prev.map(j=>j.id===otpModal.id?{...j,status:"in-progress"}:j));
      setOtpModal(null); setOtpInput("");
    } catch(e){ setOtpErr(e.message||"Verification failed"); }
    setOtpBusy(false);
  };

  const updateJobStatus = async (id, status) => {
    await supabase.from("bookings").update({status}).eq("id",id);
    setJobs(prev=>prev.map(j=>j.id===id?{...j,status}:j));
  };

  const earnings = (proData?.earnings||0) + jobs.filter(j=>j.status==="completed").reduce((s,j)=>s+Math.round((j.amount||0)*.8),0);
  const avgRating = myReviews.length>0?(myReviews.reduce((s,r)=>s+r.rating,0)/myReviews.length).toFixed(1):(proData?.rating||5.0);
  const completedJobs = jobs.filter(j=>j.status==="completed").length;
  const pendingJobs = jobs.filter(j=>j.status==="pending"||j.status==="confirmed").length;

  if(showChat) return <ChatSupport user={user} onClose={()=>setShowChat(false)}/>;
  if(showWallet) return <WalletScreen user={user} lang={lang} onBack={()=>setShowWallet(false)}/>;
  if(showReviews) return <ReviewsList proPhone={user.phone} onClose={()=>setShowReviews(false)}/>;

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh"}}>

      {otpModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={()=>{setOtpModal(null);setOtpInput("");setOtpErr("");}}>
          <div style={{background:"white",borderRadius:"28px 28px 0 0",padding:"24px 20px 40px",width:"100%",maxWidth:430}} onClick={e=>e.stopPropagation()}>
            <div style={{width:40,height:4,background:"#E8E8E8",borderRadius:4,margin:"0 auto 20px"}}/>
            <div style={{fontWeight:900,color:"#0D0D0D",fontSize:20,marginBottom:4}}>Enter Start OTP</div>
            <div style={{color:"#9A9A9A",fontSize:13,marginBottom:20}}>Ask the customer for their 4-digit code to start this job.</div>
            <input value={otpInput} onChange={e=>setOtpInput(e.target.value.replace(/\D/g,"").slice(0,4))}
              inputMode="numeric" maxLength={4} placeholder="----"
              style={{width:"100%",padding:"16px",textAlign:"center",fontSize:28,fontWeight:900,letterSpacing:8,border:"2px solid #E8E8E8",borderRadius:14,boxSizing:"border-box",outline:"none",marginBottom:12,color:"#0D0D0D"}}/>
            {otpErr&&<div style={{background:"#FEE2E2",borderRadius:10,padding:"10px 14px",color:"#DC2626",fontSize:13,marginBottom:12,textAlign:"center"}}>{otpErr}</div>}
            <button onClick={startJobWithOtp} disabled={otpBusy||otpInput.length<4} className="tap"
              style={{width:"100%",padding:"15px",background:otpInput.length<4?"#D1D5DB":"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:otpInput.length<4?"not-allowed":"pointer"}}>
              {otpBusy?"Verifying...":"🚀 Verify & Start Job"}
            </button>
          </div>
        </div>
      )}

      {/* ── RAPIDO STYLE JOB ALERT POPUP ── */}
      {newJobAlert&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div className="su" style={{background:"white",borderRadius:"28px 28px 0 0",padding:"0 0 32px",width:"100%",maxWidth:430,overflow:"hidden"}}>
            {/* Timer bar */}
            <div style={{height:5,background:"#E8E8E8"}}>
              <div style={{height:"100%",background:`linear-gradient(90deg,#065F46,#22C55E)`,width:`${(timer/30)*100}%`,transition:"width 1s linear",borderRadius:4}}/>
            </div>

            {/* Header */}
            <div style={{background:"linear-gradient(135deg,#065F46,#047857)",padding:"20px 20px 16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:10,height:10,borderRadius:"50%",background:"#4ADE80",animation:"pulse 1s infinite"}}/>
                  <span style={{color:"white",fontWeight:800,fontSize:16}}>New Job Request! 🔔</span>
                </div>
                <div style={{background:"rgba(255,255,255,.2)",borderRadius:20,padding:"4px 12px",display:"flex",alignItems:"center",gap:4}}>
                  <span style={{color:"#FBBF24",fontWeight:900,fontSize:18}}>{timer}</span>
                  <span style={{color:"rgba(255,255,255,.7)",fontSize:11}}>sec</span>
                </div>
              </div>
              <div style={{color:"rgba(255,255,255,.7)",fontSize:12}}>Accept quickly before it goes to another expert</div>
            </div>

            <div style={{padding:"16px 20px"}}>
              {/* Service details */}
              <div style={{background:"#F4F6FA",borderRadius:18,padding:"16px",marginBottom:16}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                  <div>
                    <div style={{fontWeight:900,color:"#0D0D0D",fontSize:18}}>{newJobAlert.service_name}</div>
                    <div style={{fontSize:13,color:"#9A9A9A",marginTop:2}}>{newJobAlert.category}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{fontWeight:900,color:"#065F46",fontSize:24}}>₹{Math.round((newJobAlert.amount||0)*.8)}</div>
                    <div style={{fontSize:10,color:"#9A9A9A"}}>your earning</div>
                  </div>
                </div>
                {[
                  ["📅",`${newJobAlert.date} at ${newJobAlert.time}`],
                  ["📍",newJobAlert.area],
                  ["🏠",newJobAlert.address],
                  ["👤",newJobAlert.customer_name||"Customer"],
                ].map(([ic,v])=>v&&(
                  <div key={ic} style={{display:"flex",gap:10,marginBottom:6,alignItems:"flex-start"}}>
                    <span style={{fontSize:14,flexShrink:0}}>{ic}</span>
                    <span style={{fontSize:13,color:"#545454",lineHeight:1.4}}>{v}</span>
                  </div>
                ))}
              </div>

              {/* Earning breakdown */}
              <div style={{display:"flex",gap:10,marginBottom:20}}>
                <div style={{flex:1,background:"#ECFDF5",borderRadius:14,padding:"12px",textAlign:"center",border:"1px solid #BBF7D0"}}>
                  <div style={{fontWeight:900,color:"#065F46",fontSize:20}}>₹{Math.round((newJobAlert.amount||0)*.8)}</div>
                  <div style={{fontSize:11,color:"#065F46",marginTop:2}}>Your Earning</div>
                </div>
                <div style={{flex:1,background:"#F3E8FF",borderRadius:14,padding:"12px",textAlign:"center",border:"1px solid #DDD6FE"}}>
                  <div style={{fontWeight:900,color:"#7C3AED",fontSize:20}}>₹{Math.round((newJobAlert.amount||0)*.2)}</div>
                  <div style={{fontSize:11,color:"#7C3AED",marginTop:2}}>Platform Fee</div>
                </div>
                <div style={{flex:1,background:"#EFF6FF",borderRadius:14,padding:"12px",textAlign:"center",border:"1px solid #BFDBFE"}}>
                  <div style={{fontWeight:900,color:"#1D4ED8",fontSize:20}}>₹{newJobAlert.amount||0}</div>
                  <div style={{fontSize:11,color:"#1D4ED8",marginTop:2}}>Total</div>
                </div>
              </div>

              {/* Accept / Decline buttons */}
              <div style={{display:"flex",gap:12}}>
                <button onClick={declineJob} className="tap"
                  style={{flex:1,padding:"16px",background:"#FEE2E2",border:"2px solid #FECACA",borderRadius:18,color:"#DC2626",fontWeight:800,fontSize:16,cursor:"pointer"}}>
                  ❌ Decline
                </button>
                <button onClick={acceptJob} disabled={accepting} className="tap"
                  style={{flex:2,padding:"16px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:18,color:"white",fontWeight:900,fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8,boxShadow:"0 8px 24px rgba(6,95,70,.4)"}}>
                  {accepting?<Spinner/>:"✅ Accept"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {tab==="jobs"&&(
        <div style={{paddingBottom:90}}>
          <div style={{background:"linear-gradient(145deg,#065F46,#047857)",padding:"52px 16px 24px",borderRadius:"0 0 28px 28px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div style={{display:"flex",gap:10,alignItems:"center"}}>
                <Logo size={34} white/>
                <div>
                  <div style={{color:"white",fontWeight:900,fontSize:16}}>Expert Panel</div>
                  <div style={{color:"rgba(255,255,255,.6)",fontSize:11}}>GharPe Professional</div>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setShowChat(true)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 10px",color:"white",fontSize:18,cursor:"pointer"}}>🤖</button>
                <button onClick={()=>setLang(l=>l==="en"?"hi":"en")} style={{background:"rgba(255,255,255,.12)",border:"1px solid rgba(255,255,255,.2)",borderRadius:20,padding:"5px 12px",color:"rgba(255,255,255,.9)",fontWeight:600,fontSize:11,cursor:"pointer"}}>{L?"हिंदी":"ENG"}</button>
              </div>
            </div>
            <div style={{background:"rgba(255,255,255,.12)",borderRadius:20,padding:"16px",border:"1px solid rgba(255,255,255,.15)"}}>
              <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:14}}>
                <div style={{width:52,height:52,borderRadius:18,background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0}}>
                  {proData?.selfie_url&&proData.selfie_url.startsWith("http")?
                    <img src={proData.selfie_url} alt="" style={{width:52,height:52,borderRadius:18,objectFit:"cover"}}/>:"🔧"}
                </div>
                <div style={{flex:1}}>
                  <div style={{color:"white",fontWeight:900,fontSize:17}}>{user.name||"Expert"}</div>
                  <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginTop:1}}>{proData?.category||"Professional"} · {proData?.experience||""}</div>
                </div>
                <div style={{textAlign:"center"}}>
                  <button onClick={toggleOnline}
                    style={{width:52,height:28,borderRadius:14,background:isOnline?"#4ADE80":"rgba(255,255,255,.25)",border:"none",cursor:"pointer",position:"relative",transition:"background .3s",display:"block"}}>
                    <div style={{position:"absolute",top:3,left:isOnline?26:3,width:22,height:22,borderRadius:"50%",background:"white",transition:"left .3s",boxShadow:"0 2px 4px rgba(0,0,0,.2)"}}/>
                  </button>
                  <div style={{color:isOnline?"#4ADE80":"rgba(255,255,255,.5)",fontSize:10,fontWeight:700,marginTop:4}}>{isOnline?"ONLINE":"OFFLINE"}</div>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:8}}>
                {[["⭐",avgRating,"Rating"],["✅",completedJobs,"Done"],["⏳",pendingJobs,"Pending"],["💰","₹"+Math.round(earnings/1000)+"K","Earned"]].map(([ic,v,l])=>(
                  <div key={l} style={{background:"rgba(255,255,255,.1)",borderRadius:12,padding:"10px 6px",textAlign:"center"}}>
                    <div style={{fontSize:13,marginBottom:2}}>{ic}</div>
                    <div style={{color:"white",fontWeight:900,fontSize:13}}>{v}</div>
                    <div style={{color:"rgba(255,255,255,.55)",fontSize:9,marginTop:1}}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{padding:"16px"}}>
            {!isOnline&&(
              <div style={{background:"#FEF9C3",border:"1px solid #FDE68A",borderRadius:14,padding:"14px 16px",marginBottom:16,display:"flex",gap:10,alignItems:"center"}}>
                <span style={{fontSize:20}}>⚠️</span>
                <div>
                  <div style={{fontWeight:700,color:"#A16207",fontSize:13}}>You are Offline</div>
                  <div style={{fontSize:12,color:"#A16207"}}>Toggle online to start receiving jobs</div>
                </div>
              </div>
            )}
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:17,marginBottom:14}}>My Jobs ({jobs.length})</div>
            {loading&&<div style={{textAlign:"center",padding:40,color:"#9A9A9A"}}>Loading...</div>}
            {!loading&&jobs.length===0&&(
              <div style={{background:"white",borderRadius:18,padding:"40px 20px",textAlign:"center",border:"1px solid #E8E8E8"}}>
                <div style={{fontSize:52,marginBottom:12}}>📋</div>
                <div style={{fontWeight:700,color:"#0D0D0D",fontSize:16,marginBottom:6}}>No jobs yet!</div>
                <div style={{fontSize:13,color:"#9A9A9A"}}>Go online to receive bookings</div>
              </div>
            )}
            {jobs.map((j,i)=>(
              <div key={j.id} className="fu" style={{background:"white",borderRadius:20,marginBottom:14,border:`2px solid ${j.status==="in-progress"?"#FBBF24":j.status==="confirmed"?"#86EFAC":"#E8E8E8"}`,overflow:"hidden",animationDelay:`${i*50}ms`}}>
                <div style={{height:4,background:j.status==="completed"?"#22C55E":j.status==="in-progress"?"#FBBF24":j.status==="confirmed"?"#3B82F6":"#E2E8F0"}}/>
                <div style={{padding:"14px 16px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                    <div>
                      <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15}}>{j.service_name}</div>
                      <div style={{fontSize:12,color:"#9A9A9A",marginTop:2}}>#{j.id}</div>
                    </div>
                    <StatusPill status={j.status}/>
                  </div>
                  <div style={{background:"#F4F6FA",borderRadius:10,padding:"10px 12px",marginBottom:12}}>
                    {[["👤",j.customer_name||j.customer_phone],["📅",`${j.date} at ${j.time}`],["📍",j.area],["🏠",j.address]].map(([ic,v],idx)=>(
                      v&&<div key={idx} style={{display:"flex",gap:8,marginBottom:idx<3?4:0}}>
                        <span style={{fontSize:13,width:18,flexShrink:0}}>{ic}</span>
                        <span style={{fontSize:12,color:"#545454"}}>{v}</span>
                      </div>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,background:"#ECFDF5",borderRadius:10,padding:"8px 12px"}}>
                    <span style={{fontSize:12,color:"#065F46",fontWeight:600}}>Your Earning (80%)</span>
                    <span style={{fontWeight:900,color:"#065F46",fontSize:16}}>₹{Math.round((j.amount||0)*.8)}</span>
                  </div>
                  {j.status==="confirmed"&&(
                    <div style={{display:"flex",gap:10}}>
                      <a href={`tel:${j.customer_phone}`}
                        style={{flex:1,padding:"11px",background:"#EFF6FF",borderRadius:12,color:"#1D4ED8",fontWeight:700,fontSize:13,textAlign:"center",textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                        📞 Call
                      </a>
                      <button onClick={()=>{setOtpModal(j);setOtpInput("");setOtpErr("");}} className="tap"
                        style={{flex:2,padding:"11px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                        🚀 Start Job
                      </button>
                    </div>
                  )}
                  {j.status==="in-progress"&&(
                    <button onClick={()=>updateJobStatus(j.id,"awaiting-confirmation")} className="tap"
                      style={{width:"100%",padding:"13px",background:"linear-gradient(135deg,#1D4ED8,#2563EB)",border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:14,cursor:"pointer"}}>
                      ✅ Mark as Completed
                    </button>
                  )}
                  {j.status==="awaiting-confirmation"&&(
                    <div style={{padding:"11px",background:"#FEF3C7",borderRadius:12,color:"#B45309",fontWeight:700,fontSize:12,textAlign:"center"}}>
                      ⏳ Waiting for customer to confirm completion
                    </div>
                  )}
                  {j.status==="pending"&&(
                    <div style={{display:"flex",gap:10}}>
                      <button onClick={()=>updateJobStatus(j.id,"cancelled")} className="tap"
                        style={{flex:1,padding:"11px",background:"#FEE2E2",border:"none",borderRadius:12,color:"#DC2626",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                        ❌ Decline
                      </button>
                      <button onClick={()=>updateJobStatus(j.id,"confirmed")} className="tap"
                        style={{flex:2,padding:"11px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:12,color:"white",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                        ✅ Accept Job
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {tab==="earn"&&(
        <div style={{paddingBottom:90}}>
          <div style={{background:"linear-gradient(145deg,#065F46,#047857)",padding:"52px 16px 28px",borderRadius:"0 0 28px 28px"}}>
            <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginBottom:4}}>Total Earnings</div>
            <div style={{color:"white",fontSize:44,fontWeight:900,letterSpacing:-1.5}}>₹{earnings.toLocaleString()}</div>
            <div style={{color:"rgba(255,255,255,.55)",fontSize:12,marginTop:4}}>{completedJobs} jobs · avg ₹{completedJobs>0?Math.round(earnings/completedJobs):0}/job</div>
          </div>
          <div style={{padding:"16px"}}>
            {[
              {label:"Total Earnings",value:"₹"+earnings.toLocaleString(),bg:"#ECFDF5",c:"#065F46"},
              {label:"Pending Payout",value:"₹"+(proData?.pending_payout||0),bg:"#FEF9C3",c:"#A16207"},
              {label:"Completed Jobs",value:completedJobs,bg:"#EFF6FF",c:"#1D4ED8"},
              {label:"Average Rating",value:"⭐ "+avgRating,bg:"#FEF9C3",c:"#A16207"},
            ].map(s=>(
              <div key={s.label} style={{background:s.bg,borderRadius:16,padding:"16px 18px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center",border:`1px solid ${s.c}22`}}>
                <span style={{fontWeight:600,color:"#545454",fontSize:14}}>{s.label}</span>
                <span style={{fontWeight:900,color:s.c,fontSize:22}}>{s.value}</span>
              </div>
            ))}
            <button onClick={()=>setShowWallet(true)} className="tap"
              style={{width:"100%",padding:"15px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:"pointer",boxShadow:"0 8px 24px rgba(6,95,70,.3)"}}>
              💰 View Wallet & Withdraw
            </button>
          </div>
        </div>
      )}

      {tab==="profile"&&(
        <div style={{paddingBottom:90}}>
          <div style={{background:"linear-gradient(145deg,#065F46,#047857)",padding:"52px 16px 28px",borderRadius:"0 0 28px 28px"}}>
            <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:16}}>
              <div style={{width:64,height:64,borderRadius:22,background:"rgba(255,255,255,.15)",border:"2.5px solid rgba(255,255,255,.3)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:28}}>
                {proData?.selfie_url&&proData.selfie_url.startsWith("http")?
                  <img src={proData.selfie_url} alt="" style={{width:64,height:64,borderRadius:20,objectFit:"cover"}}/>:"🔧"}
              </div>
              <div style={{flex:1}}>
                <div style={{color:"white",fontWeight:900,fontSize:20}}>{user.name||"Expert"}</div>
                <div style={{color:"rgba(255,255,255,.65)",fontSize:13,marginTop:2}}>{proData?.category}</div>
                <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginTop:1}}>📱 +91 {user.phone}</div>
              </div>
              <button onClick={()=>setShowReviews(true)}
                style={{background:"rgba(255,255,255,.15)",border:"1px solid rgba(255,255,255,.25)",borderRadius:12,padding:"8px 14px",color:"white",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                ⭐ Reviews
              </button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              {[["⭐",avgRating,"Rating"],["✅",completedJobs,"Jobs"],["💰","₹"+Math.round(earnings/1000)+"K","Earned"]].map(([ic,v,l])=>(
                <div key={l} style={{background:"rgba(255,255,255,.1)",borderRadius:14,padding:"12px 8px",textAlign:"center"}}>
                  <div style={{color:"white",fontWeight:900,fontSize:18}}>{v}</div>
                  <div style={{color:"rgba(255,255,255,.6)",fontSize:10,marginTop:2}}>{l}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{padding:"16px"}}>
            {[
              ["📍","Service Area",proData?.area||"Lucknow",null],
              ["🛠️","Skills",proData?.skills||proData?.category||"—",null],
              ["📅","Experience",proData?.experience||"—",null],
              ["🏦","Bank","XXXX"+String(proData?.bank_account||"").slice(-4)||"Not set",null],
              ["🤖","AI Support","Get help anytime",()=>setShowChat(true)],
              ["💰","My Wallet","Earnings & withdrawals",()=>setShowWallet(true)],
              ["⭐","My Reviews","Customer feedback",()=>setShowReviews(true)],
            ].map(([ic,l,v,action],i)=>(
              <div key={l} onClick={action||undefined} className="fu"
                style={{background:"white",borderRadius:16,padding:"14px 16px",marginBottom:10,display:"flex",gap:14,alignItems:"center",border:"1px solid #E8E8E8",cursor:action?"pointer":"default",animationDelay:`${i*35}ms`}}>
                <div style={{width:42,height:42,borderRadius:14,background:"#ECFDF5",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{ic}</div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,color:"#0D0D0D",fontSize:14}}>{l}</div>
                  <div style={{color:"#9A9A9A",fontSize:12,marginTop:2}}>{v}</div>
                </div>
                {action&&<span style={{color:"#9A9A9A",fontSize:20}}>›</span>}
              </div>
            ))}
            <button onClick={onLogout} className="tap"
              style={{width:"100%",padding:"14px",background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:16,color:"#DC2626",fontWeight:800,fontSize:15,cursor:"pointer",marginTop:4}}>
              Sign Out
            </button>
          </div>
        </div>
      )}

      <Nav active={tab} set={setTab} tabs={[
        {id:"jobs",   icon:"🔨",lbl:L?"Jobs":"काम",badge:pendingJobs},
        {id:"earn",   icon:"💰",lbl:L?"Earn":"कमाई"},
        {id:"profile",icon:"👤",lbl:L?"Profile":"प्रोफाइल"},
      ]}/>
    </div>
  );
};

const ExpertStatusDashboard = ({user, onLogout, onResubmit}) => {
  const [proData, setProData]   = useState(null);
  const [loading, setLoading]   = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [showReupload, setShowReupload] = useState(false);
  const [newDoc, setNewDoc]     = useState({aadhaarFront:null, aadhaarBack:null, panPhoto:null, selfie:null});
  const [submitting, setSubmitting] = useState(false);

  const STATUS_CONFIG = {
    pending:      {color:"#A16207",bg:"#FEF9C3",border:"#FDE68A",icon:"⏳",label:"Pending Verification",step:1},
    under_review: {color:"#EA580C",bg:"#FFEDD5",border:"#FED7AA",icon:"🟠",label:"Under Review",step:2},
    verification: {color:"#1D4ED8",bg:"#EFF6FF",border:"#BFDBFE",icon:"🔵",label:"Verification in Progress",step:3},
    more_docs:    {color:"#7C3AED",bg:"#F3E8FF",border:"#DDD6FE",icon:"📄",label:"Additional Documents Required",step:2},
    approved:     {color:"#15803D",bg:"#DCFCE7",border:"#BBF7D0",icon:"✅",label:"Approved",step:5},
    rejected:     {color:"#DC2626",bg:"#FEE2E2",border:"#FECACA",icon:"❌",label:"Rejected",step:0},
    suspended:    {color:"#475569",bg:"#F1F5F9",border:"#CBD5E1",icon:"⚫",label:"Suspended",step:0},
  };

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await supabase.from("professionals")
        .select("*").eq("phone", user.phone).single();
      if(data) setProData(data);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  useEffect(()=>{ load(); },[user.phone]);

  // Real-time subscription for instant status updates
  useEffect(()=>{
    const channel = supabase
      .channel("expert_status_"+user.phone)
      .on("postgres_changes", {
        event:"UPDATE",
        schema:"public",
        table:"professionals",
        filter:`phone=eq.${user.phone}`
      }, (payload)=>{
        console.log("Real-time update:", payload.new);
        setProData(payload.new);
      })
      .subscribe();

    // Also poll every 10 seconds as backup
    const interval = setInterval(load, 10000);

    return ()=>{
      supabase.removeChannel(channel);
      clearInterval(interval);
    };
  },[user.phone]);

  const resubmitDocs = async () => {
    setSubmitting(true);
    try {
      const updates = {
        verification_status: "under_review",
        more_docs_reason: null,
      };
      if(newDoc.aadhaarFront) updates.aadhaar_front_url = newDoc.aadhaarFront;
      if(newDoc.aadhaarBack)  updates.aadhaar_back_url  = newDoc.aadhaarBack;
      if(newDoc.panPhoto)     updates.pan_url            = newDoc.panPhoto;
      if(newDoc.selfie)       updates.selfie_url         = newDoc.selfie;
      await supabase.from("professionals").update(updates).eq("phone", user.phone);
      await supabase.from("users").update({verification_status:"under_review"}).eq("phone", user.phone);
      setShowReupload(false);
      setNewDoc({aadhaarFront:null,aadhaarBack:null,panPhoto:null,selfie:null});
      load();
    } catch(e) { console.error(e); }
    setSubmitting(false);
  };

  if(showChat) return <ChatSupport user={user} onClose={()=>setShowChat(false)}/>;

  const status = proData?.verification_status || user.verification_status || "pending";
  const sc = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const appId = "EXP-2026-" + String(user.phone).slice(-6);

  const STEPS = [
    {label:"Registration Submitted",    icon:"📝",done:sc.step>=1},
    {label:"Documents Submitted",       icon:"📄",done:sc.step>=1},
    {label:"Under Review",              icon:"🔍",done:sc.step>=2},
    {label:"Verification in Progress",  icon:"⚙️",done:sc.step>=3},
    {label:"Approved",                  icon:"✅",done:sc.step>=5},
  ];

  return (
    <div style={{background:"#F4F6FA",minHeight:"100vh"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(145deg,#065F46,#047857)",padding:"52px 20px 28px",borderRadius:"0 0 28px 28px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:20}}>
          <div style={{display:"flex",gap:12,alignItems:"center"}}>
            <div style={{width:52,height:52,borderRadius:18,background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>
              {proData?.selfie_url&&proData.selfie_url.startsWith("data:")?
                <img src={proData.selfie_url} alt="" style={{width:52,height:52,borderRadius:18,objectFit:"cover"}}/>:"🔧"}
            </div>
            <div>
              <div style={{color:"white",fontWeight:900,fontSize:18}}>{proData?.name||user.name||"Expert"}</div>
              <div style={{color:"rgba(255,255,255,.65)",fontSize:12,marginTop:2}}>📱 +91 {user.phone}</div>
            </div>
          </div>
          <button onClick={()=>load()} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:10,padding:"6px 12px",color:"white",fontSize:18,cursor:"pointer"}}>🔄</button>
        </div>

        {/* Status badge */}
        <div style={{background:"rgba(255,255,255,.12)",borderRadius:18,padding:"16px 18px",border:"1px solid rgba(255,255,255,.15)"}}>
          <div style={{color:"rgba(255,255,255,.65)",fontSize:11,letterSpacing:.5,marginBottom:6}}>APPLICATION STATUS</div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
            <div style={{width:14,height:14,borderRadius:"50%",background:sc.color,
              animation:status==="pending"||status==="under_review"||status==="verification"?"pulse 2s infinite":"none"}}/>
            <span style={{color:"white",fontWeight:900,fontSize:20}}>{sc.icon} {sc.label}</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {[["App ID",appId],["Submitted",proData?.registered_at?new Date(proData.registered_at).toLocaleDateString("en-IN"):"Today"],
              ["Updated",proData?.updated_at?new Date(proData.updated_at).toLocaleDateString("en-IN"):"—"],
              ["Category",proData?.category||"General"]].map(([l,v])=>(
              <div key={l}>
                <div style={{color:"rgba(255,255,255,.5)",fontSize:9,letterSpacing:.5}}>{l}</div>
                <div style={{color:"white",fontWeight:700,fontSize:11,marginTop:1}}>{v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{padding:"20px 16px",paddingBottom:100}}>
        {loading&&<div style={{textAlign:"center",padding:30,color:"#9A9A9A"}}>Fetching latest status...</div>}

        {/* Admin remarks */}
        {proData?.admin_note&&(
          <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:16,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontWeight:700,color:"#1D4ED8",fontSize:13,marginBottom:4}}>💬 Admin Remark</div>
            <div style={{fontSize:13,color:"#1D4ED8",lineHeight:1.6}}>{proData.admin_note}</div>
          </div>
        )}

        {/* Rejection reason */}
        {status==="rejected"&&proData?.rejected_reason&&(
          <div style={{background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:16,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontWeight:700,color:"#DC2626",fontSize:13,marginBottom:4}}>❌ Rejection Reason</div>
            <div style={{fontSize:13,color:"#DC2626",lineHeight:1.6}}>{proData.rejected_reason}</div>
            <button onClick={()=>setShowReupload(true)} className="tap"
              style={{marginTop:10,padding:"10px 20px",background:"#DC2626",border:"none",borderRadius:12,color:"white",fontWeight:700,fontSize:13,cursor:"pointer"}}>
              📤 Re-submit Documents
            </button>
          </div>
        )}

        {/* More docs needed */}
        {status==="more_docs"&&proData?.more_docs_reason&&(
          <div style={{background:"#F3E8FF",border:"1px solid #DDD6FE",borderRadius:16,padding:"14px 16px",marginBottom:16}}>
            <div style={{fontWeight:700,color:"#7C3AED",fontSize:13,marginBottom:4}}>📄 Additional Documents Required</div>
            <div style={{fontSize:13,color:"#7C3AED",lineHeight:1.6}}>{proData.more_docs_reason}</div>
            <button onClick={()=>setShowReupload(true)} className="tap"
              style={{marginTop:10,padding:"10px 20px",background:"#7C3AED",border:"none",borderRadius:12,color:"white",fontWeight:700,fontSize:13,cursor:"pointer"}}>
              📤 Upload Documents
            </button>
          </div>
        )}

        {/* Progress steps */}
        <div style={{background:"white",borderRadius:18,padding:"18px 16px",marginBottom:16,border:"1px solid #E8E8E8"}}>
          <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15,marginBottom:16}}>Verification Progress</div>
          {STEPS.map((s,i)=>(
            <div key={i} style={{display:"flex",gap:12,marginBottom:i<STEPS.length-1?4:0}}>
              <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                <div style={{width:36,height:36,borderRadius:12,
                  background:s.done?(status==="rejected"&&i===4?"#FEE2E2":"#ECFDF5"):"#F4F6FA",
                  border:`2px solid ${s.done?(status==="rejected"&&i===4?"#DC2626":"#065F46"):"#E8E8E8"}`,
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0,
                  boxShadow:s.done&&!(status==="rejected"&&i===4)?"0 2px 8px rgba(6,95,70,.2)":"none"}}>
                  {s.done?(status==="rejected"&&i===4?"❌":s.icon):<span style={{color:"#9A9A9A",fontSize:11}}>{i+1}</span>}
                </div>
                {i<STEPS.length-1&&<div style={{width:2,height:24,background:s.done?"#065F46":"#E8E8E8",margin:"3px 0"}}/>}
              </div>
              <div style={{paddingTop:8}}>
                <div style={{fontWeight:s.done?700:400,color:s.done?"#0D0D0D":"#9A9A9A",fontSize:13}}>{s.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Uploaded documents preview */}
        <div style={{background:"white",borderRadius:18,padding:"16px",marginBottom:16,border:"1px solid #E8E8E8"}}>
          <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15,marginBottom:14}}>📄 Your Documents</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {[
              ["🤳","Selfie",proData?.selfie_url],
              ["📄","Aadhaar Front",proData?.aadhaar_front_url],
              ["📄","Aadhaar Back",proData?.aadhaar_back_url],
              ["💳","PAN Card",proData?.pan_url],
            ].map(([ic,label,url])=>{
              const isBase64 = url && url.startsWith("data:");
              const isHttpUrl = url && url.startsWith("http");
              const isUploaded = isBase64 || isHttpUrl;
              return (
                <div key={label} style={{background:"#F4F6FA",borderRadius:14,padding:12,textAlign:"center",border:`1px solid ${isUploaded?"#6EE7B7":"#E8E8E8"}`}}>
                  {isBase64 ? (
                    <img src={url} alt={label} style={{width:"100%",height:70,objectFit:"cover",borderRadius:10,marginBottom:6}}/>
                  ) : isHttpUrl ? (
                    <a href={url} target="_blank" rel="noreferrer" style={{display:"block",textDecoration:"none"}}>
                      <div style={{fontSize:28,padding:"8px 0"}}>{ic}</div>
                      <div style={{fontSize:10,color:"#1D4ED8",fontWeight:600}}>Tap to view</div>
                    </a>
                  ) : (
                    <div style={{fontSize:28,padding:"10px 0"}}>{ic}</div>
                  )}
                  <div style={{fontSize:11,fontWeight:600,color:"#545454",marginTop:4}}>{label}</div>
                  <div style={{fontSize:10,fontWeight:700,color:isUploaded?"#065F46":"#DC2626",marginTop:2}}>
                    {isUploaded ? "✅ Uploaded" : "❌ Missing"}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Profile summary */}
        {proData&&(
          <div style={{background:"white",borderRadius:18,padding:"16px",marginBottom:16,border:"1px solid #E8E8E8"}}>
            <div style={{fontWeight:800,color:"#0D0D0D",fontSize:15,marginBottom:12}}>👤 Your Profile</div>
            {[["Category",proData.category],["Experience",proData.experience],["Skills",proData.skills],["City",proData.city||proData.area],["Aadhaar","XXXX XXXX "+String(proData.aadhaar_number||"").slice(-4)],["PAN",proData.pan_number]].map(([l,v])=>v&&(
              <div key={l} style={{display:"flex",gap:8,padding:"7px 0",borderBottom:"1px solid #F4F6FA"}}>
                <span style={{color:"#9A9A9A",fontSize:12,width:80,flexShrink:0}}>{l}</span>
                <span style={{color:"#0D0D0D",fontSize:12,fontWeight:600}}>{v}</span>
              </div>
            ))}
          </div>
        )}

        {/* Timeline */}
        <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:16,padding:"14px 16px",marginBottom:16}}>
          <div style={{fontWeight:700,color:"#1D4ED8",fontSize:13,marginBottom:6}}>⏱️ Expected Timeline</div>
          <div style={{fontSize:12,color:"#1D4ED8",lineHeight:1.8}}>
            • Document check: <b>24 hours</b><br/>
            • Background verification: <b>2-3 days</b><br/>
            • Admin approval SMS: <b>within 48 hours</b>
          </div>
        </div>

        {/* What you can do after approval */}
        <div style={{background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:16,padding:"14px 16px",marginBottom:20}}>
          <div style={{fontWeight:700,color:"#065F46",fontSize:13,marginBottom:8}}>🚀 After Approval You Can:</div>
          {["Go Online and accept customer bookings","View and manage your jobs","Earn money — ₹15,000-₹50,000/month","Build your ratings and reviews","Access earnings & wallet"].map((item,i)=>(
            <div key={i} style={{fontSize:12,color:"#065F46",marginBottom:4}}>✓ {item}</div>
          ))}
        </div>

        {/* Contact options */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:20}}>
          <button onClick={()=>setShowChat(true)} className="tap"
            style={{padding:"14px",background:"#F3E8FF",border:"1px solid #DDD6FE",borderRadius:16,cursor:"pointer",textAlign:"center"}}>
            <div style={{fontSize:24,marginBottom:4}}>🤖</div>
            <div style={{fontWeight:700,color:"#7C3AED",fontSize:13}}>AI Support</div>
            <div style={{fontSize:10,color:"#9A9A9A",marginTop:2}}>24/7 help</div>
          </button>
          <a href={`https://wa.me/919000000001?text=Hi, my expert application status. App ID: ${appId}, Phone: +91 ${user.phone}`}
            style={{padding:"14px",background:"#ECFDF5",border:"1px solid #6EE7B7",borderRadius:16,textDecoration:"none",textAlign:"center",display:"block"}}>
            <div style={{fontSize:24,marginBottom:4}}>💬</div>
            <div style={{fontWeight:700,color:"#065F46",fontSize:13}}>WhatsApp</div>
            <div style={{fontSize:10,color:"#9A9A9A",marginTop:2}}>Contact support</div>
          </a>
        </div>

        <button onClick={onLogout} className="tap"
          style={{width:"100%",padding:"14px",background:"#FEE2E2",border:"1px solid #FECACA",borderRadius:16,color:"#DC2626",fontWeight:800,fontSize:15,cursor:"pointer"}}>
          Sign Out
        </button>
      </div>

      {/* Re-upload modal */}
      {showReupload&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:999,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={()=>setShowReupload(false)}>
          <div style={{background:"white",borderRadius:"28px 28px 0 0",padding:"24px 20px 40px",width:"100%",maxWidth:430}} onClick={e=>e.stopPropagation()}>
            <div style={{width:40,height:4,background:"#E8E8E8",borderRadius:4,margin:"0 auto 20px"}}/>
            <div style={{fontWeight:900,color:"#0D0D0D",fontSize:18,marginBottom:4}}>Re-upload Documents</div>
            <div style={{color:"#9A9A9A",fontSize:13,marginBottom:20}}>Upload only the documents that were requested</div>
            {[["aadhaarFront","📄 Aadhaar Front"],["aadhaarBack","📄 Aadhaar Back"],["panPhoto","💳 PAN Card"],["selfie","🤳 New Selfie"]].map(([key,label])=>(
              <div key={key} style={{marginBottom:12}}>
                <div style={{fontWeight:600,color:"#545454",fontSize:12,marginBottom:6}}>{label}</div>
                <label style={{display:"block",cursor:"pointer"}}>
                  {newDoc[key]?(
                    <div style={{display:"flex",alignItems:"center",gap:10,background:"#ECFDF5",borderRadius:12,padding:"10px 14px",border:"1px solid #6EE7B7"}}>
                      <img src={newDoc[key]} alt={label} style={{width:40,height:40,borderRadius:8,objectFit:"cover"}}/>
                      <span style={{color:"#065F46",fontWeight:600,fontSize:12}}>✅ Ready to upload</span>
                    </div>
                  ):(
                    <div style={{background:"#F4F6FA",border:"2px dashed #E8E8E8",borderRadius:12,padding:"12px",textAlign:"center"}}>
                      <span style={{fontSize:11,color:"#9A9A9A"}}>Tap to upload {label}</span>
                    </div>
                  )}
                  <input type="file" accept="image/*" capture={key==="selfie"?"user":undefined} style={{display:"none"}}
                    onChange={e=>{const f=e.target.files[0];if(f){const r=new FileReader();r.onload=ev=>{const img=new Image();img.onload=()=>{const c=document.createElement("canvas");const m=500;let w=img.width,h=img.height;if(w>m){h=h*m/w;w=m;}c.width=w;c.height=h;c.getContext("2d").drawImage(img,0,0,w,h);setNewDoc(d=>({...d,[key]:c.toDataURL("image/jpeg",.7)}));};img.src=ev.target.result;};r.readAsDataURL(f);}}}/>
                </label>
              </div>
            ))}
            <button onClick={resubmitDocs} disabled={submitting} className="tap"
              style={{width:"100%",marginTop:8,padding:"15px",background:"linear-gradient(135deg,#065F46,#047857)",border:"none",borderRadius:16,color:"white",fontWeight:800,fontSize:15,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              {submitting?<Spinner/>:"📤 Submit for Review"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};


export default function GharPeApp() {
  const [user,setUser]       = useState(null);
  const [lang,setLang]       = useState(()=>localStorage.getItem("gp_lang")||"en");
  const [isLoading,setLoad]  = useState(true);

  // Check if this is the secret admin route
  const isAdminRoute = window.location.pathname === "/manage";

  // ── Persist user to localStorage ─────────────────────────────
  const saveUser = (u) => {
    if(u) {
      localStorage.setItem("gp_user", JSON.stringify(u));
      localStorage.setItem("gp_user_ts", Date.now().toString());
    } else {
      localStorage.removeItem("gp_user");
      localStorage.removeItem("gp_user_ts");
    }
    setUser(u);
  };

  // ── Restore session on app resume ────────────────────────────
  const restoreLocalSession = () => {
    try {
      const saved = localStorage.getItem("gp_user");
      const ts    = localStorage.getItem("gp_user_ts");
      if(saved && ts) {
        // Session valid for 7 days
        const age = Date.now() - parseInt(ts);
        if(age < 7 * 24 * 60 * 60 * 1000) {
          const u = JSON.parse(saved);
          if(u?.phone && u?.role) {
            setUser(u);
            return true;
          }
        }
      }
    } catch(e) {}
    return false;
  };

  useEffect(()=>{
    const id="gp-styles";
    if(!document.getElementById(id)){
      const el=document.createElement("style");
      el.id=id; el.textContent=STYLE;
      document.head.appendChild(el);
    }

    if(!isAdminRoute) {
      // First — instantly restore from localStorage (no flicker)
      const restored = restoreLocalSession();
      if(restored) setLoad(false);

      // Then — verify with Supabase in background
      const { data:{ subscription } } = supabase.auth.onAuthStateChange(
        async (event, session) => {
          if(event === "SIGNED_OUT") {
            saveUser(null);
            setLoad(false);
            return;
          }
          if(session?.user){
            const phone = (session.user.phone||"").replace("+91","").replace(/\D/g,"").slice(-10);
            try {
              const { data:pro } = await supabase.from("professionals")
                .select("*").eq("phone",phone).single().catch(()=>({data:null}));
              if(pro?.name){
                const u = {phone,name:pro.name,role:"expert",area:pro.city||pro.area||"Lucknow",verification_status:pro.verification_status||"pending"};
                saveUser(u);
                setLoad(false); return;
              }
              const { data:u } = await supabase.from("users")
                .select("*").eq("phone",phone).single().catch(()=>({data:null}));
              if(u?.name){ saveUser({...u,phone}); setLoad(false); return; }
            } catch(e){ console.error(e); }
          }
          // Only clear if we have no local session
          if(!restoreLocalSession()) {
            setUser(null);
          }
          setLoad(false);
        }
      );

      // Handle app coming back from background (visibilitychange)
      const handleVisibility = () => {
        if(document.visibilityState === "visible") {
          // Restore from localStorage instantly — no login flash
          restoreLocalSession();
        }
      };
      document.addEventListener("visibilitychange", handleVisibility);

      return () => {
        subscription.unsubscribe();
        document.removeEventListener("visibilitychange", handleVisibility);
      };
    } else {
      setLoad(false);
    }
  },[]);

  // Save lang preference
  useEffect(()=>{
    localStorage.setItem("gp_lang", lang);
  },[lang]);

  const logout = async () => {
    await supabase.auth.signOut();
    saveUser(null);
  };

  // ── ADMIN ROUTE — /manage ─────────────────────────────────────────────────
  if(isAdminRoute) {
    // Dynamically import AdminRoute to keep it out of main bundle
    const AdminRoute = require("./AdminRoute").default;
    return (
      <div style={{maxWidth:430,margin:"0 auto",minHeight:"100vh",fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
        <AdminRoute/>
      </div>
    );
  }

  // ── CUSTOMER / EXPERT APP ─────────────────────────────────────────────────
  if(isLoading) return(
    <div style={{maxWidth:430,margin:"0 auto",minHeight:"100vh",background:"white",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16}}>
      <div style={{fontSize:40}}>🏠</div>
      <div style={{width:32,height:32,border:"3px solid #E8E8E8",borderTopColor:"#0F2D5C",borderRadius:"50%",animation:"spin .7s linear infinite"}}/>
    </div>
  );

  return(
    <div style={{maxWidth:430,margin:"0 auto",minHeight:"100vh",background:"white",fontFamily:"'Plus Jakarta Sans',sans-serif"}}>
      {!user                   && <Login     onLogin={saveUser} lang={lang} setLang={setLang}/>}
      {user?.role==="customer"  && <CustomerApp user={user} lang={lang} setLang={setLang} onLogout={logout}/>}
      {user?.role==="expert"    && user?.verification_status==="approved" && <ExpertApp user={user} lang={lang} setLang={setLang} onLogout={logout}/>}
      {user?.role==="expert"    && user?.verification_status!=="approved" && <ExpertStatusDashboard user={user} onLogout={logout} onResubmit={u=>saveUser(u)}/>}
      {user?.role==="pro"       && <ExpertApp user={user} lang={lang} setLang={setLang} onLogout={logout}/>}
    </div>
  );
}